var Co = Object.defineProperty;
var Do = (e, t, r) => t in e ? Co(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var ze = (e, t, r) => (Do(e, typeof t != "symbol" ? t + "" : t, r), r);
import { jsx as W, jsxs as je, Fragment as ua } from "react/jsx-runtime";
import it, { createContext as Ge, useContext as Se, createElement as De, forwardRef as Zt, memo as To, useDebugValue as zr, useMemo as Ne, useEffect as J, useLayoutEffect as Ao, useRef as X, useState as ue, useCallback as L, useReducer as Vr, cloneElement as ko, Component as xo, Suspense as Ro } from "react";
import * as Io from "@tanstack/react-query";
import { useSuspenseQuery as $o, dehydrate as cn, QueryClientProvider as jo, HydrationBoundary as Lo } from "@tanstack/react-query";
import { I18nextProvider as Wo, useTranslation as Fo } from "react-i18next";
import "i18next";
import { createPortal as No } from "react-dom";
function Ho(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function fn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function w(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fn(Object(r), !0).forEach(function(n) {
      Ho(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function oe(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Bo(e, t) {
  if (e) {
    if (typeof e == "string")
      return mn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return mn(e, t);
  }
}
function mn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function st(e, t) {
  var r;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (r = Bo(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0;
      return function() {
        return n >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[n++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = e[Symbol.iterator](), r.next.bind(r);
}
var Kr = /* @__PURE__ */ Ge({});
function zo(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function vn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vn(Object(r), !0).forEach(function(n) {
      zo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Or(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Vo(e, t) {
  if (e) {
    if (typeof e == "string")
      return hn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return hn(e, t);
  }
}
function hn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function pn(e, t) {
  var r;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (r = Vo(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0;
      return function() {
        return n >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[n++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = e[Symbol.iterator](), r.next.bind(r);
}
function Ko(e) {
  return typeof e == "function";
}
var wt = function(t, r, n) {
  n === void 0 && (n = r.children);
  var a = Se(Kr);
  if (a.useCreateElement)
    return a.useCreateElement(t, r, n);
  if (typeof t == "string" && Ko(n)) {
    r.children;
    var o = Or(r, ["children"]);
    return n(o);
  }
  return /* @__PURE__ */ De(t, r, n);
};
function Uo(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function yn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yn(Object(r), !0).forEach(function(n) {
      Uo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qo(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Yo(e, t) {
  if (e) {
    if (typeof e == "string")
      return gn(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return gn(e, t);
  }
}
function gn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Xo(e, t) {
  var r;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (r = Yo(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0;
      return function() {
        return n >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[n++]
        };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = e[Symbol.iterator](), r.next.bind(r);
}
function Ur(e) {
  return typeof e == "object" && e != null;
}
function Cr(e) {
  var t;
  if (!Ur(e))
    return !1;
  var r = Object.getPrototypeOf(e);
  return r == null ? !0 : ((t = r.constructor) === null || t === void 0 ? void 0 : t.toString()) === Object.toString();
}
function bn(e, t) {
  for (var r = Object.keys(e), n = {}, a = {}, o = 0, u = r; o < u.length; o++) {
    var i = u[o];
    t.indexOf(i) >= 0 ? n[i] = e[i] : a[i] = e[i];
  }
  return [n, a];
}
function Mn(e, t) {
  if (t === void 0 && (t = []), !Cr(e.state))
    return bn(e, t);
  var r = bn(e, [].concat(t, ["state"])), n = r[0], a = r[1], o = n.state, u = qo(n, ["state"]);
  return [qe(qe({}, o), u), a];
}
function Rt(e, t) {
  if (e === t)
    return !0;
  if (!e || !t || typeof e != "object" || typeof t != "object")
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = r.length;
  if (n.length !== a)
    return !1;
  for (var o = 0, u = r; o < u.length; o++) {
    var i = u[o];
    if (e[i] !== t[i])
      return !1;
  }
  return !0;
}
function wn(e) {
  return e.name === "normalizePropsAreEqualInner" ? e : function(r, n) {
    return !Cr(r.state) || !Cr(n.state) ? e(r, n) : e(qe(qe({}, r.state), r), qe(qe({}, n.state), n));
  };
}
function Go(e) {
  return /* @__PURE__ */ Zt(e);
}
function Jo(e, t) {
  return /* @__PURE__ */ To(e, t);
}
function pe(e) {
  var t = e.as, r = e.useHook, n = e.memo, a = e.propsAreEqual, o = a === void 0 ? r == null ? void 0 : r.unstable_propsAreEqual : a, u = e.keys, i = u === void 0 ? (r == null ? void 0 : r.__keys) || [] : u, s = e.useCreateElement, l = s === void 0 ? wt : s, d = function(v, c) {
    var h = v.as, f = h === void 0 ? t : h, p = Or(v, ["as"]);
    if (r) {
      var y, M = Mn(p, i), b = M[0], g = M[1], E = r(b, vt({
        ref: c
      }, g)), P = E.wrapElement, _ = Or(E, ["wrapElement"]), D = ((y = f.render) === null || y === void 0 ? void 0 : y.__keys) || f.__keys, O = D && Mn(p, D)[0], S = O ? vt(vt({}, _), O) : _, x = l(f, S);
      return P ? P(x) : x;
    }
    return l(f, vt({
      ref: c
    }, p));
  };
  return process.env.NODE_ENV !== "production" && r && (d.displayName = r.name.replace(/^(unstable_)?use/, "")), d = Go(d), n && (d = Jo(d, o && wn(o))), d.__keys = i, d.unstable_propsAreEqual = wn(o || Rt), d;
}
function la(e, t) {
  zr(e);
  var r = Se(Kr);
  return r[e] != null ? r[e] : t;
}
function Qo(e, t, r) {
  t === void 0 && (t = {}), r === void 0 && (r = {});
  var n = "use" + e + "Props";
  zr(n);
  var a = la(n);
  return a ? a(t, r) : r;
}
function Zo(e, t, r) {
  t === void 0 && (t = {}), r === void 0 && (r = {});
  var n = "use" + e + "Options";
  zr(n);
  var a = la(n);
  return a ? vt(vt({}, t), a(t, r)) : t;
}
function ei(e) {
  return Array.isArray(e) ? e : typeof e < "u" ? [e] : [];
}
function ye(e) {
  var t, r, n = ei(e.compose), a = function(s, l) {
    if (e.useOptions && (s = e.useOptions(s, l)), e.name && (s = Zo(e.name, s, l)), e.compose)
      for (var d = pn(n), m; !(m = d()).done; ) {
        var v = m.value;
        s = v.__useOptions(s, l);
      }
    return s;
  }, o = function(s, l, d) {
    if (s === void 0 && (s = {}), l === void 0 && (l = {}), d === void 0 && (d = !1), d || (s = a(s, l)), e.useProps && (l = e.useProps(s, l)), e.name && (l = Qo(e.name, s, l)), e.compose)
      if (e.useComposeOptions && (s = e.useComposeOptions(s, l)), e.useComposeProps)
        l = e.useComposeProps(s, l);
      else
        for (var m = pn(n), v; !(v = m()).done; ) {
          var c = v.value;
          l = c(s, l, !0);
        }
    var h = {}, f = l || {};
    for (var p in f)
      f[p] !== void 0 && (h[p] = f[p]);
    return h;
  };
  o.__useOptions = a;
  var u = n.reduce(function(i, s) {
    return i.push.apply(i, s.__keys || []), i;
  }, []);
  return o.__keys = [].concat(u, ((t = e.useState) === null || t === void 0 ? void 0 : t.__keys) || [], e.keys || []), o.unstable_propsAreEqual = e.propsAreEqual || ((r = n[0]) === null || r === void 0 ? void 0 : r.unstable_propsAreEqual) || Rt, process.env.NODE_ENV !== "production" && e.name && Object.defineProperty(o, "name", {
    value: "use" + e.name
  }), o;
}
function En(e, t) {
  t === void 0 && (t = null), e && (typeof e == "function" ? e(t) : e.current = t);
}
function He(e, t) {
  return Ne(function() {
    return e == null && t == null ? null : function(r) {
      En(e, r), En(t, r);
    };
  }, [e, t]);
}
var ti = ["button", "color", "file", "image", "reset", "submit"];
function ir(e) {
  if (e.tagName === "BUTTON")
    return !0;
  if (e.tagName === "INPUT") {
    var t = e;
    return ti.indexOf(t.type) !== -1;
  }
  return !1;
}
function da(e) {
  for (var t = [], r = Xo(e), n; !(n = r()).done; ) {
    var a = n.value;
    Array.isArray(a) ? t.push.apply(t, da(a)) : t.push(a);
  }
  return t;
}
function Oe(e) {
  if (process.env.NODE_ENV !== "production") {
    var t;
    if (!e)
      return;
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      n[a - 1] = arguments[a];
    var o = da(n.map(function(u) {
      return [u, `
`];
    }));
    (t = console).warn.apply(t, o.slice(0, -1));
    try {
      throw Error(o.join(""));
    } catch {
    }
  }
}
function ri(e) {
  return Ur(e) && "current" in e;
}
function Wt(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  process.env.NODE_ENV !== "production" && J(function() {
    process.env.NODE_ENV !== "production" && Oe.apply(void 0, [e].concat(r.map(function(a) {
      return ri(a) ? a.current : a;
    })));
  }, [e]);
}
function ge(e) {
  return e ? e.ownerDocument || e : document;
}
var Dr;
try {
  Dr = window;
} catch {
}
function ca(e) {
  return e && ge(e).defaultView || Dr;
}
function ni() {
  var e = ca();
  return !!(typeof e < "u" && e.document && e.document.createElement);
}
var Et = ni(), Je = Et ? Ao : J;
function ee(e) {
  var t = X(e);
  return Je(function() {
    t.current = e;
  }), t;
}
function $e(e) {
  return e.target === e.currentTarget;
}
function St(e) {
  var t = ge(e), r = t.activeElement;
  return r != null && r.nodeName ? r : null;
}
function Le(e, t) {
  return e === t || e.contains(t);
}
function Ft(e) {
  var t = St(e);
  if (!t)
    return !1;
  if (Le(e, t))
    return !0;
  var r = t.getAttribute("aria-activedescendant");
  return r ? r === e.id ? !0 : !!e.querySelector("#" + r) : !1;
}
function qr(e) {
  return !Le(e.currentTarget, e.target);
}
function et(e) {
  return Et ? window.navigator.userAgent.indexOf(e) !== -1 : !1;
}
function fa(e, t) {
  return "matches" in e ? e.matches(t) : "msMatchesSelector" in e ? e.msMatchesSelector(t) : e.webkitMatchesSelector(t);
}
function ma(e, t) {
  if ("closest" in e)
    return e.closest(t);
  do {
    if (fa(e, t))
      return e;
    e = e.parentElement || e.parentNode;
  } while (e !== null && e.nodeType === 1);
  return null;
}
var va = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function ai(e) {
  var t = e;
  return t.offsetWidth > 0 || t.offsetHeight > 0 || e.getClientRects().length > 0;
}
function oi(e) {
  var t = parseInt(e.getAttribute("tabindex") || "0", 10);
  return t < 0;
}
function ha(e) {
  return fa(e, va) && ai(e);
}
function Tr(e) {
  return ha(e) && !oi(e);
}
function pa(e, t) {
  var r = Array.from(e.querySelectorAll(va)), n = r.filter(Tr);
  return Tr(e) && n.unshift(e), !n.length && t ? r : n;
}
function ya(e, t) {
  var r = pa(e, t), n = r[0];
  return n || null;
}
function ii(e, t) {
  var r = pa(e, t);
  return r[r.length - 1] || null;
}
var si = ["unstable_system"], sr = ye({
  name: "Role",
  keys: si,
  propsAreEqual: function(t, r) {
    var n = t.unstable_system, a = oe(t, ["unstable_system"]), o = r.unstable_system, u = oe(r, ["unstable_system"]);
    return n !== o && !Rt(n, o) ? !1 : Rt(a, u);
  }
});
pe({
  as: "div",
  useHook: sr
});
var ui = ["disabled", "focusable"], li = et("Mac") && !et("Chrome") && (et("Safari") || et("Firefox"));
function Sn(e) {
  !Ft(e) && ha(e) && e.focus();
}
function di(e) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"].includes(e.tagName);
}
function ci(e) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA"].includes(e.tagName);
}
function fi(e, t, r, n) {
  return e ? t && !r ? -1 : void 0 : t ? n : n || 0;
}
function fr(e, t) {
  return L(function(r) {
    var n;
    (n = e.current) === null || n === void 0 || n.call(e, r), !r.defaultPrevented && t && (r.stopPropagation(), r.preventDefault());
  }, [e, t]);
}
var er = ye({
  name: "Tabbable",
  compose: sr,
  keys: ui,
  useOptions: function(t, r) {
    var n = r.disabled;
    return w({
      disabled: n
    }, t);
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.tabIndex, o = r.onClickCapture, u = r.onMouseDownCapture, i = r.onMouseDown, s = r.onKeyPressCapture, l = r.style, d = oe(r, ["ref", "tabIndex", "onClickCapture", "onMouseDownCapture", "onMouseDown", "onKeyPressCapture", "style"]), m = X(null), v = ee(o), c = ee(u), h = ee(i), f = ee(s), p = !!t.disabled && !t.focusable, y = ue(!0), M = y[0], b = y[1], g = ue(!0), E = g[0], P = g[1], _ = t.disabled ? w({
      pointerEvents: "none"
    }, l) : l;
    Je(function() {
      var C = m.current;
      if (!C) {
        process.env.NODE_ENV !== "production" && Oe(!0, "Can't determine if the element is a native tabbable element because `ref` wasn't passed to the component.", "See https://reakit.io/docs/tabbable");
        return;
      }
      di(C) || b(!1), ci(C) || P(!1);
    }, []);
    var D = fr(v, t.disabled), O = fr(c, t.disabled), S = fr(f, t.disabled), x = L(function(C) {
      var T;
      (T = h.current) === null || T === void 0 || T.call(h, C);
      var j = C.currentTarget;
      if (!C.defaultPrevented && li && !qr(C) && ir(j)) {
        var A = requestAnimationFrame(function() {
          j.removeEventListener("mouseup", $, !0), Sn(j);
        }), $ = function() {
          cancelAnimationFrame(A), Sn(j);
        };
        j.addEventListener("mouseup", $, {
          once: !0,
          capture: !0
        });
      }
    }, []);
    return w({
      ref: He(m, n),
      style: _,
      tabIndex: fi(p, M, E, a),
      disabled: p && E ? !0 : void 0,
      "aria-disabled": t.disabled ? !0 : void 0,
      onClickCapture: D,
      onMouseDownCapture: O,
      onMouseDown: x,
      onKeyPressCapture: S
    }, d);
  }
});
pe({
  as: "div",
  useHook: er
});
var mi = ["unstable_clickOnEnter", "unstable_clickOnSpace"];
function vi(e) {
  var t = e.currentTarget;
  return e.isTrusted ? ir(t) || t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "A" || t.tagName === "SELECT" : !1;
}
var Dt = ye({
  name: "Clickable",
  compose: er,
  keys: mi,
  useOptions: function(t) {
    var r = t.unstable_clickOnEnter, n = r === void 0 ? !0 : r, a = t.unstable_clickOnSpace, o = a === void 0 ? !0 : a, u = oe(t, ["unstable_clickOnEnter", "unstable_clickOnSpace"]);
    return w({
      unstable_clickOnEnter: n,
      unstable_clickOnSpace: o
    }, u);
  },
  useProps: function(t, r) {
    var n = r.onKeyDown, a = r.onKeyUp, o = oe(r, ["onKeyDown", "onKeyUp"]), u = ue(!1), i = u[0], s = u[1], l = ee(n), d = ee(a), m = L(function(c) {
      var h;
      if ((h = l.current) === null || h === void 0 || h.call(l, c), !c.defaultPrevented && !t.disabled && !c.metaKey && $e(c)) {
        var f = t.unstable_clickOnEnter && c.key === "Enter", p = t.unstable_clickOnSpace && c.key === " ";
        if (f || p) {
          if (vi(c))
            return;
          c.preventDefault(), f ? c.currentTarget.click() : p && s(!0);
        }
      }
    }, [t.disabled, t.unstable_clickOnEnter, t.unstable_clickOnSpace]), v = L(function(c) {
      var h;
      if ((h = d.current) === null || h === void 0 || h.call(d, c), !c.defaultPrevented && !t.disabled && !c.metaKey) {
        var f = t.unstable_clickOnSpace && c.key === " ";
        i && f && (s(!1), c.currentTarget.click());
      }
    }, [t.disabled, t.unstable_clickOnSpace, i]);
    return w({
      "data-active": i || void 0,
      onKeyDown: m,
      onKeyUp: v
    }, o);
  }
});
pe({
  as: "button",
  memo: !0,
  useHook: Dt
});
var hi = [], ga = ye({
  name: "Button",
  compose: Dt,
  keys: hi,
  useProps: function(t, r) {
    var n = r.ref, a = oe(r, ["ref"]), o = X(null), u = ue(void 0), i = u[0], s = u[1], l = ue("button"), d = l[0], m = l[1];
    return J(function() {
      var v = o.current;
      if (!v) {
        process.env.NODE_ENV !== "production" && Oe(!0, "Can't determine whether the element is a native button because `ref` wasn't passed to the component", "See https://reakit.io/docs/button");
        return;
      }
      ir(v) || (v.tagName !== "A" && s("button"), m(void 0));
    }, []), w({
      ref: He(o, n),
      role: i,
      type: d
    }, a);
  }
}), pi = pe({
  as: "button",
  memo: !0,
  useHook: ga
});
function yi(e, t) {
  return t === -1 ? e : [].concat(e.slice(0, t), e.slice(t + 1));
}
function ba(e, t, r) {
  if (typeof Event == "function")
    return new Event(t, r);
  var n = ge(e).createEvent("Event");
  return n.initEvent(t, r == null ? void 0 : r.bubbles, r == null ? void 0 : r.cancelable), n;
}
function ut(e) {
  var t = ue(e), r = t[0];
  return r;
}
function Ma(e, t) {
  var r = X(!1);
  J(function() {
    if (r.current)
      return e();
    r.current = !0;
  }, t);
}
function Pn(e, t, r) {
  return r === void 0 && (r = {}), typeof FocusEvent == "function" ? new FocusEvent(t, r) : ba(e, t, r);
}
function mr(e, t) {
  var r = Pn(e, "blur", t), n = e.dispatchEvent(r), a = qe(qe({}, t), {}, {
    bubbles: !0
  });
  return e.dispatchEvent(Pn(e, "focusout", a)), n;
}
function gi(e, t, r) {
  if (r === void 0 && (r = {}), typeof KeyboardEvent == "function")
    return new KeyboardEvent(t, r);
  var n = ge(e).createEvent("KeyboardEvent");
  return n.initKeyboardEvent(t, r.bubbles, r.cancelable, ca(e), r.key, r.location, r.ctrlKey, r.altKey, r.shiftKey, r.metaKey), n;
}
function bi(e, t, r) {
  return e.dispatchEvent(gi(e, t, r));
}
var Mi = Et && "msCrypto" in window;
function wa(e) {
  if (Mi) {
    var t = St(e.currentTarget);
    return t;
  }
  return e.relatedTarget;
}
function tr(e) {
  for (var t = [[]], r = function() {
    var u = a.value, i = t.find(function(s) {
      return !s[0] || s[0].groupId === u.groupId;
    });
    i ? i.push(u) : t.push([u]);
  }, n = st(e), a; !(a = n()).done; )
    r();
  return t;
}
function Ar(e) {
  for (var t = [], r = st(e), n; !(n = r()).done; ) {
    var a = n.value;
    t.push.apply(t, a);
  }
  return t;
}
function mt(e) {
  return e.slice().reverse();
}
function Ve(e, t) {
  return t ? e.find(function(r) {
    return !r.disabled && r.id !== t;
  }) : e.find(function(r) {
    return !r.disabled;
  });
}
function Ze(e, t) {
  var r;
  return t || t === null ? t : e.currentId || e.currentId === null ? e.currentId : (r = Ve(e.items || [])) === null || r === void 0 ? void 0 : r.id;
}
function Ea(e, t) {
  if (t)
    return e == null ? void 0 : e.find(function(r) {
      return r.id === t && !r.disabled;
    });
}
var wi = ["baseId", "unstable_idCountRef", "setBaseId", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget"], Sa = wi, Ei = Sa, Si = Ei;
function Pa(e) {
  e.userFocus = !0, e.focus(), e.userFocus = !1;
}
function Pi(e) {
  return !!e.userFocus;
}
function _n(e, t) {
  e.userFocus = t;
}
var _i = Et && "msCrypto" in window;
function Oi(e) {
  return !(!$e(e) || e.metaKey || e.key === "Tab");
}
function On(e, t, r) {
  var n = ee(r);
  return L(function(a) {
    var o;
    if ((o = n.current) === null || o === void 0 || o.call(n, a), !a.defaultPrevented && e && Oi(a)) {
      var u = t == null ? void 0 : t.ref.current;
      u && (bi(u, a.type, a) || a.preventDefault(), a.currentTarget.contains(u) && a.stopPropagation());
    }
  }, [e, t]);
}
function Ci(e) {
  var t = X(null);
  return J(function() {
    var r = ge(e.current), n = function(o) {
      var u = o.target;
      t.current = u;
    };
    return r.addEventListener("focus", n, !0), function() {
      r.removeEventListener("focus", n, !0);
    };
  }, []), t;
}
function Di(e) {
  return Ve(Ar(mt(tr(e))));
}
function vr(e, t) {
  return e == null ? void 0 : e.some(function(r) {
    return !!t && r.ref.current === t;
  });
}
function Ti(e) {
  var t = ee(e), r = Vr(function(o) {
    return o + 1;
  }, 0), n = r[0], a = r[1];
  return J(function() {
    var o, u = (o = t.current) === null || o === void 0 ? void 0 : o.ref.current;
    n && u && Pa(u);
  }, [n]), a;
}
var _a = ye({
  name: "Composite",
  compose: [er],
  keys: Sa,
  useOptions: function(t) {
    return w(w({}, t), {}, {
      currentId: Ze(t)
    });
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.onFocusCapture, o = r.onFocus, u = r.onBlurCapture, i = r.onKeyDown, s = r.onKeyDownCapture, l = r.onKeyUpCapture, d = oe(r, ["ref", "onFocusCapture", "onFocus", "onBlurCapture", "onKeyDown", "onKeyDownCapture", "onKeyUpCapture"]), m = X(null), v = Ea(t.items, t.currentId), c = X(null), h = ee(a), f = ee(o), p = ee(u), y = ee(i), M = Ti(v), b = _i ? Ci(m) : void 0;
    J(function() {
      var S = m.current;
      t.unstable_moves && !v && (process.env.NODE_ENV !== "production" && Oe(!S, "Can't focus composite component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite"), S == null || S.focus());
    }, [t.unstable_moves, v]);
    var g = On(t.unstable_virtual, v, s), E = On(t.unstable_virtual, v, l), P = L(function(S) {
      var x;
      if ((x = h.current) === null || x === void 0 || x.call(h, S), !S.defaultPrevented && t.unstable_virtual) {
        var C = (b == null ? void 0 : b.current) || S.relatedTarget, T = vr(t.items, C);
        $e(S) && T && (S.stopPropagation(), c.current = C);
      }
    }, [t.unstable_virtual, t.items]), _ = L(function(S) {
      var x;
      if ((x = f.current) === null || x === void 0 || x.call(f, S), !S.defaultPrevented) {
        if (t.unstable_virtual)
          $e(S) && M();
        else if ($e(S)) {
          var C;
          (C = t.setCurrentId) === null || C === void 0 || C.call(t, null);
        }
      }
    }, [t.unstable_virtual, t.setCurrentId]), D = L(function(S) {
      var x;
      if ((x = p.current) === null || x === void 0 || x.call(p, S), !S.defaultPrevented && t.unstable_virtual) {
        var C = (v == null ? void 0 : v.ref.current) || null, T = wa(S), j = vr(t.items, T);
        if ($e(S) && j)
          T === C ? c.current && c.current !== T && mr(c.current, S) : C && mr(C, S), S.stopPropagation();
        else {
          var A = vr(t.items, S.target);
          !A && C && mr(C, S);
        }
      }
    }, [t.unstable_virtual, t.items, v]), O = L(function(S) {
      var x, C;
      if ((x = y.current) === null || x === void 0 || x.call(y, S), !S.defaultPrevented && t.currentId === null && $e(S)) {
        var T = t.orientation !== "horizontal", j = t.orientation !== "vertical", A = !!((C = t.groups) !== null && C !== void 0 && C.length), $ = function() {
          if (A) {
            var ce = Di(t.items);
            if (ce != null && ce.id) {
              var ie;
              (ie = t.move) === null || ie === void 0 || ie.call(t, ce.id);
            }
          } else {
            var se;
            (se = t.last) === null || se === void 0 || se.call(t);
          }
        }, Q = {
          ArrowUp: (A || T) && $,
          ArrowRight: (A || j) && t.first,
          ArrowDown: (A || T) && t.first,
          ArrowLeft: (A || j) && t.last,
          Home: t.first,
          End: t.last,
          PageUp: t.first,
          PageDown: t.last
        }, te = Q[S.key];
        te && (S.preventDefault(), te());
      }
    }, [t.currentId, t.orientation, t.groups, t.items, t.move, t.last, t.first]);
    return w({
      ref: He(m, n),
      id: t.baseId,
      onFocus: _,
      onFocusCapture: P,
      onBlurCapture: D,
      onKeyDownCapture: g,
      onKeyDown: O,
      onKeyUpCapture: E,
      "aria-activedescendant": t.unstable_virtual && (v == null ? void 0 : v.id) || void 0
    }, d);
  },
  useComposeProps: function(t, r) {
    r = sr(t, r, !0);
    var n = er(t, r, !0);
    return t.unstable_virtual || t.currentId === null ? w({
      tabIndex: 0
    }, n) : w(w({}, r), {}, {
      ref: n.ref
    });
  }
});
pe({
  as: "div",
  useHook: _a,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Wt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/composite"), wt(t, r, n);
  }
});
function Cn(e) {
  try {
    var t = e instanceof HTMLInputElement && e.selectionStart !== null, r = e.tagName === "TEXTAREA", n = e.contentEditable === "true";
    return t || r || n || !1;
  } catch {
    return !1;
  }
}
function Ai(e) {
  var t = St(e);
  if (!t)
    return !1;
  if (t === e)
    return !0;
  var r = t.getAttribute("aria-activedescendant");
  return r ? r === e.id : !1;
}
function It(e, t) {
  var r = t === void 0 ? {} : t, n = r.preventScroll, a = r.isActive, o = a === void 0 ? Ai : a;
  return o(e) || (e.focus({
    preventScroll: n
  }), o(e)) ? -1 : requestAnimationFrame(function() {
    e.focus({
      preventScroll: n
    });
  });
}
var Oa = "id";
function ki(e) {
  return e === void 0 && (e = Oa), (e ? e + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var Yr = /* @__PURE__ */ Ge(ki);
function xi(e) {
  var t = e.children, r = e.prefix, n = r === void 0 ? Oa : r, a = X(0), o = L(function(u) {
    return u === void 0 && (u = n), (u ? u + "-" : "") + ++a.current;
  }, [n]);
  return /* @__PURE__ */ De(Yr.Provider, {
    value: o
  }, t);
}
var Ri = ["baseId", "unstable_idCountRef", "setBaseId"], Ii = [].concat(Ri, ["id"]), Ca = ye({
  keys: Ii,
  useOptions: function(t, r) {
    var n = Se(Yr), a = ue(function() {
      return t.unstable_idCountRef ? (t.unstable_idCountRef.current += 1, "-" + t.unstable_idCountRef.current) : t.baseId ? "-" + n("") : "";
    }), o = a[0], u = Ne(function() {
      return t.baseId || n();
    }, [t.baseId, n]), i = r.id || t.id || "" + u + o;
    return w(w({}, t), {}, {
      id: i
    });
  },
  useProps: function(t, r) {
    return w({
      id: t.id
    }, r);
  }
});
pe({
  as: "div",
  useHook: Ca
});
function $i(e, t, r) {
  return e.dispatchEvent(ba(e, t, r));
}
function Dn(e, t) {
  if (e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement) {
    var r, n = Object.getPrototypeOf(e), a = (r = Object.getOwnPropertyDescriptor(n, "value")) === null || r === void 0 ? void 0 : r.set;
    a && (a.call(e, t), $i(e, "input", {
      bubbles: !0
    }));
  }
}
function hr(e) {
  return e.querySelector("[data-composite-item-widget]");
}
function ji(e) {
  return Ne(function() {
    var t;
    return (t = e.items) === null || t === void 0 ? void 0 : t.find(function(r) {
      return e.id && r.id === e.id;
    });
  }, [e.items, e.id]);
}
function Li(e, t) {
  if ($e(e))
    return !1;
  for (var r = st(t), n; !(n = r()).done; ) {
    var a = n.value;
    if (a.ref.current === e.target)
      return !0;
  }
  return !1;
}
var kr = ye({
  name: "CompositeItem",
  compose: [Dt, Ca],
  keys: Si,
  propsAreEqual: function(t, r) {
    if (!r.id || t.id !== r.id)
      return Dt.unstable_propsAreEqual(t, r);
    var n = t.currentId, a = t.unstable_moves, o = oe(t, ["currentId", "unstable_moves"]), u = r.currentId, i = r.unstable_moves, s = oe(r, ["currentId", "unstable_moves"]);
    if (u !== n) {
      if (r.id === u || r.id === n)
        return !1;
    } else if (a !== i)
      return !1;
    return Dt.unstable_propsAreEqual(o, s);
  },
  useOptions: function(t) {
    return w(w({}, t), {}, {
      id: t.id,
      currentId: Ze(t),
      unstable_clickOnSpace: t.unstable_hasActiveWidget ? !1 : t.unstable_clickOnSpace
    });
  },
  useProps: function(t, r) {
    var n, a = r.ref, o = r.tabIndex, u = o === void 0 ? 0 : o, i = r.onMouseDown, s = r.onFocus, l = r.onBlurCapture, d = r.onKeyDown, m = r.onClick, v = oe(r, ["ref", "tabIndex", "onMouseDown", "onFocus", "onBlurCapture", "onKeyDown", "onClick"]), c = X(null), h = t.id, f = t.disabled && !t.focusable, p = t.currentId === h, y = ee(p), M = X(!1), b = ji(t), g = ee(i), E = ee(s), P = ee(l), _ = ee(d), D = ee(m), O = !t.unstable_virtual && !t.unstable_hasActiveWidget && p || // We don't want to set tabIndex="-1" when using CompositeItem as a
    // standalone component, without state props.
    !((n = t.items) !== null && n !== void 0 && n.length);
    J(function() {
      var A;
      if (h)
        return (A = t.registerItem) === null || A === void 0 || A.call(t, {
          id: h,
          ref: c,
          disabled: !!f
        }), function() {
          var $;
          ($ = t.unregisterItem) === null || $ === void 0 || $.call(t, h);
        };
    }, [h, f, t.registerItem, t.unregisterItem]), J(function() {
      var A = c.current;
      if (!A) {
        process.env.NODE_ENV !== "production" && Oe(!0, "Can't focus composite item component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite");
        return;
      }
      t.unstable_moves && y.current && Pa(A);
    }, [t.unstable_moves]);
    var S = L(function(A) {
      var $;
      ($ = g.current) === null || $ === void 0 || $.call(g, A), _n(A.currentTarget, !0);
    }, []), x = L(function(A) {
      var $, Q, te = Pi(A.currentTarget);
      if (_n(A.currentTarget, !1), ($ = E.current) === null || $ === void 0 || $.call(E, A), !A.defaultPrevented && !qr(A) && h && !Li(A, t.items) && ((Q = t.setCurrentId) === null || Q === void 0 || Q.call(t, h), te && t.unstable_virtual && t.baseId && $e(A))) {
        var re = A.target, ce = ge(re).getElementById(t.baseId);
        ce && (M.current = !0, It(ce));
      }
    }, [h, t.items, t.setCurrentId, t.unstable_virtual, t.baseId]), C = L(function(A) {
      var $;
      ($ = P.current) === null || $ === void 0 || $.call(P, A), !A.defaultPrevented && t.unstable_virtual && M.current && (M.current = !1, A.preventDefault(), A.stopPropagation());
    }, [t.unstable_virtual]), T = L(function(A) {
      var $;
      if ($e(A)) {
        var Q = t.orientation !== "horizontal", te = t.orientation !== "vertical", re = !!(b != null && b.groupId), ce = {
          ArrowUp: (re || Q) && t.up,
          ArrowRight: (re || te) && t.next,
          ArrowDown: (re || Q) && t.down,
          ArrowLeft: (re || te) && t.previous,
          Home: function() {
            if (!re || A.ctrlKey) {
              var ne;
              (ne = t.first) === null || ne === void 0 || ne.call(t);
            } else {
              var Z;
              (Z = t.previous) === null || Z === void 0 || Z.call(t, !0);
            }
          },
          End: function() {
            if (!re || A.ctrlKey) {
              var ne;
              (ne = t.last) === null || ne === void 0 || ne.call(t);
            } else {
              var Z;
              (Z = t.next) === null || Z === void 0 || Z.call(t, !0);
            }
          },
          PageUp: function() {
            if (re) {
              var ne;
              (ne = t.up) === null || ne === void 0 || ne.call(t, !0);
            } else {
              var Z;
              (Z = t.first) === null || Z === void 0 || Z.call(t);
            }
          },
          PageDown: function() {
            if (re) {
              var ne;
              (ne = t.down) === null || ne === void 0 || ne.call(t, !0);
            } else {
              var Z;
              (Z = t.last) === null || Z === void 0 || Z.call(t);
            }
          }
        }, ie = ce[A.key];
        if (ie) {
          A.preventDefault(), ie();
          return;
        }
        if (($ = _.current) === null || $ === void 0 || $.call(_, A), !A.defaultPrevented) {
          if (A.key.length === 1 && A.key !== " ") {
            var se = hr(A.currentTarget);
            se && Cn(se) && (se.focus(), Dn(se, ""));
          } else if (A.key === "Delete" || A.key === "Backspace") {
            var be = hr(A.currentTarget);
            be && Cn(be) && (A.preventDefault(), Dn(be, ""));
          }
        }
      }
    }, [t.orientation, b, t.up, t.next, t.down, t.previous, t.first, t.last]), j = L(function(A) {
      var $;
      if (($ = D.current) === null || $ === void 0 || $.call(D, A), !A.defaultPrevented) {
        var Q = A.currentTarget, te = hr(Q);
        te && !Ft(te) && te.focus();
      }
    }, []);
    return w({
      ref: He(c, a),
      id: h,
      tabIndex: O ? u : -1,
      "aria-selected": t.unstable_virtual && p ? !0 : void 0,
      onMouseDown: S,
      onFocus: x,
      onBlurCapture: C,
      onKeyDown: T,
      onClick: j
    }, v);
  }
});
pe({
  as: "button",
  memo: !0,
  useHook: kr
});
function Wi(e) {
  return typeof e == "function";
}
function Ue(e, t) {
  return Wi(e) ? e(t) : e;
}
function Da(e) {
  e === void 0 && (e = {});
  var t = ut(e), r = t.baseId, n = Se(Yr), a = X(0), o = ue(function() {
    return r || n();
  }), u = o[0], i = o[1];
  return {
    baseId: u,
    setBaseId: i,
    unstable_idCountRef: a
  };
}
function Ta(e, t) {
  return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
function Tn(e, t) {
  return e.findIndex(function(r) {
    return !r.ref.current || !t.ref.current ? !1 : Ta(t.ref.current, r.ref.current);
  });
}
function Aa(e) {
  for (var t = 0, r = st(e), n; !(n = r()).done; ) {
    var a = n.value.length;
    a > t && (t = a);
  }
  return t;
}
function An(e) {
  for (var t = tr(e), r = Aa(t), n = [], a = 0; a < r; a += 1)
    for (var o = st(t), u; !(u = o()).done; ) {
      var i = u.value;
      i[a] && n.push(w(w({}, i[a]), {}, {
        // If there's no groupId, it means that it's not a grid composite,
        // but a single row instead. So, instead of verticalizing it, that
        // is, assigning a different groupId based on the column index, we
        // keep it undefined so they will be part of the same group.
        // It's useful when using up/down on one-dimensional composites.
        groupId: i[a].groupId ? "" + a : void 0
      }));
    }
  return n;
}
function Fi(e) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    ref: {
      current: null
    },
    groupId: e
  };
}
function kn(e, t, r) {
  for (var n = Aa(e), a = st(e), o; !(o = a()).done; )
    for (var u = o.value, i = 0; i < n; i += 1) {
      var s = u[i];
      if (!s || r && s.disabled) {
        var l = i === 0, d = l && r ? Ve(u) : u[i - 1];
        u[i] = d && t !== (d == null ? void 0 : d.id) && r ? d : Fi(d == null ? void 0 : d.groupId);
      }
    }
  return e;
}
var Ni = {
  id: null,
  ref: {
    current: null
  }
};
function Hi(e, t, r) {
  var n = e.findIndex(function(a) {
    return a.id === t;
  });
  return [].concat(e.slice(n + 1), r ? [Ni] : [], e.slice(0, n));
}
function pr(e, t) {
  return e.filter(function(r) {
    return r.groupId === t;
  });
}
var Bi = {
  horizontal: "vertical",
  vertical: "horizontal"
};
function zi(e) {
  return e && Bi[e];
}
function xn(e, t, r) {
  return r in e ? [].concat(e.slice(0, r), [t], e.slice(r)) : [].concat(e, [t]);
}
function xr(e) {
  var t = e.map(function(n, a) {
    return [a, n];
  }), r = !1;
  return t.sort(function(n, a) {
    var o = n[0], u = n[1], i = a[0], s = a[1], l = u.ref.current, d = s.ref.current;
    return !l || !d ? 0 : Ta(l, d) ? (o > i && (r = !0), -1) : (o < i && (r = !0), 1);
  }), r ? t.map(function(n) {
    n[0];
    var a = n[1];
    return a;
  }) : e;
}
function ka(e, t) {
  var r = xr(e);
  e !== r && t(r);
}
function Vi(e) {
  for (var t, r = e[0], n = e.slice(1), a = r == null || (t = r.ref.current) === null || t === void 0 ? void 0 : t.parentElement, o = function() {
    var s = a;
    if (n.every(function(l) {
      return s.contains(l.ref.current);
    }))
      return {
        v: a
      };
    a = a.parentElement;
  }; a; ) {
    var u = o();
    if (typeof u == "object")
      return u.v;
  }
  return ge(a).body;
}
function Ki(e, t) {
  var r = X([]);
  J(function() {
    for (var n = function() {
      var d = !!r.current.length;
      d && ka(e, t), r.current = e;
    }, a = Vi(e), o = new IntersectionObserver(n, {
      root: a
    }), u = st(e), i; !(i = u()).done; ) {
      var s = i.value;
      s.ref.current && o.observe(s.ref.current);
    }
    return function() {
      o.disconnect();
    };
  }, [e]);
}
function Ui(e, t) {
  J(function() {
    var r = function() {
      return ka(e, t);
    }, n = setTimeout(r, 250);
    return function() {
      return clearTimeout(n);
    };
  });
}
function qi(e, t) {
  typeof IntersectionObserver == "function" ? Ki(e, t) : Ui(e, t);
}
function Ce(e, t) {
  var r = e.unstable_virtual, n = e.rtl, a = e.orientation, o = e.items, u = e.groups, i = e.currentId, s = e.loop, l = e.wrap, d = e.pastIds, m = e.shift, v = e.unstable_moves, c = e.unstable_includesBaseElement, h = e.initialVirtual, f = e.initialRTL, p = e.initialOrientation, y = e.initialCurrentId, M = e.initialLoop, b = e.initialWrap, g = e.initialShift, E = e.hasSetCurrentId;
  switch (t.type) {
    case "registerGroup": {
      var P = t.group;
      if (u.length === 0)
        return w(w({}, e), {}, {
          groups: [P]
        });
      var _ = Tn(u, P);
      return w(w({}, e), {}, {
        groups: xn(u, P, _)
      });
    }
    case "unregisterGroup": {
      var D = t.id, O = u.filter(function(Ae) {
        return Ae.id !== D;
      });
      return O.length === u.length ? e : w(w({}, e), {}, {
        groups: O
      });
    }
    case "registerItem": {
      var S = t.item, x = u.find(function(Ae) {
        var cr;
        return (cr = Ae.ref.current) === null || cr === void 0 ? void 0 : cr.contains(S.ref.current);
      }), C = w({
        groupId: x == null ? void 0 : x.id
      }, S), T = Tn(o, C), j = w(w({}, e), {}, {
        items: xn(o, C, T)
      });
      if (!E && !v && y === void 0) {
        var A;
        return w(w({}, j), {}, {
          currentId: (A = Ve(j.items)) === null || A === void 0 ? void 0 : A.id
        });
      }
      return j;
    }
    case "unregisterItem": {
      var $ = t.id, Q = o.filter(function(Ae) {
        return Ae.id !== $;
      });
      if (Q.length === o.length)
        return e;
      var te = d.filter(function(Ae) {
        return Ae !== $;
      }), re = w(w({}, e), {}, {
        pastIds: te,
        items: Q
      });
      if (i && i === $) {
        var ce = c ? null : Ze(w(w({}, re), {}, {
          currentId: te[0]
        }));
        return w(w({}, re), {}, {
          currentId: ce
        });
      }
      return re;
    }
    case "move": {
      var ie = t.id;
      if (ie === void 0)
        return e;
      var se = d.filter(function(Ae) {
        return Ae !== i && Ae !== ie;
      }), be = i ? [i].concat(se) : se, fe = w(w({}, e), {}, {
        pastIds: be
      });
      if (ie === null)
        return w(w({}, fe), {}, {
          unstable_moves: v + 1,
          currentId: Ze(fe, ie)
        });
      var ne = Ea(o, ie);
      return w(w({}, fe), {}, {
        unstable_moves: ne ? v + 1 : v,
        currentId: Ze(fe, ne == null ? void 0 : ne.id)
      });
    }
    case "next": {
      if (i == null)
        return Ce(e, w(w({}, t), {}, {
          type: "first"
        }));
      var Z = a !== "vertical", Me = n && Z, he = Me ? mt(o) : o, Ee = he.find(function(Ae) {
        return Ae.id === i;
      });
      if (!Ee)
        return Ce(e, w(w({}, t), {}, {
          type: "first"
        }));
      var k = !!Ee.groupId, I = he.indexOf(Ee), q = he.slice(I + 1), z = pr(q, Ee.groupId);
      if (t.allTheWay) {
        var B = Ve(Me ? pr(he, Ee.groupId) : mt(z));
        return Ce(e, w(w({}, t), {}, {
          type: "move",
          id: B == null ? void 0 : B.id
        }));
      }
      var G = zi(
        // If it's a grid and orientation is not set, it's a next/previous
        // call, which is inherently horizontal. up/down will call next with
        // orientation set to vertical by default (see below on up/down cases).
        k ? a || "horizontal" : a
      ), V = s && s !== G, K = k && l && l !== G, Y = (
        // `previous` and `up` will set action.hasNullItem, but when calling
        // next directly, hasNullItem will only be true if it's not a grid and
        // loop is set to true, which means that pressing right or down keys on
        // grids will never focus the composite element. On one-dimensional
        // composites that don't loop, pressing right or down keys also doesn't
        // focus the composite element.
        t.hasNullItem || !k && V && c
      );
      if (V) {
        var ae = K && !Y ? he : pr(he, Ee.groupId), U = Hi(ae, i, Y), R = Ve(U, i);
        return Ce(e, w(w({}, t), {}, {
          type: "move",
          id: R == null ? void 0 : R.id
        }));
      }
      if (K) {
        var le = Ve(
          // We can use nextItems, which contains all the next items, including
          // items from other groups, to wrap between groups. However, if there
          // is a null item (the composite element), we'll only use the next
          // items in the group. So moving next from the last item will focus
          // the composite element (null). On grid composites, horizontal
          // navigation never focuses the composite element, only vertical.
          Y ? z : q,
          i
        ), we = Y ? (le == null ? void 0 : le.id) || null : le == null ? void 0 : le.id;
        return Ce(e, w(w({}, t), {}, {
          type: "move",
          id: we
        }));
      }
      var Ie = Ve(z, i);
      return !Ie && Y ? Ce(e, w(w({}, t), {}, {
        type: "move",
        id: null
      })) : Ce(e, w(w({}, t), {}, {
        type: "move",
        id: Ie == null ? void 0 : Ie.id
      }));
    }
    case "previous": {
      var Bt = !!u.length, zt = !Bt && c, Vt = Ce(w(w({}, e), {}, {
        items: mt(o)
      }), w(w({}, t), {}, {
        type: "next",
        hasNullItem: zt
      }));
      return w(w({}, Vt), {}, {
        items: o
      });
    }
    case "down": {
      var Kt = m && !t.allTheWay, yo = An(Ar(kn(tr(o), i, Kt))), go = s && s !== "horizontal", bo = go && c, Mo = Ce(w(w({}, e), {}, {
        orientation: "vertical",
        items: yo
      }), w(w({}, t), {}, {
        type: "next",
        hasNullItem: bo
      }));
      return w(w({}, Mo), {}, {
        orientation: a,
        items: o
      });
    }
    case "up": {
      var wo = m && !t.allTheWay, Eo = An(mt(Ar(kn(tr(o), i, wo)))), So = c, Po = Ce(w(w({}, e), {}, {
        orientation: "vertical",
        items: Eo
      }), w(w({}, t), {}, {
        type: "next",
        hasNullItem: So
      }));
      return w(w({}, Po), {}, {
        orientation: a,
        items: o
      });
    }
    case "first": {
      var dr = Ve(o);
      return Ce(e, w(w({}, t), {}, {
        type: "move",
        id: dr == null ? void 0 : dr.id
      }));
    }
    case "last": {
      var _o = Ce(w(w({}, e), {}, {
        items: mt(o)
      }), w(w({}, t), {}, {
        type: "first"
      }));
      return w(w({}, _o), {}, {
        items: o
      });
    }
    case "sort":
      return w(w({}, e), {}, {
        items: xr(o),
        groups: xr(u)
      });
    case "setVirtual":
      return w(w({}, e), {}, {
        unstable_virtual: Ue(t.virtual, r)
      });
    case "setRTL":
      return w(w({}, e), {}, {
        rtl: Ue(t.rtl, n)
      });
    case "setOrientation":
      return w(w({}, e), {}, {
        orientation: Ue(t.orientation, a)
      });
    case "setCurrentId": {
      var Oo = Ze(w(w({}, e), {}, {
        currentId: Ue(t.currentId, i)
      }));
      return w(w({}, e), {}, {
        currentId: Oo,
        hasSetCurrentId: !0
      });
    }
    case "setLoop":
      return w(w({}, e), {}, {
        loop: Ue(t.loop, s)
      });
    case "setWrap":
      return w(w({}, e), {}, {
        wrap: Ue(t.wrap, l)
      });
    case "setShift":
      return w(w({}, e), {}, {
        shift: Ue(t.shift, m)
      });
    case "setIncludesBaseElement":
      return w(w({}, e), {}, {
        unstable_includesBaseElement: Ue(t.includesBaseElement, c)
      });
    case "reset":
      return w(w({}, e), {}, {
        unstable_virtual: h,
        rtl: f,
        orientation: p,
        currentId: Ze(w(w({}, e), {}, {
          currentId: y
        })),
        loop: M,
        wrap: b,
        shift: g,
        unstable_moves: 0,
        pastIds: []
      });
    case "setItems":
      return w(w({}, e), {}, {
        items: t.items
      });
    default:
      throw new Error();
  }
}
function me(e) {
  return L(e, []);
}
function Yi() {
  var e = X(!1);
  return Je(function() {
    return function() {
      e.current = !0;
    };
  }, []), e;
}
function Xi(e) {
  e === void 0 && (e = {});
  var t = ut(e), r = t.unstable_virtual, n = r === void 0 ? !1 : r, a = t.rtl, o = a === void 0 ? !1 : a, u = t.orientation, i = t.currentId, s = t.loop, l = s === void 0 ? !1 : s, d = t.wrap, m = d === void 0 ? !1 : d, v = t.shift, c = v === void 0 ? !1 : v, h = t.unstable_includesBaseElement, f = oe(t, ["unstable_virtual", "rtl", "orientation", "currentId", "loop", "wrap", "shift", "unstable_includesBaseElement"]), p = Da(f), y = Vr(Ce, {
    unstable_virtual: n,
    rtl: o,
    orientation: u,
    items: [],
    groups: [],
    currentId: i,
    loop: l,
    wrap: m,
    shift: c,
    unstable_moves: 0,
    pastIds: [],
    unstable_includesBaseElement: h ?? i === null,
    initialVirtual: n,
    initialRTL: o,
    initialOrientation: u,
    initialCurrentId: i,
    initialLoop: l,
    initialWrap: m,
    initialShift: c
  }), M = y[0];
  M.pastIds, M.initialVirtual, M.initialRTL, M.initialOrientation, M.initialCurrentId, M.initialLoop, M.initialWrap, M.initialShift, M.hasSetCurrentId;
  var b = oe(M, ["pastIds", "initialVirtual", "initialRTL", "initialOrientation", "initialCurrentId", "initialLoop", "initialWrap", "initialShift", "hasSetCurrentId"]), g = y[1], E = ue(!1), P = E[0], _ = E[1], D = Yi(), O = L(function(S) {
    return g({
      type: "setItems",
      items: S
    });
  }, []);
  return qi(b.items, O), w(w(w({}, p), b), {}, {
    unstable_hasActiveWidget: P,
    unstable_setHasActiveWidget: _,
    registerItem: me(function(S) {
      D.current || g({
        type: "registerItem",
        item: S
      });
    }),
    unregisterItem: me(function(S) {
      D.current || g({
        type: "unregisterItem",
        id: S
      });
    }),
    registerGroup: me(function(S) {
      D.current || g({
        type: "registerGroup",
        group: S
      });
    }),
    unregisterGroup: me(function(S) {
      D.current || g({
        type: "unregisterGroup",
        id: S
      });
    }),
    move: me(function(S) {
      return g({
        type: "move",
        id: S
      });
    }),
    next: me(function(S) {
      return g({
        type: "next",
        allTheWay: S
      });
    }),
    previous: me(function(S) {
      return g({
        type: "previous",
        allTheWay: S
      });
    }),
    up: me(function(S) {
      return g({
        type: "up",
        allTheWay: S
      });
    }),
    down: me(function(S) {
      return g({
        type: "down",
        allTheWay: S
      });
    }),
    first: me(function() {
      return g({
        type: "first"
      });
    }),
    last: me(function() {
      return g({
        type: "last"
      });
    }),
    sort: me(function() {
      return g({
        type: "sort"
      });
    }),
    unstable_setVirtual: me(function(S) {
      return g({
        type: "setVirtual",
        virtual: S
      });
    }),
    setRTL: me(function(S) {
      return g({
        type: "setRTL",
        rtl: S
      });
    }),
    setOrientation: me(function(S) {
      return g({
        type: "setOrientation",
        orientation: S
      });
    }),
    setCurrentId: me(function(S) {
      return g({
        type: "setCurrentId",
        currentId: S
      });
    }),
    setLoop: me(function(S) {
      return g({
        type: "setLoop",
        loop: S
      });
    }),
    setWrap: me(function(S) {
      return g({
        type: "setWrap",
        wrap: S
      });
    }),
    setShift: me(function(S) {
      return g({
        type: "setShift",
        shift: S
      });
    }),
    unstable_setIncludesBaseElement: me(function(S) {
      return g({
        type: "setIncludesBaseElement",
        includesBaseElement: S
      });
    }),
    reset: me(function() {
      return g({
        type: "reset"
      });
    })
  });
}
var Pe = "top", xe = "bottom", Re = "right", _e = "left", Xr = "auto", Nt = [Pe, xe, Re, _e], ht = "start", $t = "end", Gi = "clippingParents", xa = "viewport", _t = "popper", Ji = "reference", Rn = /* @__PURE__ */ Nt.reduce(function(e, t) {
  return e.concat([t + "-" + ht, t + "-" + $t]);
}, []), Ra = /* @__PURE__ */ [].concat(Nt, [Xr]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ht, t + "-" + $t]);
}, []), Qi = "beforeRead", Zi = "read", es = "afterRead", ts = "beforeMain", rs = "main", ns = "afterMain", as = "beforeWrite", os = "write", is = "afterWrite", ss = [Qi, Zi, es, ts, rs, ns, as, os, is];
function Fe(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Te(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function at(e) {
  var t = Te(e).Element;
  return e instanceof t || e instanceof Element;
}
function ke(e) {
  var t = Te(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Gr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Te(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function us(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, o = t.elements[r];
    !ke(o) || !Fe(o) || (Object.assign(o.style, n), Object.keys(a).forEach(function(u) {
      var i = a[u];
      i === !1 ? o.removeAttribute(u) : o.setAttribute(u, i === !0 ? "" : i);
    }));
  });
}
function ls(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], o = t.attributes[n] || {}, u = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), i = u.reduce(function(s, l) {
        return s[l] = "", s;
      }, {});
      !ke(a) || !Fe(a) || (Object.assign(a.style, i), Object.keys(o).forEach(function(s) {
        a.removeAttribute(s);
      }));
    });
  };
}
const ds = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: us,
  effect: ls,
  requires: ["computeStyles"]
};
function We(e) {
  return e.split("-")[0];
}
var tt = Math.max, rr = Math.min, pt = Math.round;
function Rr() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Ia() {
  return !/^((?!chrome|android).)*safari/i.test(Rr());
}
function yt(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), a = 1, o = 1;
  t && ke(e) && (a = e.offsetWidth > 0 && pt(n.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && pt(n.height) / e.offsetHeight || 1);
  var u = at(e) ? Te(e) : window, i = u.visualViewport, s = !Ia() && r, l = (n.left + (s && i ? i.offsetLeft : 0)) / a, d = (n.top + (s && i ? i.offsetTop : 0)) / o, m = n.width / a, v = n.height / o;
  return {
    width: m,
    height: v,
    top: d,
    right: l + m,
    bottom: d + v,
    left: l,
    x: l,
    y: d
  };
}
function Jr(e) {
  var t = yt(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function $a(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Gr(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Ke(e) {
  return Te(e).getComputedStyle(e);
}
function cs(e) {
  return ["table", "td", "th"].indexOf(Fe(e)) >= 0;
}
function Qe(e) {
  return ((at(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function ur(e) {
  return Fe(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Gr(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Qe(e)
  );
}
function In(e) {
  return !ke(e) || // https://github.com/popperjs/popper-core/issues/837
  Ke(e).position === "fixed" ? null : e.offsetParent;
}
function fs(e) {
  var t = /firefox/i.test(Rr()), r = /Trident/i.test(Rr());
  if (r && ke(e)) {
    var n = Ke(e);
    if (n.position === "fixed")
      return null;
  }
  var a = ur(e);
  for (Gr(a) && (a = a.host); ke(a) && ["html", "body"].indexOf(Fe(a)) < 0; ) {
    var o = Ke(a);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Ht(e) {
  for (var t = Te(e), r = In(e); r && cs(r) && Ke(r).position === "static"; )
    r = In(r);
  return r && (Fe(r) === "html" || Fe(r) === "body" && Ke(r).position === "static") ? t : r || fs(e) || t;
}
function Qr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Tt(e, t, r) {
  return tt(e, rr(t, r));
}
function ms(e, t, r) {
  var n = Tt(e, t, r);
  return n > r ? r : n;
}
function ja() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function La(e) {
  return Object.assign({}, ja(), e);
}
function Wa(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var vs = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, La(typeof t != "number" ? t : Wa(t, Nt));
};
function hs(e) {
  var t, r = e.state, n = e.name, a = e.options, o = r.elements.arrow, u = r.modifiersData.popperOffsets, i = We(r.placement), s = Qr(i), l = [_e, Re].indexOf(i) >= 0, d = l ? "height" : "width";
  if (!(!o || !u)) {
    var m = vs(a.padding, r), v = Jr(o), c = s === "y" ? Pe : _e, h = s === "y" ? xe : Re, f = r.rects.reference[d] + r.rects.reference[s] - u[s] - r.rects.popper[d], p = u[s] - r.rects.reference[s], y = Ht(o), M = y ? s === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, b = f / 2 - p / 2, g = m[c], E = M - v[d] - m[h], P = M / 2 - v[d] / 2 + b, _ = Tt(g, P, E), D = s;
    r.modifiersData[n] = (t = {}, t[D] = _, t.centerOffset = _ - P, t);
  }
}
function ps(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || $a(t.elements.popper, a) && (t.elements.arrow = a));
}
const ys = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: hs,
  effect: ps,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function gt(e) {
  return e.split("-")[1];
}
var gs = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function bs(e, t) {
  var r = e.x, n = e.y, a = t.devicePixelRatio || 1;
  return {
    x: pt(r * a) / a || 0,
    y: pt(n * a) / a || 0
  };
}
function $n(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, o = e.variation, u = e.offsets, i = e.position, s = e.gpuAcceleration, l = e.adaptive, d = e.roundOffsets, m = e.isFixed, v = u.x, c = v === void 0 ? 0 : v, h = u.y, f = h === void 0 ? 0 : h, p = typeof d == "function" ? d({
    x: c,
    y: f
  }) : {
    x: c,
    y: f
  };
  c = p.x, f = p.y;
  var y = u.hasOwnProperty("x"), M = u.hasOwnProperty("y"), b = _e, g = Pe, E = window;
  if (l) {
    var P = Ht(r), _ = "clientHeight", D = "clientWidth";
    if (P === Te(r) && (P = Qe(r), Ke(P).position !== "static" && i === "absolute" && (_ = "scrollHeight", D = "scrollWidth")), P = P, a === Pe || (a === _e || a === Re) && o === $t) {
      g = xe;
      var O = m && P === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        P[_]
      );
      f -= O - n.height, f *= s ? 1 : -1;
    }
    if (a === _e || (a === Pe || a === xe) && o === $t) {
      b = Re;
      var S = m && P === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        P[D]
      );
      c -= S - n.width, c *= s ? 1 : -1;
    }
  }
  var x = Object.assign({
    position: i
  }, l && gs), C = d === !0 ? bs({
    x: c,
    y: f
  }, Te(r)) : {
    x: c,
    y: f
  };
  if (c = C.x, f = C.y, s) {
    var T;
    return Object.assign({}, x, (T = {}, T[g] = M ? "0" : "", T[b] = y ? "0" : "", T.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + c + "px, " + f + "px)" : "translate3d(" + c + "px, " + f + "px, 0)", T));
  }
  return Object.assign({}, x, (t = {}, t[g] = M ? f + "px" : "", t[b] = y ? c + "px" : "", t.transform = "", t));
}
function Ms(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, o = r.adaptive, u = o === void 0 ? !0 : o, i = r.roundOffsets, s = i === void 0 ? !0 : i, l = {
    placement: We(t.placement),
    variation: gt(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, $n(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: u,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, $n(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const ws = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Ms,
  data: {}
};
var Ut = {
  passive: !0
};
function Es(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, o = a === void 0 ? !0 : a, u = n.resize, i = u === void 0 ? !0 : u, s = Te(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && l.forEach(function(d) {
    d.addEventListener("scroll", r.update, Ut);
  }), i && s.addEventListener("resize", r.update, Ut), function() {
    o && l.forEach(function(d) {
      d.removeEventListener("scroll", r.update, Ut);
    }), i && s.removeEventListener("resize", r.update, Ut);
  };
}
const Ss = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Es,
  data: {}
};
var Ps = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Jt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Ps[t];
  });
}
var _s = {
  start: "end",
  end: "start"
};
function jn(e) {
  return e.replace(/start|end/g, function(t) {
    return _s[t];
  });
}
function Zr(e) {
  var t = Te(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function en(e) {
  return yt(Qe(e)).left + Zr(e).scrollLeft;
}
function Os(e, t) {
  var r = Te(e), n = Qe(e), a = r.visualViewport, o = n.clientWidth, u = n.clientHeight, i = 0, s = 0;
  if (a) {
    o = a.width, u = a.height;
    var l = Ia();
    (l || !l && t === "fixed") && (i = a.offsetLeft, s = a.offsetTop);
  }
  return {
    width: o,
    height: u,
    x: i + en(e),
    y: s
  };
}
function Cs(e) {
  var t, r = Qe(e), n = Zr(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, o = tt(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), u = tt(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), i = -n.scrollLeft + en(e), s = -n.scrollTop;
  return Ke(a || r).direction === "rtl" && (i += tt(r.clientWidth, a ? a.clientWidth : 0) - o), {
    width: o,
    height: u,
    x: i,
    y: s
  };
}
function tn(e) {
  var t = Ke(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function Fa(e) {
  return ["html", "body", "#document"].indexOf(Fe(e)) >= 0 ? e.ownerDocument.body : ke(e) && tn(e) ? e : Fa(ur(e));
}
function At(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Fa(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), o = Te(n), u = a ? [o].concat(o.visualViewport || [], tn(n) ? n : []) : n, i = t.concat(u);
  return a ? i : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    i.concat(At(ur(u)))
  );
}
function Ir(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Ds(e, t) {
  var r = yt(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Ln(e, t, r) {
  return t === xa ? Ir(Os(e, r)) : at(t) ? Ds(t, r) : Ir(Cs(Qe(e)));
}
function Ts(e) {
  var t = At(ur(e)), r = ["absolute", "fixed"].indexOf(Ke(e).position) >= 0, n = r && ke(e) ? Ht(e) : e;
  return at(n) ? t.filter(function(a) {
    return at(a) && $a(a, n) && Fe(a) !== "body";
  }) : [];
}
function As(e, t, r, n) {
  var a = t === "clippingParents" ? Ts(e) : [].concat(t), o = [].concat(a, [r]), u = o[0], i = o.reduce(function(s, l) {
    var d = Ln(e, l, n);
    return s.top = tt(d.top, s.top), s.right = rr(d.right, s.right), s.bottom = rr(d.bottom, s.bottom), s.left = tt(d.left, s.left), s;
  }, Ln(e, u, n));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function Na(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? We(n) : null, o = n ? gt(n) : null, u = t.x + t.width / 2 - r.width / 2, i = t.y + t.height / 2 - r.height / 2, s;
  switch (a) {
    case Pe:
      s = {
        x: u,
        y: t.y - r.height
      };
      break;
    case xe:
      s = {
        x: u,
        y: t.y + t.height
      };
      break;
    case Re:
      s = {
        x: t.x + t.width,
        y: i
      };
      break;
    case _e:
      s = {
        x: t.x - r.width,
        y: i
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var l = a ? Qr(a) : null;
  if (l != null) {
    var d = l === "y" ? "height" : "width";
    switch (o) {
      case ht:
        s[l] = s[l] - (t[d] / 2 - r[d] / 2);
        break;
      case $t:
        s[l] = s[l] + (t[d] / 2 - r[d] / 2);
        break;
    }
  }
  return s;
}
function jt(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, o = r.strategy, u = o === void 0 ? e.strategy : o, i = r.boundary, s = i === void 0 ? Gi : i, l = r.rootBoundary, d = l === void 0 ? xa : l, m = r.elementContext, v = m === void 0 ? _t : m, c = r.altBoundary, h = c === void 0 ? !1 : c, f = r.padding, p = f === void 0 ? 0 : f, y = La(typeof p != "number" ? p : Wa(p, Nt)), M = v === _t ? Ji : _t, b = e.rects.popper, g = e.elements[h ? M : v], E = As(at(g) ? g : g.contextElement || Qe(e.elements.popper), s, d, u), P = yt(e.elements.reference), _ = Na({
    reference: P,
    element: b,
    strategy: "absolute",
    placement: a
  }), D = Ir(Object.assign({}, b, _)), O = v === _t ? D : P, S = {
    top: E.top - O.top + y.top,
    bottom: O.bottom - E.bottom + y.bottom,
    left: E.left - O.left + y.left,
    right: O.right - E.right + y.right
  }, x = e.modifiersData.offset;
  if (v === _t && x) {
    var C = x[a];
    Object.keys(S).forEach(function(T) {
      var j = [Re, xe].indexOf(T) >= 0 ? 1 : -1, A = [Pe, xe].indexOf(T) >= 0 ? "y" : "x";
      S[T] += C[A] * j;
    });
  }
  return S;
}
function ks(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, o = r.rootBoundary, u = r.padding, i = r.flipVariations, s = r.allowedAutoPlacements, l = s === void 0 ? Ra : s, d = gt(n), m = d ? i ? Rn : Rn.filter(function(h) {
    return gt(h) === d;
  }) : Nt, v = m.filter(function(h) {
    return l.indexOf(h) >= 0;
  });
  v.length === 0 && (v = m);
  var c = v.reduce(function(h, f) {
    return h[f] = jt(e, {
      placement: f,
      boundary: a,
      rootBoundary: o,
      padding: u
    })[We(f)], h;
  }, {});
  return Object.keys(c).sort(function(h, f) {
    return c[h] - c[f];
  });
}
function xs(e) {
  if (We(e) === Xr)
    return [];
  var t = Jt(e);
  return [jn(e), t, jn(t)];
}
function Rs(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, o = a === void 0 ? !0 : a, u = r.altAxis, i = u === void 0 ? !0 : u, s = r.fallbackPlacements, l = r.padding, d = r.boundary, m = r.rootBoundary, v = r.altBoundary, c = r.flipVariations, h = c === void 0 ? !0 : c, f = r.allowedAutoPlacements, p = t.options.placement, y = We(p), M = y === p, b = s || (M || !h ? [Jt(p)] : xs(p)), g = [p].concat(b).reduce(function(fe, ne) {
      return fe.concat(We(ne) === Xr ? ks(t, {
        placement: ne,
        boundary: d,
        rootBoundary: m,
        padding: l,
        flipVariations: h,
        allowedAutoPlacements: f
      }) : ne);
    }, []), E = t.rects.reference, P = t.rects.popper, _ = /* @__PURE__ */ new Map(), D = !0, O = g[0], S = 0; S < g.length; S++) {
      var x = g[S], C = We(x), T = gt(x) === ht, j = [Pe, xe].indexOf(C) >= 0, A = j ? "width" : "height", $ = jt(t, {
        placement: x,
        boundary: d,
        rootBoundary: m,
        altBoundary: v,
        padding: l
      }), Q = j ? T ? Re : _e : T ? xe : Pe;
      E[A] > P[A] && (Q = Jt(Q));
      var te = Jt(Q), re = [];
      if (o && re.push($[C] <= 0), i && re.push($[Q] <= 0, $[te] <= 0), re.every(function(fe) {
        return fe;
      })) {
        O = x, D = !1;
        break;
      }
      _.set(x, re);
    }
    if (D)
      for (var ce = h ? 3 : 1, ie = function(ne) {
        var Z = g.find(function(Me) {
          var he = _.get(Me);
          if (he)
            return he.slice(0, ne).every(function(Ee) {
              return Ee;
            });
        });
        if (Z)
          return O = Z, "break";
      }, se = ce; se > 0; se--) {
        var be = ie(se);
        if (be === "break")
          break;
      }
    t.placement !== O && (t.modifiersData[n]._skip = !0, t.placement = O, t.reset = !0);
  }
}
const Is = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Rs,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Wn(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Fn(e) {
  return [Pe, Re, xe, _e].some(function(t) {
    return e[t] >= 0;
  });
}
function $s(e) {
  var t = e.state, r = e.name, n = t.rects.reference, a = t.rects.popper, o = t.modifiersData.preventOverflow, u = jt(t, {
    elementContext: "reference"
  }), i = jt(t, {
    altBoundary: !0
  }), s = Wn(u, n), l = Wn(i, a, o), d = Fn(s), m = Fn(l);
  t.modifiersData[r] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: l,
    isReferenceHidden: d,
    hasPopperEscaped: m
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": m
  });
}
const js = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: $s
};
function Ls(e, t, r) {
  var n = We(e), a = [_e, Pe].indexOf(n) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, u = o[0], i = o[1];
  return u = u || 0, i = (i || 0) * a, [_e, Re].indexOf(n) >= 0 ? {
    x: i,
    y: u
  } : {
    x: u,
    y: i
  };
}
function Ws(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, o = a === void 0 ? [0, 0] : a, u = Ra.reduce(function(d, m) {
    return d[m] = Ls(m, t.rects, o), d;
  }, {}), i = u[t.placement], s = i.x, l = i.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += l), t.modifiersData[n] = u;
}
const Fs = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Ws
};
function Ns(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Na({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Hs = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Ns,
  data: {}
};
function Bs(e) {
  return e === "x" ? "y" : "x";
}
function zs(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, o = a === void 0 ? !0 : a, u = r.altAxis, i = u === void 0 ? !1 : u, s = r.boundary, l = r.rootBoundary, d = r.altBoundary, m = r.padding, v = r.tether, c = v === void 0 ? !0 : v, h = r.tetherOffset, f = h === void 0 ? 0 : h, p = jt(t, {
    boundary: s,
    rootBoundary: l,
    padding: m,
    altBoundary: d
  }), y = We(t.placement), M = gt(t.placement), b = !M, g = Qr(y), E = Bs(g), P = t.modifiersData.popperOffsets, _ = t.rects.reference, D = t.rects.popper, O = typeof f == "function" ? f(Object.assign({}, t.rects, {
    placement: t.placement
  })) : f, S = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), x = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, C = {
    x: 0,
    y: 0
  };
  if (P) {
    if (o) {
      var T, j = g === "y" ? Pe : _e, A = g === "y" ? xe : Re, $ = g === "y" ? "height" : "width", Q = P[g], te = Q + p[j], re = Q - p[A], ce = c ? -D[$] / 2 : 0, ie = M === ht ? _[$] : D[$], se = M === ht ? -D[$] : -_[$], be = t.elements.arrow, fe = c && be ? Jr(be) : {
        width: 0,
        height: 0
      }, ne = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : ja(), Z = ne[j], Me = ne[A], he = Tt(0, _[$], fe[$]), Ee = b ? _[$] / 2 - ce - he - Z - S.mainAxis : ie - he - Z - S.mainAxis, k = b ? -_[$] / 2 + ce + he + Me + S.mainAxis : se + he + Me + S.mainAxis, I = t.elements.arrow && Ht(t.elements.arrow), q = I ? g === "y" ? I.clientTop || 0 : I.clientLeft || 0 : 0, z = (T = x == null ? void 0 : x[g]) != null ? T : 0, B = Q + Ee - z - q, G = Q + k - z, V = Tt(c ? rr(te, B) : te, Q, c ? tt(re, G) : re);
      P[g] = V, C[g] = V - Q;
    }
    if (i) {
      var K, Y = g === "x" ? Pe : _e, ae = g === "x" ? xe : Re, U = P[E], R = E === "y" ? "height" : "width", le = U + p[Y], we = U - p[ae], Ie = [Pe, _e].indexOf(y) !== -1, Bt = (K = x == null ? void 0 : x[E]) != null ? K : 0, zt = Ie ? le : U - _[R] - D[R] - Bt + S.altAxis, Vt = Ie ? U + _[R] + D[R] - Bt - S.altAxis : we, Kt = c && Ie ? ms(zt, U, Vt) : Tt(c ? zt : le, U, c ? Vt : we);
      P[E] = Kt, C[E] = Kt - U;
    }
    t.modifiersData[n] = C;
  }
}
const Vs = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: zs,
  requiresIfExists: ["offset"]
};
function Ks(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Us(e) {
  return e === Te(e) || !ke(e) ? Zr(e) : Ks(e);
}
function qs(e) {
  var t = e.getBoundingClientRect(), r = pt(t.width) / e.offsetWidth || 1, n = pt(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Ys(e, t, r) {
  r === void 0 && (r = !1);
  var n = ke(t), a = ke(t) && qs(t), o = Qe(t), u = yt(e, a, r), i = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Fe(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  tn(o)) && (i = Us(t)), ke(t) ? (s = yt(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : o && (s.x = en(o))), {
    x: u.left + i.scrollLeft - s.x,
    y: u.top + i.scrollTop - s.y,
    width: u.width,
    height: u.height
  };
}
function Xs(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function a(o) {
    r.add(o.name);
    var u = [].concat(o.requires || [], o.requiresIfExists || []);
    u.forEach(function(i) {
      if (!r.has(i)) {
        var s = t.get(i);
        s && a(s);
      }
    }), n.push(o);
  }
  return e.forEach(function(o) {
    r.has(o.name) || a(o);
  }), n;
}
function Gs(e) {
  var t = Xs(e);
  return ss.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function Js(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Qs(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Nn = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Hn() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Zs(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, o = a === void 0 ? Nn : a;
  return function(i, s, l) {
    l === void 0 && (l = o);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Nn, o),
      modifiersData: {},
      elements: {
        reference: i,
        popper: s
      },
      attributes: {},
      styles: {}
    }, m = [], v = !1, c = {
      state: d,
      setOptions: function(y) {
        var M = typeof y == "function" ? y(d.options) : y;
        f(), d.options = Object.assign({}, o, d.options, M), d.scrollParents = {
          reference: at(i) ? At(i) : i.contextElement ? At(i.contextElement) : [],
          popper: At(s)
        };
        var b = Gs(Qs([].concat(n, d.options.modifiers)));
        return d.orderedModifiers = b.filter(function(g) {
          return g.enabled;
        }), h(), c.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!v) {
          var y = d.elements, M = y.reference, b = y.popper;
          if (Hn(M, b)) {
            d.rects = {
              reference: Ys(M, Ht(b), d.options.strategy === "fixed"),
              popper: Jr(b)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(S) {
              return d.modifiersData[S.name] = Object.assign({}, S.data);
            });
            for (var g = 0; g < d.orderedModifiers.length; g++) {
              if (d.reset === !0) {
                d.reset = !1, g = -1;
                continue;
              }
              var E = d.orderedModifiers[g], P = E.fn, _ = E.options, D = _ === void 0 ? {} : _, O = E.name;
              typeof P == "function" && (d = P({
                state: d,
                options: D,
                name: O,
                instance: c
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Js(function() {
        return new Promise(function(p) {
          c.forceUpdate(), p(d);
        });
      }),
      destroy: function() {
        f(), v = !0;
      }
    };
    if (!Hn(i, s))
      return c;
    c.setOptions(l).then(function(p) {
      !v && l.onFirstUpdate && l.onFirstUpdate(p);
    });
    function h() {
      d.orderedModifiers.forEach(function(p) {
        var y = p.name, M = p.options, b = M === void 0 ? {} : M, g = p.effect;
        if (typeof g == "function") {
          var E = g({
            state: d,
            name: y,
            instance: c,
            options: b
          }), P = function() {
          };
          m.push(E || P);
        }
      });
    }
    function f() {
      m.forEach(function(p) {
        return p();
      }), m = [];
    }
    return c;
  };
}
var eu = [Ss, Hs, ws, ds, Fs, Is, Vs, ys, js], tu = /* @__PURE__ */ Zs({
  defaultModifiers: eu
});
function ru(e) {
  var t = X(null);
  return Je(function() {
    t.current = e;
  }, [e]), t;
}
function Ha(e) {
  e === void 0 && (e = {});
  var t = ut(e), r = t.visible, n = r === void 0 ? !1 : r, a = t.animated, o = a === void 0 ? !1 : a, u = oe(t, ["visible", "animated"]), i = Da(u), s = ue(n), l = s[0], d = s[1], m = ue(o), v = m[0], c = m[1], h = ue(!1), f = h[0], p = h[1], y = ru(l), M = y.current != null && y.current !== l;
  v && !f && M && p(!0), J(function() {
    if (typeof v == "number" && f) {
      var _ = setTimeout(function() {
        return p(!1);
      }, v);
      return function() {
        clearTimeout(_);
      };
    }
    if (v && f && process.env.NODE_ENV === "development") {
      var D = setTimeout(function() {
        process.env.NODE_ENV !== "production" && Oe(f, "It's been 8 seconds but stopAnimation has not been called. Does the disclousure element have a CSS transition?");
      }, 8e3);
      return function() {
        clearTimeout(D);
      };
    }
    return function() {
    };
  }, [v, f]);
  var b = L(function() {
    return d(!0);
  }, []), g = L(function() {
    return d(!1);
  }, []), E = L(function() {
    return d(function(_) {
      return !_;
    });
  }, []), P = L(function() {
    return p(!1);
  }, []);
  return w(w({}, i), {}, {
    visible: l,
    animated: v,
    animating: f,
    show: b,
    hide: g,
    toggle: E,
    setVisible: d,
    setAnimated: c,
    stopAnimation: P
  });
}
function nu(e) {
  e === void 0 && (e = {});
  var t = ut(e), r = t.modal, n = r === void 0 ? !0 : r, a = oe(t, ["modal"]), o = Ha(a), u = ue(n), i = u[0], s = u[1], l = X(null);
  return w(w({}, o), {}, {
    modal: i,
    setModal: s,
    unstable_disclosureRef: l
  });
}
var au = et("Mac") && !et("Chrome") && et("Safari");
function Bn(e) {
  return function(t) {
    return e && !Rt(t, e) ? e : t;
  };
}
function ou(e) {
  e === void 0 && (e = {});
  var t = ut(e), r = t.gutter, n = r === void 0 ? 12 : r, a = t.placement, o = a === void 0 ? "bottom" : a, u = t.unstable_flip, i = u === void 0 ? !0 : u, s = t.unstable_offset, l = t.unstable_preventOverflow, d = l === void 0 ? !0 : l, m = t.unstable_fixed, v = m === void 0 ? !1 : m, c = t.modal, h = c === void 0 ? !1 : c, f = oe(t, ["gutter", "placement", "unstable_flip", "unstable_offset", "unstable_preventOverflow", "unstable_fixed", "modal"]), p = X(null), y = X(null), M = X(null), b = X(null), g = ue(o), E = g[0], P = g[1], _ = ue(o), D = _[0], O = _[1], S = ue(s || [0, n]), x = S[0], C = ue({
    position: "fixed",
    left: "100%",
    top: "100%"
  }), T = C[0], j = C[1], A = ue({}), $ = A[0], Q = A[1], te = nu(w({
    modal: h
  }, f)), re = L(function() {
    return p.current ? (p.current.forceUpdate(), !0) : !1;
  }, []), ce = L(function(ie) {
    ie.placement && O(ie.placement), ie.styles && (j(Bn(ie.styles.popper)), b.current && Q(Bn(ie.styles.arrow)));
  }, []);
  return Je(function() {
    return y.current && M.current && (p.current = tu(y.current, M.current, {
      // https://popper.js.org/docs/v2/constructors/#options
      placement: E,
      strategy: v ? "fixed" : "absolute",
      // Safari needs styles to be applied in the first render, otherwise
      // hovering over the popover when it gets visible for the first time
      // will change its dimensions unexpectedly.
      onFirstUpdate: au ? ce : void 0,
      modifiers: [{
        // https://popper.js.org/docs/v2/modifiers/event-listeners/
        name: "eventListeners",
        enabled: te.visible
      }, {
        // https://popper.js.org/docs/v2/modifiers/apply-styles/
        name: "applyStyles",
        enabled: !1
      }, {
        // https://popper.js.org/docs/v2/modifiers/flip/
        name: "flip",
        enabled: i,
        options: {
          padding: 8
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/offset/
        name: "offset",
        options: {
          offset: x
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/prevent-overflow/
        name: "preventOverflow",
        enabled: d,
        options: {
          tetherOffset: function() {
            var se;
            return ((se = b.current) === null || se === void 0 ? void 0 : se.clientWidth) || 0;
          }
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/arrow/
        name: "arrow",
        enabled: !!b.current,
        options: {
          element: b.current
        }
      }, {
        // https://popper.js.org/docs/v2/modifiers/#custom-modifiers
        name: "updateState",
        phase: "write",
        requires: ["computeStyles"],
        enabled: te.visible && process.env.NODE_ENV !== "test",
        fn: function(se) {
          var be = se.state;
          return ce(be);
        }
      }]
    })), function() {
      p.current && (p.current.destroy(), p.current = null);
    };
  }, [E, v, te.visible, i, x, d]), J(function() {
    if (te.visible) {
      var ie = window.requestAnimationFrame(function() {
        var se;
        (se = p.current) === null || se === void 0 || se.forceUpdate();
      });
      return function() {
        window.cancelAnimationFrame(ie);
      };
    }
  }, [te.visible]), w(w({}, te), {}, {
    unstable_referenceRef: y,
    unstable_popoverRef: M,
    unstable_arrowRef: b,
    unstable_popoverStyles: T,
    unstable_arrowStyles: $,
    unstable_update: re,
    unstable_originalPlacement: E,
    placement: D,
    place: P
  });
}
var iu = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation"], Ba = iu, su = Ba, za = ye({
  name: "DisclosureContent",
  compose: sr,
  keys: su,
  useProps: function(t, r) {
    var n = r.onTransitionEnd, a = r.onAnimationEnd, o = r.style, u = oe(r, ["onTransitionEnd", "onAnimationEnd", "style"]), i = t.animated && t.animating, s = ue(null), l = s[0], d = s[1], m = !t.visible && !i, v = m ? w({
      display: "none"
    }, o) : o, c = ee(n), h = ee(a), f = X(0);
    J(function() {
      if (t.animated)
        return f.current = window.requestAnimationFrame(function() {
          f.current = window.requestAnimationFrame(function() {
            t.visible ? d("enter") : d(i ? "leave" : null);
          });
        }), function() {
          return window.cancelAnimationFrame(f.current);
        };
    }, [t.animated, t.visible, i]);
    var p = L(function(b) {
      if ($e(b) && i && t.animated === !0) {
        var g;
        (g = t.stopAnimation) === null || g === void 0 || g.call(t);
      }
    }, [t.animated, i, t.stopAnimation]), y = L(function(b) {
      var g;
      (g = c.current) === null || g === void 0 || g.call(c, b), p(b);
    }, [p]), M = L(function(b) {
      var g;
      (g = h.current) === null || g === void 0 || g.call(h, b), p(b);
    }, [p]);
    return w({
      id: t.baseId,
      "data-enter": l === "enter" ? "" : void 0,
      "data-leave": l === "leave" ? "" : void 0,
      onTransitionEnd: y,
      onAnimationEnd: M,
      hidden: m,
      style: v
    }, u);
  }
}), uu = pe({
  as: "div",
  useHook: za
});
function Va() {
  return Et ? document.body : null;
}
var zn = /* @__PURE__ */ Ge(Va());
function bt(e) {
  var t = e.children, r = Se(zn) || Va(), n = ue(function() {
    if (Et) {
      var o = document.createElement("div");
      return o.className = bt.__className, o;
    }
    return null;
  }), a = n[0];
  return Je(function() {
    if (!(!a || !r))
      return r.appendChild(a), function() {
        r.removeChild(a);
      };
  }, [a, r]), a ? /* @__PURE__ */ No(/* @__PURE__ */ De(zn.Provider, {
    value: a
  }, t), a) : null;
}
bt.__className = "__reakit-portal";
bt.__selector = "." + bt.__className;
function $r(e, t) {
  var r = e.indexOf(t);
  return yi(e, r);
}
var Xe = /* @__PURE__ */ Ge(null);
function lu(e, t, r) {
  var n = "unstable_orphan" in r && r.unstable_orphan, a = Se(Xe), o = ue([]), u = o[0], i = o[1], s = a || {}, l = s.addChild, d = s.removeChild, m = L(function(f) {
    return i(function(p) {
      return [].concat(p, [f]);
    });
  }, []), v = L(function(f) {
    return i(function(p) {
      return $r(p, f);
    });
  }, []);
  J(function() {
    if (!(!l || n))
      return l(e), function() {
        d == null || d(e);
      };
  }, [e, l, d, n]);
  var c = Ne(function() {
    return {
      orientation: r.orientation,
      next: r.next,
      previous: r.previous,
      ref: e,
      role: t,
      parent: a,
      children: u,
      addChild: m,
      removeChild: v
    };
  }, [r.orientation, r.next, r.previous, e, t, a, u, m, v]), h = L(function(f) {
    return /* @__PURE__ */ De(Xe.Provider, {
      value: c
    }, f);
  }, [c]);
  return h;
}
function du(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++)
      r[t] = e[t];
    return r;
  } else
    return Array.from(e);
}
var rn = !1;
if (typeof window < "u") {
  var Vn = {
    get passive() {
      rn = !0;
    }
  };
  window.addEventListener("testPassive", null, Vn), window.removeEventListener("testPassive", null, Vn);
}
var Ka = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), Ye = [], nr = !1, Ua = -1, kt = void 0, xt = void 0, qa = function(t) {
  return Ye.some(function(r) {
    return !!(r.options.allowTouchMove && r.options.allowTouchMove(t));
  });
}, ar = function(t) {
  var r = t || window.event;
  return qa(r.target) || r.touches.length > 1 ? !0 : (r.preventDefault && r.preventDefault(), !1);
}, cu = function(t) {
  if (xt === void 0) {
    var r = !!t && t.reserveScrollBarGap === !0, n = window.innerWidth - document.documentElement.clientWidth;
    r && n > 0 && (xt = document.body.style.paddingRight, document.body.style.paddingRight = n + "px");
  }
  kt === void 0 && (kt = document.body.style.overflow, document.body.style.overflow = "hidden");
}, fu = function() {
  xt !== void 0 && (document.body.style.paddingRight = xt, xt = void 0), kt !== void 0 && (document.body.style.overflow = kt, kt = void 0);
}, mu = function(t) {
  return t ? t.scrollHeight - t.scrollTop <= t.clientHeight : !1;
}, vu = function(t, r) {
  var n = t.targetTouches[0].clientY - Ua;
  return qa(t.target) ? !1 : r && r.scrollTop === 0 && n > 0 || mu(r) && n < 0 ? ar(t) : (t.stopPropagation(), !0);
}, hu = function(t, r) {
  if (!t) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!Ye.some(function(a) {
    return a.targetElement === t;
  })) {
    var n = {
      targetElement: t,
      options: r || {}
    };
    Ye = [].concat(du(Ye), [n]), Ka ? (t.ontouchstart = function(a) {
      a.targetTouches.length === 1 && (Ua = a.targetTouches[0].clientY);
    }, t.ontouchmove = function(a) {
      a.targetTouches.length === 1 && vu(a, t);
    }, nr || (document.addEventListener("touchmove", ar, rn ? { passive: !1 } : void 0), nr = !0)) : cu(r);
  }
}, pu = function(t) {
  if (!t) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  Ye = Ye.filter(function(r) {
    return r.targetElement !== t;
  }), Ka ? (t.ontouchstart = null, t.ontouchmove = null, nr && Ye.length === 0 && (document.removeEventListener("touchmove", ar, rn ? { passive: !1 } : void 0), nr = !1)) : Ye.length || fu();
}, yu = /* @__PURE__ */ Ge(void 0);
function gu(e) {
  return Array.isArray(e) ? !e.length : Ur(e) ? !Object.keys(e).length : e == null || e === "";
}
var Ya = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal"], bu = [].concat(Ya, ["hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_initialFocusRef", "unstable_finalFocusRef", "unstable_orphan", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide"]), Mu = Ya, wu = Mu;
function Eu(e, t) {
  var r = X(null), n = !!(t.animated && t.animating);
  return J(function() {
    if (!(t.visible || n)) {
      var a = function(i) {
        var s = i.target;
        "focus" in s && (r.current = s, t.unstable_disclosureRef && (t.unstable_disclosureRef.current = s));
      }, o = ge(e.current);
      return o.addEventListener("focusin", a), function() {
        return o.removeEventListener("focusin", a);
      };
    }
  }, [t.visible, n, t.unstable_disclosureRef, e]), J(function() {
    var a;
    if (!(!t.visible || n)) {
      var o = function(s) {
        var l = s.currentTarget;
        ir(l) && (s.preventDefault(), l.focus());
      }, u = ((a = t.unstable_disclosureRef) === null || a === void 0 ? void 0 : a.current) || r.current;
      return u == null || u.addEventListener("mousedown", o), function() {
        return u == null ? void 0 : u.removeEventListener("mousedown", o);
      };
    }
  }, [t.visible, n, t.unstable_disclosureRef]), t.unstable_disclosureRef || r;
}
function Su(e, t) {
  var r = !!(t.preventBodyScroll && t.visible);
  J(function() {
    var n = e.current;
    if (!(!n || !r))
      return hu(n, {
        reserveScrollBarGap: !0
      }), function() {
        return pu(n);
      };
  }, [e, r]);
}
function Pu(e, t, r) {
  var n = r.unstable_initialFocusRef, a = r.visible && r.unstable_autoFocusOnShow, o = !!(r.animated && r.animating);
  Ma(function() {
    var u = e.current;
    if (process.env.NODE_ENV !== "production" && Oe(!!a && !u, "[reakit/Dialog]", "Can't set initial focus on dialog because `ref` wasn't passed to the dialog element.", "See https://reakit.io/docs/dialog"), !!a && u && !o && !t.some(function(l) {
      return l.current && !l.current.hidden;
    }))
      if (n != null && n.current)
        n.current.focus({
          preventScroll: !0
        });
      else {
        var i = ya(u, !0), s = function() {
          return Ft(u);
        };
        i ? It(i, {
          preventScroll: !0,
          isActive: s
        }) : (It(u, {
          preventScroll: !0,
          isActive: s
        }), process.env.NODE_ENV !== "production" && Oe(u.tabIndex === void 0 || u.tabIndex < 0, "It's recommended to have at least one tabbable element inside dialog. The dialog element has been automatically focused.", "If this is the intended behavior, pass `tabIndex={0}` to the dialog element to disable this warning.", "See https://reakit.io/docs/dialog/#initial-focus", u));
      }
  }, [e, a, o, t, n]);
}
function _u(e, t) {
  var r = X(null);
  return J(function() {
    var n = e.current;
    !n || !t.visible || (r.current = ma(n, bt.__selector));
  }, [e, t.visible]), r;
}
function Kn(e) {
  e.parentNode != null && e.parentNode.removeChild(e);
}
var Xa = "__reakit-focus-trap";
function Ou(e) {
  var t;
  return (t = e.classList) === null || t === void 0 ? void 0 : t.contains(Xa);
}
function Cu(e, t, r) {
  var n = _u(e, r), a = r.visible && r.modal, o = X(null), u = X(null);
  J(function() {
    if (a) {
      var i = n.current;
      if (!i) {
        process.env.NODE_ENV !== "production" && Oe(!0, "Can't trap focus within modal dialog because either `ref` wasn't passed to component or the component wasn't rendered within a portal", "See https://reakit.io/docs/dialog");
        return;
      }
      if (!o.current) {
        var s = ge(i);
        o.current = s.createElement("div"), o.current.className = Xa, o.current.tabIndex = 0, o.current.style.position = "fixed", o.current.setAttribute("aria-hidden", "true");
      }
      return u.current || (u.current = o.current.cloneNode()), i.insertAdjacentElement("beforebegin", o.current), i.insertAdjacentElement("afterend", u.current), function() {
        o.current && Kn(o.current), u.current && Kn(u.current);
      };
    }
  }, [n, a]), J(function() {
    var i = o.current, s = u.current;
    if (!(!a || !i || !s)) {
      var l = function(m) {
        var v = e.current;
        if (!(!v || t.length)) {
          m.preventDefault();
          var c = m.target === s, h = c ? ya(v) : ii(v);
          h ? h.focus() : v.focus();
        }
      };
      return i.addEventListener("focus", l), s.addEventListener("focus", l), function() {
        i.removeEventListener("focus", l), s.removeEventListener("focus", l);
      };
    }
  }, [e, t, a]);
}
function Du(e) {
  var t = e.current;
  if (!t)
    return !1;
  var r = St(t);
  return !r || Le(t, r) ? !1 : !!(Tr(r) || r.getAttribute("data-dialog") === "true");
}
function Tu(e, t, r) {
  var n = r.unstable_autoFocusOnHide && !r.visible, a = !!(r.animated && r.animating);
  Ma(function() {
    var o;
    if (n && !a && !Du(e)) {
      var u = ((o = r.unstable_finalFocusRef) === null || o === void 0 ? void 0 : o.current) || t.current;
      if (u) {
        if (u.id) {
          var i = ge(u), s = i.querySelector("[aria-activedescendant='" + u.id + "']");
          if (s) {
            It(s);
            return;
          }
        }
        It(u);
        return;
      }
      process.env.NODE_ENV !== "production" && Oe(!0, "Can't return focus after closing dialog. Either render a disclosure component or provide a `unstable_finalFocusRef` prop.", "See https://reakit.io/docs/dialog", e.current);
    }
  }, [n, a, e, t]);
}
var Un = /* @__PURE__ */ Ge({});
function Au(e, t) {
  var r = Se(Un), n = ue([]), a = n[0], o = n[1], u = ue(a), i = u[0], s = u[1], l = L(function(f) {
    var p;
    (p = r.addDialog) === null || p === void 0 || p.call(r, f), o(function(y) {
      return [].concat(y, [f]);
    });
  }, [r.addDialog]), d = L(function(f) {
    var p;
    (p = r.removeDialog) === null || p === void 0 || p.call(r, f), o(function(y) {
      return $r(y, f);
    });
  }, [r.removeDialog]), m = L(function(f) {
    var p;
    (p = r.showDialog) === null || p === void 0 || p.call(r, f), s(function(y) {
      return [].concat(y, [f]);
    });
  }, [r.showDialog]), v = L(function(f) {
    var p;
    (p = r.hideDialog) === null || p === void 0 || p.call(r, f), s(function(y) {
      return $r(y, f);
    });
  }, [r.hideDialog]);
  J(function() {
    var f;
    if (!t.unstable_orphan)
      return (f = r.addDialog) === null || f === void 0 || f.call(r, e), function() {
        var p;
        (p = r.removeDialog) === null || p === void 0 || p.call(r, e);
      };
  }, [t.unstable_orphan, r.addDialog, e, r.removeDialog]), J(function() {
    var f;
    if (!t.unstable_orphan && t.modal && t.visible)
      return (f = r.showDialog) === null || f === void 0 || f.call(r, e), function() {
        var p;
        (p = r.hideDialog) === null || p === void 0 || p.call(r, e);
      };
  }, [t.unstable_orphan, t.modal, t.visible, r.showDialog, e, r.hideDialog]), J(function() {
    if (r.visible === !1 && t.visible && !t.unstable_orphan) {
      var f;
      (f = t.hide) === null || f === void 0 || f.call(t);
    }
  }, [r.visible, t.visible, t.hide, t.unstable_orphan]);
  var c = Ne(function() {
    return {
      visible: t.visible,
      addDialog: l,
      removeDialog: d,
      showDialog: m,
      hideDialog: v
    };
  }, [t.visible, l, d, m, v]), h = L(function(f) {
    return /* @__PURE__ */ De(Un.Provider, {
      value: c
    }, f);
  }, [c]);
  return {
    dialogs: a,
    visibleModals: i,
    wrap: h
  };
}
function ku(e) {
  return function(t) {
    var r = t.current;
    if (!r)
      return !1;
    if (Le(r, e))
      return !0;
    var n = ge(r), a = n.querySelector('[data-dialog-ref="' + r.id + '"]');
    return a ? Le(a, e) : !1;
  };
}
function xu(e, t) {
  return Le(t, e);
}
function Ru(e) {
  var t = ge(e);
  return e.tagName === "HTML" ? !0 : Le(t.body, e);
}
function jr(e, t, r, n, a, o, u) {
  var i = ee(a);
  J(function() {
    if (o) {
      var s = function(m) {
        if (i.current) {
          var v = e.current, c = t.current, h = m.target;
          if (!v) {
            process.env.NODE_ENV !== "production" && Oe(!0, "Can't detect events outside dialog because `ref` wasn't passed to component.", "See https://reakit.io/docs/dialog");
            return;
          }
          Ru(h) && (Le(v, h) || c && xu(h, c) || Ou(h) || r.some(ku(h)) || i.current(m));
        }
      }, l = ge(e.current);
      return l.addEventListener(n, s, u), function() {
        return l.removeEventListener(n, s, u);
      };
    }
  }, [e, t, r, n, o, i]);
}
function Iu(e, t) {
  var r = X();
  return J(function() {
    if (t.visible && t.hideOnClickOutside) {
      var n = ge(e.current), a = function(u) {
        r.current = u.target;
      };
      return n.addEventListener("mousedown", a), function() {
        return n.removeEventListener("mousedown", a);
      };
    }
  }, [t.visible, t.hideOnClickOutside, e]), r;
}
function $u(e, t, r, n) {
  var a = Iu(e, n);
  jr(e, t, r, "click", function(o) {
    if (a.current === o.target) {
      var u;
      (u = n.hide) === null || u === void 0 || u.call(n);
    }
  }, n.visible && n.hideOnClickOutside), jr(e, t, r, "focusin", function(o) {
    var u = ge(e.current);
    if (o.target !== u && o.target !== u.body) {
      var i;
      (i = n.hide) === null || i === void 0 || i.call(n);
    }
  }, n.visible && n.hideOnClickOutside);
}
function ju(e, t, r) {
  var n = function(o) {
    return jr(e, {
      current: null
    }, t, o, function(u) {
      u.stopPropagation(), u.preventDefault();
    }, r.visible && r.modal, !0);
  };
  n("mouseover"), n("mousemove"), n("mouseout");
}
function Lu(e, t) {
  J(function() {
    var r = e.current;
    if (!(!t.visible || !r)) {
      var n = new MutationObserver(function(a) {
        var o = a[0].target;
        if (o === r) {
          var u = ge(r), i = St(r);
          (i === u.body || gu(i)) && r.focus();
        }
      });
      return n.observe(r, {
        childList: !0,
        subtree: !0
      }), function() {
        n.disconnect();
      };
    }
  }, [t.visible, e]);
}
function qn(e) {
  return e && e.tagName && e.tagName !== "HTML" && e !== ge(e).body;
}
function Wu(e, t) {
  var r = Vr(function(u) {
    return u + 1;
  }, 0), n = r[0], a = r[1];
  Je(function() {
    var u = e.current;
    t.visible && n && (qn(St(u)) || (process.env.NODE_ENV !== "production" && Oe(!u, "Can't focus dialog after a nested element got blurred because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), u == null || u.focus()));
  }, [n, e]);
  var o = L(function(u) {
    if (t.visible) {
      var i = wa(u);
      qn(i) || a();
    }
  }, [t.visible]);
  return o;
}
var Ga = ye({
  name: "Dialog",
  compose: za,
  keys: bu,
  useOptions: function(t) {
    var r = t.modal, n = r === void 0 ? !0 : r, a = t.hideOnEsc, o = a === void 0 ? !0 : a, u = t.hideOnClickOutside, i = u === void 0 ? !0 : u, s = t.preventBodyScroll, l = s === void 0 ? n : s, d = t.unstable_autoFocusOnShow, m = d === void 0 ? !0 : d, v = t.unstable_autoFocusOnHide, c = v === void 0 ? !0 : v, h = t.unstable_orphan, f = oe(t, ["modal", "hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide", "unstable_orphan"]);
    return w({
      modal: n,
      hideOnEsc: o,
      hideOnClickOutside: i,
      preventBodyScroll: n && l,
      unstable_autoFocusOnShow: m,
      unstable_autoFocusOnHide: c,
      unstable_orphan: n && h
    }, f);
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.onKeyDown, o = r.onBlur, u = r.wrapElement, i = r.tabIndex, s = oe(r, ["ref", "onKeyDown", "onBlur", "wrapElement", "tabIndex"]), l = X(null), d = Se(yu), m = d && d === t.baseId, v = Eu(l, t), c = ee(a), h = ee(o), f = Wu(l, t), p = Au(l, t), y = p.dialogs, M = p.visibleModals, b = p.wrap, g = t.modal && !M.length ? !0 : void 0;
    Su(l, t), Cu(l, M, t), Lu(l, t), Pu(l, y, t), Tu(l, v, t), $u(l, v, y, t), ju(l, y, t);
    var E = L(function(D) {
      var O;
      if ((O = c.current) === null || O === void 0 || O.call(c, D), !D.defaultPrevented && D.key === "Escape" && t.hideOnEsc) {
        if (!t.hide) {
          process.env.NODE_ENV !== "production" && Oe(!0, "`hideOnEsc` prop is truthy, but `hide` prop wasn't provided.", "See https://reakit.io/docs/dialog", l.current);
          return;
        }
        D.stopPropagation(), t.hide();
      }
    }, [t.hideOnEsc, t.hide]), P = L(function(D) {
      var O;
      (O = h.current) === null || O === void 0 || O.call(h, D), f(D);
    }, [f]), _ = L(function(D) {
      return D = b(D), t.modal && !m && (D = /* @__PURE__ */ De(bt, null, D)), u && (D = u(D)), // Prevents Menu > Dialog > Menu to behave as a sub menu
      /* @__PURE__ */ De(Xe.Provider, {
        value: null
      }, D);
    }, [b, t.modal, m, u]);
    return w({
      ref: He(l, n),
      role: "dialog",
      tabIndex: i ?? -1,
      "aria-modal": g,
      "data-dialog": !0,
      onKeyDown: E,
      onBlur: P,
      wrapElement: _
    }, s);
  }
});
pe({
  as: "div",
  useHook: Ga,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Wt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/dialog"), wt(t, r, n);
  }
});
var Fu = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"], Ja = Fu, Nu = Ja, Hu = Nu, Qa = ye({
  name: "Popover",
  compose: Ga,
  keys: Ja,
  useOptions: function(t) {
    var r = t.modal, n = r === void 0 ? !1 : r, a = oe(t, ["modal"]);
    return w({
      modal: n
    }, a);
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.style, o = oe(r, ["ref", "style"]);
    return w({
      ref: He(t.unstable_popoverRef, n),
      style: w(w({}, t.unstable_popoverStyles), a)
    }, o);
  }
});
pe({
  as: "div",
  useHook: Qa,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Wt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/popover"), wt(t, r, n);
  }
});
var Za = ye({
  name: "Disclosure",
  compose: ga,
  keys: Ba,
  useProps: function(t, r) {
    var n = r.onClick, a = r["aria-controls"], o = oe(r, ["onClick", "aria-controls"]), u = ee(n), i = a ? a + " " + t.baseId : t.baseId, s = L(function(l) {
      var d, m;
      (d = u.current) === null || d === void 0 || d.call(u, l), !l.defaultPrevented && ((m = t.toggle) === null || m === void 0 || m.call(t));
    }, [t.toggle]);
    return w({
      "aria-expanded": !!t.visible,
      "aria-controls": i,
      onClick: s
    }, o);
  }
}), Bu = pe({
  as: "button",
  memo: !0,
  useHook: Za
}), eo = ye({
  name: "DialogDisclosure",
  compose: Za,
  keys: wu,
  useProps: function(t, r) {
    var n = r.ref, a = r.onClick, o = oe(r, ["ref", "onClick"]), u = X(null), i = ee(a), s = ue(!1), l = s[0], d = s[1], m = t.unstable_disclosureRef;
    Je(function() {
      var c = u.current;
      process.env.NODE_ENV !== "production" && Oe(!c, "Can't determine whether the element is the current disclosure because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog"), m && !m.current && (m.current = c);
      var h = !(m != null && m.current) || m.current === c;
      d(!!t.visible && h);
    }, [t.visible, m]);
    var v = L(function(c) {
      var h;
      (h = i.current) === null || h === void 0 || h.call(i, c), !c.defaultPrevented && m && (m.current = c.currentTarget);
    }, [m]);
    return w({
      ref: He(u, n),
      "aria-haspopup": "dialog",
      "aria-expanded": l,
      onClick: v
    }, o);
  }
});
pe({
  as: "button",
  memo: !0,
  useHook: eo
});
var zu = ["baseId", "unstable_idCountRef", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "unstable_values", "setBaseId", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget", "unstable_setValue"], Vu = [].concat(zu, ["visible", "animated", "animating", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"]), to = Vu, Ku = to, ro = Ku, no = ro, Uu = no, qu = Uu, Yu = qu;
function Xu(e, t, r) {
  var n = t.items, a = n === void 0 ? [] : n, o = t.move;
  r === void 0 && (r = 500);
  var u = ue(""), i = u[0], s = u[1];
  J(function() {
    if (i) {
      var l = setTimeout(function() {
        return s("");
      }, r), d = a.find(function(m) {
        return !!(m.ref.current && m.ref.current.textContent && m.ref.current.textContent.toLowerCase().startsWith(i));
      });
      return d && o(d.id), function() {
        return clearTimeout(l);
      };
    }
  }, [i, a, o, r]), J(function() {
    var l = e.current;
    if (l) {
      var d = function(v) {
        var c;
        if (!(v.key.length > 1) && !v.shiftKey && !v.metaKey && !v.ctrlKey && !v.altKey) {
          var h = v.target, f = (c = h.getAttribute) === null || c === void 0 ? void 0 : c.call(h, "role"), p = h === l, y = f && f.indexOf("menuitem") !== -1 && ma(h, "[role=menu],[role=menubar]") === l;
          !p && !y || /^[a-z0-9_-]$/i.test(v.key) && (v.stopPropagation(), v.preventDefault(), s(function(M) {
            return "" + M + v.key;
          }));
        }
      };
      return l.addEventListener("keydown", d), function() {
        return l.removeEventListener("keydown", d);
      };
    }
  }, [e, s]);
}
var ao = ye({
  name: "MenuBar",
  compose: _a,
  keys: ro,
  useProps: function(t, r) {
    var n = r.ref, a = r.wrapElement, o = r.role, u = o === void 0 ? "menubar" : o, i = oe(r, ["ref", "wrapElement", "role"]), s = X(null), l = lu(s, u, t);
    Xu(s, t);
    var d = L(function(m) {
      return m = l(m), a ? a(m) : m;
    }, [l, a]);
    return w({
      ref: He(s, n),
      role: u,
      "aria-orientation": t.orientation,
      wrapElement: d
    }, i);
  }
});
pe({
  as: "div",
  useHook: ao,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Wt(!r["aria-label"] && !r["aria-labelledby"] && r.role !== "menubar", "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), wt(t, r, n);
  }
});
function Gu(e) {
  return Ne(function() {
    var t;
    return e == null || (t = e.split("-")) === null || t === void 0 ? void 0 : t[0];
  }, [e]);
}
var Ju = ye({
  name: "Menu",
  compose: [ao, Qa],
  keys: to,
  useOptions: function(t) {
    var r = Se(Xe), n = (r == null ? void 0 : r.role) === "menubar";
    return w(w({
      unstable_autoFocusOnHide: !n,
      modal: !1
    }, t), {}, {
      // will be handled by MenuButton
      unstable_autoFocusOnShow: !1,
      // will be handled differently from usePopover/useDialog
      hideOnEsc: !1
    });
  },
  useProps: function(t, r) {
    for (var n = r.onKeyDown, a = oe(r, ["onKeyDown"]), o = ee(n), u = Se(Xe), i = !!u, s = u; s && s.role !== "menubar"; )
      s = s.parent;
    var l = s || {}, d = l.next, m = l.previous, v = l.orientation, c = v === "horizontal", h = Gu(t.placement), f = L(function(p) {
      var y;
      if ((y = o.current) === null || y === void 0 || y.call(o, p), !p.defaultPrevented) {
        if (p.key === "Escape") {
          var M;
          i || p.stopPropagation(), (M = t.hide) === null || M === void 0 || M.call(t);
        } else if (i && !qr(p)) {
          var b = c && h !== "left" ? d : h === "left" && t.hide, g = c && h !== "right" ? m : h === "right" && t.hide, E = {
            ArrowRight: b,
            ArrowLeft: g
          }, P = E[p.key];
          P && (p.preventDefault(), i && p.stopPropagation(), P());
        }
      }
    }, [i, c, d, m, h, t.hide]);
    return w({
      role: "menu",
      onKeyDown: f
    }, a);
  }
}), Qu = pe({
  as: "div",
  useHook: Ju,
  useCreateElement: function(t, r, n) {
    return process.env.NODE_ENV !== "production" && Wt(!r["aria-label"] && !r["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu"), wt(t, r, n);
  }
});
function Zu(e) {
  e === void 0 && (e = {});
  var t = ut(e), r = t.orientation, n = r === void 0 ? "horizontal" : r, a = t.unstable_values, o = a === void 0 ? {} : a, u = oe(t, ["orientation", "unstable_values"]), i = ue(o), s = i[0], l = i[1], d = Xi(w(w({}, u), {}, {
    orientation: n
  }));
  return w(w({}, d), {}, {
    unstable_values: s,
    unstable_setValue: L(function(m, v) {
      l(function(c) {
        var h;
        return w(w({}, c), {}, (h = {}, h[m] = typeof v == "function" ? v(c) : v, h));
      });
    }, [])
  });
}
var Lr = ye({
  name: "PopoverDisclosure",
  compose: eo,
  keys: Hu,
  useProps: function(t, r) {
    var n = r.ref, a = oe(r, ["ref"]);
    return w({
      ref: He(t.unstable_referenceRef, n)
    }, a);
  }
});
pe({
  as: "button",
  memo: !0,
  useHook: Lr
});
function nn(e) {
  var t = e == null ? void 0 : e.find(function(r) {
    return r.current && !r.current.hidden;
  });
  return t == null ? void 0 : t.current;
}
var el = function() {
}, tl = ye({
  name: "MenuButton",
  compose: Lr,
  keys: no,
  propsAreEqual: function(t, r) {
    t.unstable_popoverStyles, t.unstable_arrowStyles, t.currentId, t.unstable_moves;
    var n = oe(t, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.currentId, r.unstable_moves;
    var a = oe(r, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
    return Lr.unstable_propsAreEqual(n, a);
  },
  useProps: function(t, r) {
    var n = r.ref, a = r.onClick, o = r.onKeyDown, u = r.onFocus, i = r.onMouseEnter, s = r.onMouseDown, l = oe(r, ["ref", "onClick", "onKeyDown", "onFocus", "onMouseEnter", "onMouseDown"]), d = Se(Xe), m = X(null), v = X(!1), c = t.placement.split("-"), h = c[0], f = !!d, p = (d == null ? void 0 : d.role) === "menubar", y = t.disabled || l["aria-disabled"], M = ee(a), b = ee(o), g = ee(u), E = ee(i), P = ee(s), _ = L(function(C) {
      var T;
      if (C.key === "Escape") {
        var j;
        (j = t.hide) === null || j === void 0 || j.call(t);
      } else if (!y) {
        var A = t.first && function() {
          return setTimeout(t.first);
        }, $ = t.last && function() {
          return setTimeout(t.last);
        }, Q = {
          Enter: A,
          " ": A,
          ArrowUp: (h === "top" || h === "bottom") && $,
          ArrowRight: h === "right" && A,
          ArrowDown: (h === "bottom" || h === "top") && A,
          ArrowLeft: h === "left" && A
        }, te = Q[C.key];
        if (te) {
          var re;
          C.preventDefault(), C.stopPropagation(), (re = t.show) === null || re === void 0 || re.call(t), te();
          return;
        }
      }
      (T = b.current) === null || T === void 0 || T.call(b, C);
    }, [y, t.hide, t.first, t.last, h, t.show]), D = L(function(C) {
      var T;
      if ((T = E.current) === null || T === void 0 || T.call(E, C), !C.defaultPrevented && d) {
        var j = C.currentTarget;
        p ? nn(d.children) && j.focus() : setTimeout(function() {
          if (Ft(j)) {
            var A;
            (A = t.show) === null || A === void 0 || A.call(t);
          }
        }, 200);
      }
    }, [d, p, t.show]), O = L(function(C) {
      var T;
      v.current = !0, (T = P.current) === null || T === void 0 || T.call(P, C);
    }, []), S = L(function(C) {
      var T;
      if ((T = g.current) === null || T === void 0 || T.call(g, C), !C.defaultPrevented && !y && p && !v.current) {
        var j;
        (j = t.show) === null || j === void 0 || j.call(t);
      }
    }, [p, y, t.show]), x = L(function(C) {
      var T;
      if ((T = M.current) === null || T === void 0 || T.call(M, C), !C.defaultPrevented) {
        if (f && !p) {
          var j;
          (j = t.show) === null || j === void 0 || j.call(t);
        } else {
          var A;
          if ((A = t.toggle) === null || A === void 0 || A.call(t), v.current && !p && !t.visible) {
            var $;
            ($ = t.move) === null || $ === void 0 || $.call(t, null);
          }
        }
        v.current = !1;
      }
    }, [f, p, t.show, t.toggle, t.visible, t.move]);
    return w({
      ref: He(m, n),
      "aria-haspopup": "menu",
      onKeyDown: _,
      onMouseEnter: D,
      onMouseDown: O,
      onFocus: S,
      onClick: x
    }, l);
  },
  useComposeOptions: function(t) {
    return w(w({}, t), {}, {
      // Toggling is handled by MenuButton
      toggle: el
    });
  }
}), rl = pe({
  as: "button",
  memo: !0,
  useHook: tl
});
function qt(e, t, r) {
  return Math.abs((e.x * (t.y - r.y) + t.x * (r.y - e.y) + r.x * (e.y - t.y)) / 2);
}
function nl(e, t, r, n) {
  var a = qt(t, r, n), o = qt(e, r, n), u = qt(t, e, n), i = qt(t, r, e);
  return a === o + u + i;
}
function al(e, t) {
  var r = t.getBoundingClientRect(), n = r.top, a = r.right, o = r.bottom, u = r.left, i = u > e.clientX ? u : a;
  return [{
    x: i,
    y: n
  }, {
    x: i,
    y: o
  }];
}
function ol(e, t) {
  var r = ee(t), n = X(null), a = X(null), o = X(null), u = X(0), i = X(0), s = L(function(m) {
    if (e != null && e.children.length) {
      a.current = null, o.current = null;
      var v = nn(e.children);
      if (v) {
        var c = al(m, v);
        a.current = c[0], o.current = c[1];
      }
    }
  }, [e == null ? void 0 : e.children]), l = L(function(m) {
    var v = u.current !== m.clientX || i.current !== m.clientY;
    if (m.isTrusted && !v)
      return !0;
    var c = Math.abs(u.current - m.clientX);
    u.current = m.clientX, i.current = m.clientY;
    var h = function() {
      return a.current && o.current;
    };
    return m.type === "mouseleave" && !h() && s(m), h() ? c && n.current && nl({
      x: m.clientX,
      y: m.clientY
    }, n.current, a.current, o.current) : !1;
  }, [s]), d = L(function(m) {
    var v;
    (v = r.current) === null || v === void 0 || v.call(r, m), !m.defaultPrevented && (e == null ? void 0 : e.role) !== "menubar" && (n.current = {
      x: m.clientX,
      y: m.clientY
    }, s(m));
  }, [e == null ? void 0 : e.role, s]);
  return {
    onMouseEnter: d,
    isMouseInTransitToSubmenu: l
  };
}
function an(e) {
  var t = e.relatedTarget;
  return (t == null ? void 0 : t.nodeType) === Node.ELEMENT_NODE ? e.relatedTarget : e.toElement || null;
}
function il(e) {
  var t = an(e);
  return t ? Le(e.currentTarget, t) : !1;
}
function sl(e, t) {
  if (!(t != null && t.length))
    return !1;
  var r = an(e);
  if (!r)
    return !1;
  var n = nn(t);
  return n && Le(n, r);
}
function ul(e, t) {
  var r = an(e);
  return r ? t == null ? void 0 : t.some(function(n) {
    return n.ref.current && Le(n.ref.current, r);
  }) : !1;
}
var ll = ye({
  name: "MenuItem",
  compose: kr,
  keys: Yu,
  propsAreEqual: function(t, r) {
    t.unstable_popoverStyles, t.unstable_arrowStyles, t.visible;
    var n = oe(t, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    r.unstable_popoverStyles, r.unstable_arrowStyles, r.visible;
    var a = oe(r, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
    return kr.unstable_propsAreEqual(n, a);
  },
  useProps: function(t, r) {
    var n = r.onMouseEnter, a = r.onMouseMove, o = r.onMouseLeave, u = oe(r, ["onMouseEnter", "onMouseMove", "onMouseLeave"]), i = Se(Xe), s = ee(a), l = ee(o), d = ol(i, n), m = d.onMouseEnter, v = d.isMouseInTransitToSubmenu, c = L(function(f) {
      var p, y;
      (p = s.current) === null || p === void 0 || p.call(s, f), !f.defaultPrevented && (i == null ? void 0 : i.role) !== "menubar" && (v(f) || Ft(f.currentTarget) || (y = t.move) === null || y === void 0 || y.call(t, f.currentTarget.id));
    }, [t.move]), h = L(function(f) {
      var p;
      if ((p = l.current) === null || p === void 0 || p.call(l, f), !f.defaultPrevented && (i == null ? void 0 : i.role) !== "menubar" && !il(f) && !sl(f, i == null ? void 0 : i.children) && !ul(f, t.items)) {
        var y;
        if (v(f))
          return;
        (y = t.move) === null || y === void 0 || y.call(t, null);
      }
    }, [i == null ? void 0 : i.role, i == null ? void 0 : i.children, t.items, t.move]);
    return w({
      role: "menuitem",
      onMouseEnter: m,
      onMouseMove: c,
      onMouseLeave: h
    }, u);
  }
}), dl = pe({
  as: "button",
  memo: !0,
  useHook: ll
});
function cl(e) {
  e === void 0 && (e = {});
  var t = Se(Xe), r = ut(e), n = r.orientation, a = n === void 0 ? "vertical" : n, o = r.gutter, u = o === void 0 ? 0 : o, i = oe(r, ["orientation", "gutter"]), s = i.placement || (t && t.orientation === "vertical" ? "right-start" : "bottom-start"), l = Zu(w(w({}, i), {}, {
    orientation: a
  })), d = ou(w(w({}, i), {}, {
    placement: s,
    gutter: u
  }));
  return J(function() {
    d.visible || l.reset();
  }, [d.visible, l.reset]), w(w({}, l), d);
}
function fl(e) {
  var t = e.children, r = e.unstable_system;
  return /* @__PURE__ */ De(Kr.Provider, {
    value: r
  }, t);
}
var ml = {};
function vl(e) {
  var t = e.unstable_prefix, r = e.unstable_system, n = r === void 0 ? ml : r, a = e.children;
  return /* @__PURE__ */ De(xi, {
    prefix: t
  }, /* @__PURE__ */ De(fl, {
    unstable_system: n
  }, a));
}
function oo(e = {}) {
  var t;
  return new Io.QueryClient({
    ...e,
    defaultOptions: {
      ...e.defaultOptions,
      queries: {
        retry: 3,
        retryDelay(r) {
          return r * 100;
        },
        ...(t = e.defaultOptions) == null ? void 0 : t.queries
      }
    }
  });
}
const hl = ({ children: e, i18nInstance: t }) => /* @__PURE__ */ W(Wo, { i18n: t, children: e }), on = (e = "label") => {
  const t = Array.isArray(e) ? e : [e];
  return Fo(t);
};
var pl = function() {
  const t = Array.prototype.slice.call(arguments).filter(Boolean), r = {}, n = [];
  t.forEach((o) => {
    (o ? o.split(" ") : []).forEach((i) => {
      if (i.startsWith("atm_")) {
        const [, s] = i.split("_");
        r[s] = i;
      } else
        n.push(i);
    });
  });
  const a = [];
  for (const o in r)
    Object.prototype.hasOwnProperty.call(r, o) && a.push(r[o]);
  return a.push(...n), a.join(" ");
}, or = pl;
const yl = "defaultAnimation_d16p72kf";
Zt(function({ animationClass: t = !0, children: r, header: n, id: a, onToggle: o, visible: u = !1 }, i) {
  const s = t === !0 || typeof t == "string" && t !== "", l = Ha({
    animated: s ? 300 : !1,
    baseId: a.toString(),
    visible: u
  }), d = typeof t == "string" && t !== "" ? t : yl, m = X(l.visible);
  return J(() => {
    m.current !== l.visible && (m.current = l.visible, o == null || o(l.visible));
  }, [l.visible, o]), /* @__PURE__ */ je(ua, { children: [
    /* @__PURE__ */ W(Bu, { ...l, ref: i, ...n.props, children: (v) => ko(n, v) }),
    /* @__PURE__ */ W(
      uu,
      {
        ...l,
        className: or(s && d),
        ...u ? { "data-enter": !0 } : {},
        children: r
      }
    )
  ] });
});
function gl(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var bl = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, yr = /* @__PURE__ */ gl(
  function(e) {
    return bl.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ml = (e) => e.toUpperCase() === e, wl = (e) => (t) => e.indexOf(t) === -1, io = (e, t) => {
  const r = {};
  return Object.keys(e).filter(wl(t)).forEach((n) => {
    r[n] = e[n];
  }), r;
};
function El(e, t, r) {
  const n = io(t, r);
  if (!e) {
    const a = typeof yr == "function" ? { default: yr } : yr;
    Object.keys(n).forEach((o) => {
      a.default(o) || delete n[o];
    });
  }
  return n;
}
var Sl = (e, t) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof e == "number" && isFinite(e))
      return;
    const r = typeof e == "object" ? JSON.stringify(e) : String(e);
    console.warn(
      `An interpolation evaluated to '${r}' in the component '${t}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, Pl = 0;
function Yn(e) {
  let t = "";
  return process.env.NODE_ENV === "test" && (t += `mocked-styled-${Pl++}`, e && e.__wyw_meta && e.__wyw_meta.className && (t += ` ${e.__wyw_meta.className}`)), (r) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(r))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const n = (o, u) => {
      const { as: i = e, class: s = t } = o, l = r.propsAsIs === void 0 ? !(typeof i == "string" && i.indexOf("-") === -1 && !Ml(i[0])) : r.propsAsIs, d = El(l, o, [
        "as",
        "class"
      ]);
      d.ref = u, d.className = r.atomic ? or(r.class, d.className || s) : or(d.className || s, r.class);
      const { vars: m } = r;
      if (m) {
        const v = {};
        for (const f in m) {
          const p = m[f], y = p[0], M = p[1] || "", b = typeof y == "function" ? y(o) : y;
          Sl(b, r.name), v[`--${f}`] = `${b}${M}`;
        }
        const c = d.style || {}, h = Object.keys(c);
        h.length > 0 && h.forEach((f) => {
          v[f] = c[f];
        }), d.style = v;
      }
      return e.__wyw_meta && e !== i ? (d.as = i, De(e, d)) : De(i, d);
    }, a = Zt ? Zt(n) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (o) => {
        const u = io(o, ["innerRef"]);
        return n(u, o.innerRef);
      }
    );
    return a.displayName = r.name, a.__wyw_meta = {
      className: r.class || t,
      extends: e
    }, a;
  };
}
var so = process.env.NODE_ENV !== "production" ? new Proxy(Yn, {
  get(e, t) {
    return e(t);
  }
}) : Yn;
const _l = () => /* @__PURE__ */ je("svg", { fill: "none", height: "11", viewBox: "0 0 11 11", width: "11", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ W("circle", { cx: "5.5", cy: "5.5", r: "5", stroke: "#9D9DA3" }),
  /* @__PURE__ */ W(
    "path",
    {
      d: "M5.32 7.68c-.378 0-.683.314-.683.691 0 .368.296.692.682.692.386 0 .692-.324.692-.692 0-.377-.315-.691-.692-.691zM5.436 2.444c-1.212 0-1.769.719-1.769 1.204 0 .35.296.511.539.511.485 0 .287-.691 1.203-.691.449 0 .808.198.808.61 0 .485-.503.764-.799 1.015-.26.225-.602.593-.602 1.365 0 .467.126.602.494.602.44 0 .53-.198.53-.368 0-.467.009-.737.503-1.123.242-.188 1.006-.799 1.006-1.643s-.764-1.482-1.913-1.482z",
      fill: "#9D9DA3"
    }
  )
] });
const Ol = /* @__PURE__ */ so("div")({
  name: "NoContentWrapper",
  class: "NoContentWrapper_n20pplq",
  propsAsIs: !1
}), Cl = /* @__PURE__ */ so("p")({
  name: "NoContentText",
  class: "NoContentText_n102xecg",
  propsAsIs: !1
}), Dl = ({ children: e }) => /* @__PURE__ */ je(Ol, { children: [
  /* @__PURE__ */ W(_l, {}),
  /* @__PURE__ */ W(Cl, { "data-testid": "no-content-text", children: e })
] });
var Ot = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Tl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var uo = { exports: {} };
(function(e, t) {
  (function(n, a) {
    e.exports = a(it);
  })(Ot, (r) => (
    /******/
    (() => {
      var n = {
        /***/
        "./node_modules/css-mediaquery/index.js": (
          /*!**********************************************!*\
            !*** ./node_modules/css-mediaquery/index.js ***!
            \**********************************************/
          /***/
          (i, s) => {
            s.match = h, s.parse = f;
            var l = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, d = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, m = /^(?:(min|max)-)?(.+)/, v = /(em|rem|px|cm|mm|in|pt|pc)?$/, c = /(dpi|dpcm|dppx)?$/;
            function h(b, g) {
              return f(b).some(function(E) {
                var P = E.inverse, _ = E.type === "all" || g.type === E.type;
                if (_ && P || !(_ || P))
                  return !1;
                var D = E.expressions.every(function(O) {
                  var S = O.feature, x = O.modifier, C = O.value, T = g[S];
                  if (!T)
                    return !1;
                  switch (S) {
                    case "orientation":
                    case "scan":
                      return T.toLowerCase() === C.toLowerCase();
                    case "width":
                    case "height":
                    case "device-width":
                    case "device-height":
                      C = M(C), T = M(T);
                      break;
                    case "resolution":
                      C = y(C), T = y(T);
                      break;
                    case "aspect-ratio":
                    case "device-aspect-ratio":
                    case /* Deprecated */
                    "device-pixel-ratio":
                      C = p(C), T = p(T);
                      break;
                    case "grid":
                    case "color":
                    case "color-index":
                    case "monochrome":
                      C = parseInt(C, 10) || 1, T = parseInt(T, 10) || 0;
                      break;
                  }
                  switch (x) {
                    case "min":
                      return T >= C;
                    case "max":
                      return T <= C;
                    default:
                      return T === C;
                  }
                });
                return D && !P || !D && P;
              });
            }
            function f(b) {
              return b.split(",").map(function(g) {
                g = g.trim();
                var E = g.match(l), P = E[1], _ = E[2], D = E[3] || "", O = {};
                return O.inverse = !!P && P.toLowerCase() === "not", O.type = _ ? _.toLowerCase() : "all", D = D.match(/\([^\)]+\)/g) || [], O.expressions = D.map(function(S) {
                  var x = S.match(d), C = x[1].toLowerCase().match(m);
                  return {
                    modifier: C[1],
                    feature: C[2],
                    value: x[2]
                  };
                }), O;
              });
            }
            function p(b) {
              var g = Number(b), E;
              return g || (E = b.match(/^(\d+)\s*\/\s*(\d+)$/), g = E[1] / E[2]), g;
            }
            function y(b) {
              var g = parseFloat(b), E = String(b).match(c)[1];
              switch (E) {
                case "dpcm":
                  return g / 2.54;
                case "dppx":
                  return g * 96;
                default:
                  return g;
              }
            }
            function M(b) {
              var g = parseFloat(b), E = String(b).match(v)[1];
              switch (E) {
                case "em":
                  return g * 16;
                case "rem":
                  return g * 16;
                case "cm":
                  return g * 96 / 2.54;
                case "mm":
                  return g * 96 / 2.54 / 10;
                case "in":
                  return g * 96;
                case "pt":
                  return g * 72;
                case "pc":
                  return g * 72 / 12;
                default:
                  return g;
              }
            }
          }
        ),
        /***/
        "./node_modules/hyphenate-style-name/index.js": (
          /*!****************************************************!*\
            !*** ./node_modules/hyphenate-style-name/index.js ***!
            \****************************************************/
          /***/
          (i, s, l) => {
            l.r(s), l.d(s, {
              /* harmony export */
              default: () => f
              /* harmony export */
            });
            var d = /[A-Z]/g, m = /^ms-/, v = {};
            function c(p) {
              return "-" + p.toLowerCase();
            }
            function h(p) {
              if (v.hasOwnProperty(p))
                return v[p];
              var y = p.replace(d, c);
              return v[p] = m.test(y) ? "-" + y : y;
            }
            const f = h;
          }
        ),
        /***/
        "./node_modules/matchmediaquery/index.js": (
          /*!***********************************************!*\
            !*** ./node_modules/matchmediaquery/index.js ***!
            \***********************************************/
          /***/
          (i, s, l) => {
            var d = l(
              /*! css-mediaquery */
              "./node_modules/css-mediaquery/index.js"
            ).match, m = typeof window < "u" ? window.matchMedia : null;
            function v(h, f, p) {
              var y = this;
              if (m && !p) {
                var M = m.call(window, h);
                this.matches = M.matches, this.media = M.media, M.addListener(E);
              } else
                this.matches = d(h, f), this.media = h;
              this.addListener = b, this.removeListener = g, this.dispose = P;
              function b(_) {
                M && M.addListener(_);
              }
              function g(_) {
                M && M.removeListener(_);
              }
              function E(_) {
                y.matches = _.matches, y.media = _.media;
              }
              function P() {
                M && M.removeListener(E);
              }
            }
            function c(h, f, p) {
              return new v(h, f, p);
            }
            i.exports = c;
          }
        ),
        /***/
        "./node_modules/object-assign/index.js": (
          /*!*********************************************!*\
            !*** ./node_modules/object-assign/index.js ***!
            \*********************************************/
          /***/
          (i) => {
            /*
            object-assign
            (c) Sindre Sorhus
            @license MIT
            */
            var s = Object.getOwnPropertySymbols, l = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
            function m(c) {
              if (c == null)
                throw new TypeError("Object.assign cannot be called with null or undefined");
              return Object(c);
            }
            function v() {
              try {
                if (!Object.assign)
                  return !1;
                var c = new String("abc");
                if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
                  return !1;
                for (var h = {}, f = 0; f < 10; f++)
                  h["_" + String.fromCharCode(f)] = f;
                var p = Object.getOwnPropertyNames(h).map(function(M) {
                  return h[M];
                });
                if (p.join("") !== "0123456789")
                  return !1;
                var y = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(M) {
                  y[M] = M;
                }), Object.keys(Object.assign({}, y)).join("") === "abcdefghijklmnopqrst";
              } catch {
                return !1;
              }
            }
            i.exports = v() ? Object.assign : function(c, h) {
              for (var f, p = m(c), y, M = 1; M < arguments.length; M++) {
                f = Object(arguments[M]);
                for (var b in f)
                  l.call(f, b) && (p[b] = f[b]);
                if (s) {
                  y = s(f);
                  for (var g = 0; g < y.length; g++)
                    d.call(f, y[g]) && (p[y[g]] = f[y[g]]);
                }
              }
              return p;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/checkPropTypes.js": (
          /*!***************************************************!*\
            !*** ./node_modules/prop-types/checkPropTypes.js ***!
            \***************************************************/
          /***/
          (i, s, l) => {
            var d = function() {
            };
            {
              var m = l(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), v = {}, c = l(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              );
              d = function(f) {
                var p = "Warning: " + f;
                typeof console < "u" && console.error(p);
                try {
                  throw new Error(p);
                } catch {
                }
              };
            }
            function h(f, p, y, M, b) {
              for (var g in f)
                if (c(f, g)) {
                  var E;
                  try {
                    if (typeof f[g] != "function") {
                      var P = Error(
                        (M || "React class") + ": " + y + " type `" + g + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof f[g] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                      );
                      throw P.name = "Invariant Violation", P;
                    }
                    E = f[g](p, g, M, y, null, m);
                  } catch (D) {
                    E = D;
                  }
                  if (E && !(E instanceof Error) && d(
                    (M || "React class") + ": type specification of " + y + " `" + g + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof E + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                  ), E instanceof Error && !(E.message in v)) {
                    v[E.message] = !0;
                    var _ = b ? b() : "";
                    d(
                      "Failed " + y + " type: " + E.message + (_ ?? "")
                    );
                  }
                }
            }
            h.resetWarningCache = function() {
              v = {};
            }, i.exports = h;
          }
        ),
        /***/
        "./node_modules/prop-types/factoryWithTypeCheckers.js": (
          /*!************************************************************!*\
            !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
            \************************************************************/
          /***/
          (i, s, l) => {
            var d = l(
              /*! react-is */
              "./node_modules/react-is/index.js"
            ), m = l(
              /*! object-assign */
              "./node_modules/object-assign/index.js"
            ), v = l(
              /*! ./lib/ReactPropTypesSecret */
              "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
            ), c = l(
              /*! ./lib/has */
              "./node_modules/prop-types/lib/has.js"
            ), h = l(
              /*! ./checkPropTypes */
              "./node_modules/prop-types/checkPropTypes.js"
            ), f = function() {
            };
            f = function(y) {
              var M = "Warning: " + y;
              typeof console < "u" && console.error(M);
              try {
                throw new Error(M);
              } catch {
              }
            };
            function p() {
              return null;
            }
            i.exports = function(y, M) {
              var b = typeof Symbol == "function" && Symbol.iterator, g = "@@iterator";
              function E(k) {
                var I = k && (b && k[b] || k[g]);
                if (typeof I == "function")
                  return I;
              }
              var P = "<<anonymous>>", _ = {
                array: x("array"),
                bigint: x("bigint"),
                bool: x("boolean"),
                func: x("function"),
                number: x("number"),
                object: x("object"),
                string: x("string"),
                symbol: x("symbol"),
                any: C(),
                arrayOf: T,
                element: j(),
                elementType: A(),
                instanceOf: $,
                node: ce(),
                objectOf: te,
                oneOf: Q,
                oneOfType: re,
                shape: se,
                exact: be
              };
              function D(k, I) {
                return k === I ? k !== 0 || 1 / k === 1 / I : k !== k && I !== I;
              }
              function O(k, I) {
                this.message = k, this.data = I && typeof I == "object" ? I : {}, this.stack = "";
              }
              O.prototype = Error.prototype;
              function S(k) {
                var I = {}, q = 0;
                function z(G, V, K, Y, ae, U, R) {
                  if (Y = Y || P, U = U || K, R !== v) {
                    if (M) {
                      var le = new Error(
                        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                      );
                      throw le.name = "Invariant Violation", le;
                    } else if (typeof console < "u") {
                      var we = Y + ":" + K;
                      !I[we] && // Avoid spamming the console because they are often not actionable except for lib authors
                      q < 3 && (f(
                        "You are manually calling a React.PropTypes validation function for the `" + U + "` prop on `" + Y + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                      ), I[we] = !0, q++);
                    }
                  }
                  return V[K] == null ? G ? V[K] === null ? new O("The " + ae + " `" + U + "` is marked as required " + ("in `" + Y + "`, but its value is `null`.")) : new O("The " + ae + " `" + U + "` is marked as required in " + ("`" + Y + "`, but its value is `undefined`.")) : null : k(V, K, Y, ae, U);
                }
                var B = z.bind(null, !1);
                return B.isRequired = z.bind(null, !0), B;
              }
              function x(k) {
                function I(q, z, B, G, V, K) {
                  var Y = q[z], ae = Z(Y);
                  if (ae !== k) {
                    var U = Me(Y);
                    return new O(
                      "Invalid " + G + " `" + V + "` of type " + ("`" + U + "` supplied to `" + B + "`, expected ") + ("`" + k + "`."),
                      { expectedType: k }
                    );
                  }
                  return null;
                }
                return S(I);
              }
              function C() {
                return S(p);
              }
              function T(k) {
                function I(q, z, B, G, V) {
                  if (typeof k != "function")
                    return new O("Property `" + V + "` of component `" + B + "` has invalid PropType notation inside arrayOf.");
                  var K = q[z];
                  if (!Array.isArray(K)) {
                    var Y = Z(K);
                    return new O("Invalid " + G + " `" + V + "` of type " + ("`" + Y + "` supplied to `" + B + "`, expected an array."));
                  }
                  for (var ae = 0; ae < K.length; ae++) {
                    var U = k(K, ae, B, G, V + "[" + ae + "]", v);
                    if (U instanceof Error)
                      return U;
                  }
                  return null;
                }
                return S(I);
              }
              function j() {
                function k(I, q, z, B, G) {
                  var V = I[q];
                  if (!y(V)) {
                    var K = Z(V);
                    return new O("Invalid " + B + " `" + G + "` of type " + ("`" + K + "` supplied to `" + z + "`, expected a single ReactElement."));
                  }
                  return null;
                }
                return S(k);
              }
              function A() {
                function k(I, q, z, B, G) {
                  var V = I[q];
                  if (!d.isValidElementType(V)) {
                    var K = Z(V);
                    return new O("Invalid " + B + " `" + G + "` of type " + ("`" + K + "` supplied to `" + z + "`, expected a single ReactElement type."));
                  }
                  return null;
                }
                return S(k);
              }
              function $(k) {
                function I(q, z, B, G, V) {
                  if (!(q[z] instanceof k)) {
                    var K = k.name || P, Y = Ee(q[z]);
                    return new O("Invalid " + G + " `" + V + "` of type " + ("`" + Y + "` supplied to `" + B + "`, expected ") + ("instance of `" + K + "`."));
                  }
                  return null;
                }
                return S(I);
              }
              function Q(k) {
                if (!Array.isArray(k))
                  return arguments.length > 1 ? f(
                    "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                  ) : f("Invalid argument supplied to oneOf, expected an array."), p;
                function I(q, z, B, G, V) {
                  for (var K = q[z], Y = 0; Y < k.length; Y++)
                    if (D(K, k[Y]))
                      return null;
                  var ae = JSON.stringify(k, function(R, le) {
                    var we = Me(le);
                    return we === "symbol" ? String(le) : le;
                  });
                  return new O("Invalid " + G + " `" + V + "` of value `" + String(K) + "` " + ("supplied to `" + B + "`, expected one of " + ae + "."));
                }
                return S(I);
              }
              function te(k) {
                function I(q, z, B, G, V) {
                  if (typeof k != "function")
                    return new O("Property `" + V + "` of component `" + B + "` has invalid PropType notation inside objectOf.");
                  var K = q[z], Y = Z(K);
                  if (Y !== "object")
                    return new O("Invalid " + G + " `" + V + "` of type " + ("`" + Y + "` supplied to `" + B + "`, expected an object."));
                  for (var ae in K)
                    if (c(K, ae)) {
                      var U = k(K, ae, B, G, V + "." + ae, v);
                      if (U instanceof Error)
                        return U;
                    }
                  return null;
                }
                return S(I);
              }
              function re(k) {
                if (!Array.isArray(k))
                  return f("Invalid argument supplied to oneOfType, expected an instance of array."), p;
                for (var I = 0; I < k.length; I++) {
                  var q = k[I];
                  if (typeof q != "function")
                    return f(
                      "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + he(q) + " at index " + I + "."
                    ), p;
                }
                function z(B, G, V, K, Y) {
                  for (var ae = [], U = 0; U < k.length; U++) {
                    var R = k[U], le = R(B, G, V, K, Y, v);
                    if (le == null)
                      return null;
                    le.data && c(le.data, "expectedType") && ae.push(le.data.expectedType);
                  }
                  var we = ae.length > 0 ? ", expected one of type [" + ae.join(", ") + "]" : "";
                  return new O("Invalid " + K + " `" + Y + "` supplied to " + ("`" + V + "`" + we + "."));
                }
                return S(z);
              }
              function ce() {
                function k(I, q, z, B, G) {
                  return fe(I[q]) ? null : new O("Invalid " + B + " `" + G + "` supplied to " + ("`" + z + "`, expected a ReactNode."));
                }
                return S(k);
              }
              function ie(k, I, q, z, B) {
                return new O(
                  (k || "React class") + ": " + I + " type `" + q + "." + z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + B + "`."
                );
              }
              function se(k) {
                function I(q, z, B, G, V) {
                  var K = q[z], Y = Z(K);
                  if (Y !== "object")
                    return new O("Invalid " + G + " `" + V + "` of type `" + Y + "` " + ("supplied to `" + B + "`, expected `object`."));
                  for (var ae in k) {
                    var U = k[ae];
                    if (typeof U != "function")
                      return ie(B, G, V, ae, Me(U));
                    var R = U(K, ae, B, G, V + "." + ae, v);
                    if (R)
                      return R;
                  }
                  return null;
                }
                return S(I);
              }
              function be(k) {
                function I(q, z, B, G, V) {
                  var K = q[z], Y = Z(K);
                  if (Y !== "object")
                    return new O("Invalid " + G + " `" + V + "` of type `" + Y + "` " + ("supplied to `" + B + "`, expected `object`."));
                  var ae = m({}, q[z], k);
                  for (var U in ae) {
                    var R = k[U];
                    if (c(k, U) && typeof R != "function")
                      return ie(B, G, V, U, Me(R));
                    if (!R)
                      return new O(
                        "Invalid " + G + " `" + V + "` key `" + U + "` supplied to `" + B + "`.\nBad object: " + JSON.stringify(q[z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(k), null, "  ")
                      );
                    var le = R(K, U, B, G, V + "." + U, v);
                    if (le)
                      return le;
                  }
                  return null;
                }
                return S(I);
              }
              function fe(k) {
                switch (typeof k) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;
                  case "boolean":
                    return !k;
                  case "object":
                    if (Array.isArray(k))
                      return k.every(fe);
                    if (k === null || y(k))
                      return !0;
                    var I = E(k);
                    if (I) {
                      var q = I.call(k), z;
                      if (I !== k.entries) {
                        for (; !(z = q.next()).done; )
                          if (!fe(z.value))
                            return !1;
                      } else
                        for (; !(z = q.next()).done; ) {
                          var B = z.value;
                          if (B && !fe(B[1]))
                            return !1;
                        }
                    } else
                      return !1;
                    return !0;
                  default:
                    return !1;
                }
              }
              function ne(k, I) {
                return k === "symbol" ? !0 : I ? I["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && I instanceof Symbol : !1;
              }
              function Z(k) {
                var I = typeof k;
                return Array.isArray(k) ? "array" : k instanceof RegExp ? "object" : ne(I, k) ? "symbol" : I;
              }
              function Me(k) {
                if (typeof k > "u" || k === null)
                  return "" + k;
                var I = Z(k);
                if (I === "object") {
                  if (k instanceof Date)
                    return "date";
                  if (k instanceof RegExp)
                    return "regexp";
                }
                return I;
              }
              function he(k) {
                var I = Me(k);
                switch (I) {
                  case "array":
                  case "object":
                    return "an " + I;
                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + I;
                  default:
                    return I;
                }
              }
              function Ee(k) {
                return !k.constructor || !k.constructor.name ? P : k.constructor.name;
              }
              return _.checkPropTypes = h, _.resetWarningCache = h.resetWarningCache, _.PropTypes = _, _;
            };
          }
        ),
        /***/
        "./node_modules/prop-types/index.js": (
          /*!******************************************!*\
            !*** ./node_modules/prop-types/index.js ***!
            \******************************************/
          /***/
          (i, s, l) => {
            {
              var d = l(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), m = !0;
              i.exports = l(
                /*! ./factoryWithTypeCheckers */
                "./node_modules/prop-types/factoryWithTypeCheckers.js"
              )(d.isElement, m);
            }
          }
        ),
        /***/
        "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
            \*************************************************************/
          /***/
          (i) => {
            var s = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            i.exports = s;
          }
        ),
        /***/
        "./node_modules/prop-types/lib/has.js": (
          /*!********************************************!*\
            !*** ./node_modules/prop-types/lib/has.js ***!
            \********************************************/
          /***/
          (i) => {
            i.exports = Function.call.bind(Object.prototype.hasOwnProperty);
          }
        ),
        /***/
        "./node_modules/react-is/cjs/react-is.development.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/react-is/cjs/react-is.development.js ***!
            \***********************************************************/
          /***/
          (i, s) => {
            /** @license React v16.13.1
             * react-is.development.js
             *
             * Copyright (c) Facebook, Inc. and its affiliates.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */
            (function() {
              var l = typeof Symbol == "function" && Symbol.for, d = l ? Symbol.for("react.element") : 60103, m = l ? Symbol.for("react.portal") : 60106, v = l ? Symbol.for("react.fragment") : 60107, c = l ? Symbol.for("react.strict_mode") : 60108, h = l ? Symbol.for("react.profiler") : 60114, f = l ? Symbol.for("react.provider") : 60109, p = l ? Symbol.for("react.context") : 60110, y = l ? Symbol.for("react.async_mode") : 60111, M = l ? Symbol.for("react.concurrent_mode") : 60111, b = l ? Symbol.for("react.forward_ref") : 60112, g = l ? Symbol.for("react.suspense") : 60113, E = l ? Symbol.for("react.suspense_list") : 60120, P = l ? Symbol.for("react.memo") : 60115, _ = l ? Symbol.for("react.lazy") : 60116, D = l ? Symbol.for("react.block") : 60121, O = l ? Symbol.for("react.fundamental") : 60117, S = l ? Symbol.for("react.responder") : 60118, x = l ? Symbol.for("react.scope") : 60119;
              function C(R) {
                return typeof R == "string" || typeof R == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                R === v || R === M || R === h || R === c || R === g || R === E || typeof R == "object" && R !== null && (R.$$typeof === _ || R.$$typeof === P || R.$$typeof === f || R.$$typeof === p || R.$$typeof === b || R.$$typeof === O || R.$$typeof === S || R.$$typeof === x || R.$$typeof === D);
              }
              function T(R) {
                if (typeof R == "object" && R !== null) {
                  var le = R.$$typeof;
                  switch (le) {
                    case d:
                      var we = R.type;
                      switch (we) {
                        case y:
                        case M:
                        case v:
                        case h:
                        case c:
                        case g:
                          return we;
                        default:
                          var Ie = we && we.$$typeof;
                          switch (Ie) {
                            case p:
                            case b:
                            case _:
                            case P:
                            case f:
                              return Ie;
                            default:
                              return le;
                          }
                      }
                    case m:
                      return le;
                  }
                }
              }
              var j = y, A = M, $ = p, Q = f, te = d, re = b, ce = v, ie = _, se = P, be = m, fe = h, ne = c, Z = g, Me = !1;
              function he(R) {
                return Me || (Me = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Ee(R) || T(R) === y;
              }
              function Ee(R) {
                return T(R) === M;
              }
              function k(R) {
                return T(R) === p;
              }
              function I(R) {
                return T(R) === f;
              }
              function q(R) {
                return typeof R == "object" && R !== null && R.$$typeof === d;
              }
              function z(R) {
                return T(R) === b;
              }
              function B(R) {
                return T(R) === v;
              }
              function G(R) {
                return T(R) === _;
              }
              function V(R) {
                return T(R) === P;
              }
              function K(R) {
                return T(R) === m;
              }
              function Y(R) {
                return T(R) === h;
              }
              function ae(R) {
                return T(R) === c;
              }
              function U(R) {
                return T(R) === g;
              }
              s.AsyncMode = j, s.ConcurrentMode = A, s.ContextConsumer = $, s.ContextProvider = Q, s.Element = te, s.ForwardRef = re, s.Fragment = ce, s.Lazy = ie, s.Memo = se, s.Portal = be, s.Profiler = fe, s.StrictMode = ne, s.Suspense = Z, s.isAsyncMode = he, s.isConcurrentMode = Ee, s.isContextConsumer = k, s.isContextProvider = I, s.isElement = q, s.isForwardRef = z, s.isFragment = B, s.isLazy = G, s.isMemo = V, s.isPortal = K, s.isProfiler = Y, s.isStrictMode = ae, s.isSuspense = U, s.isValidElementType = C, s.typeOf = T;
            })();
          }
        ),
        /***/
        "./node_modules/react-is/index.js": (
          /*!****************************************!*\
            !*** ./node_modules/react-is/index.js ***!
            \****************************************/
          /***/
          (i, s, l) => {
            i.exports = l(
              /*! ./cjs/react-is.development.js */
              "./node_modules/react-is/cjs/react-is.development.js"
            );
          }
        ),
        /***/
        "./node_modules/shallow-equal/dist/index.esm.js": (
          /*!******************************************************!*\
            !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
            \******************************************************/
          /***/
          (i, s, l) => {
            l.r(s), l.d(s, {
              /* harmony export */
              shallowEqualArrays: () => (
                /* binding */
                m
              ),
              /* harmony export */
              shallowEqualObjects: () => (
                /* binding */
                d
              )
              /* harmony export */
            });
            function d(v, c) {
              if (v === c)
                return !0;
              if (!v || !c)
                return !1;
              var h = Object.keys(v), f = Object.keys(c), p = h.length;
              if (f.length !== p)
                return !1;
              for (var y = 0; y < p; y++) {
                var M = h[y];
                if (v[M] !== c[M] || !Object.prototype.hasOwnProperty.call(c, M))
                  return !1;
              }
              return !0;
            }
            function m(v, c) {
              if (v === c)
                return !0;
              if (!v || !c)
                return !1;
              var h = v.length;
              if (c.length !== h)
                return !1;
              for (var f = 0; f < h; f++)
                if (v[f] !== c[f])
                  return !1;
              return !0;
            }
          }
        ),
        /***/
        "./src/Component.ts": (
          /*!**************************!*\
            !*** ./src/Component.ts ***!
            \**************************/
          /***/
          function(i, s, l) {
            var d = this && this.__rest || function(h, f) {
              var p = {};
              for (var y in h)
                Object.prototype.hasOwnProperty.call(h, y) && f.indexOf(y) < 0 && (p[y] = h[y]);
              if (h != null && typeof Object.getOwnPropertySymbols == "function")
                for (var M = 0, y = Object.getOwnPropertySymbols(h); M < y.length; M++)
                  f.indexOf(y[M]) < 0 && Object.prototype.propertyIsEnumerable.call(h, y[M]) && (p[y[M]] = h[y[M]]);
              return p;
            }, m = this && this.__importDefault || function(h) {
              return h && h.__esModule ? h : { default: h };
            };
            Object.defineProperty(s, "__esModule", { value: !0 });
            var v = m(l(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            )), c = function(h) {
              var f = h.children, p = h.device, y = h.onChange, M = d(h, ["children", "device", "onChange"]), b = (0, v.default)(M, p, y);
              return typeof f == "function" ? f(b) : b ? f : null;
            };
            s.default = c;
          }
        ),
        /***/
        "./src/Context.ts": (
          /*!************************!*\
            !*** ./src/Context.ts ***!
            \************************/
          /***/
          (i, s, l) => {
            Object.defineProperty(s, "__esModule", { value: !0 });
            var d = l(
              /*! react */
              "react"
            ), m = (0, d.createContext)(void 0);
            s.default = m;
          }
        ),
        /***/
        "./src/index.ts": (
          /*!**********************!*\
            !*** ./src/index.ts ***!
            \**********************/
          /***/
          function(i, s, l) {
            var d = this && this.__importDefault || function(f) {
              return f && f.__esModule ? f : { default: f };
            };
            Object.defineProperty(s, "__esModule", { value: !0 }), s.Context = s.toQuery = s.useMediaQuery = s.default = void 0;
            var m = d(l(
              /*! ./useMediaQuery */
              "./src/useMediaQuery.ts"
            ));
            s.useMediaQuery = m.default;
            var v = d(l(
              /*! ./Component */
              "./src/Component.ts"
            ));
            s.default = v.default;
            var c = d(l(
              /*! ./toQuery */
              "./src/toQuery.ts"
            ));
            s.toQuery = c.default;
            var h = d(l(
              /*! ./Context */
              "./src/Context.ts"
            ));
            s.Context = h.default;
          }
        ),
        /***/
        "./src/mediaQuery.ts": (
          /*!***************************!*\
            !*** ./src/mediaQuery.ts ***!
            \***************************/
          /***/
          function(i, s, l) {
            var d = this && this.__assign || function() {
              return d = Object.assign || function(g) {
                for (var E, P = 1, _ = arguments.length; P < _; P++) {
                  E = arguments[P];
                  for (var D in E)
                    Object.prototype.hasOwnProperty.call(E, D) && (g[D] = E[D]);
                }
                return g;
              }, d.apply(this, arguments);
            }, m = this && this.__rest || function(g, E) {
              var P = {};
              for (var _ in g)
                Object.prototype.hasOwnProperty.call(g, _) && E.indexOf(_) < 0 && (P[_] = g[_]);
              if (g != null && typeof Object.getOwnPropertySymbols == "function")
                for (var D = 0, _ = Object.getOwnPropertySymbols(g); D < _.length; D++)
                  E.indexOf(_[D]) < 0 && Object.prototype.propertyIsEnumerable.call(g, _[D]) && (P[_[D]] = g[_[D]]);
              return P;
            }, v = this && this.__importDefault || function(g) {
              return g && g.__esModule ? g : { default: g };
            };
            Object.defineProperty(s, "__esModule", { value: !0 });
            var c = v(l(
              /*! prop-types */
              "./node_modules/prop-types/index.js"
            )), h = c.default.oneOfType([
              c.default.string,
              c.default.number
            ]), f = {
              all: c.default.bool,
              grid: c.default.bool,
              aural: c.default.bool,
              braille: c.default.bool,
              handheld: c.default.bool,
              print: c.default.bool,
              projection: c.default.bool,
              screen: c.default.bool,
              tty: c.default.bool,
              tv: c.default.bool,
              embossed: c.default.bool
            }, p = {
              orientation: c.default.oneOf([
                "portrait",
                "landscape"
              ]),
              scan: c.default.oneOf([
                "progressive",
                "interlace"
              ]),
              aspectRatio: c.default.string,
              deviceAspectRatio: c.default.string,
              height: h,
              deviceHeight: h,
              width: h,
              deviceWidth: h,
              color: c.default.bool,
              colorIndex: c.default.bool,
              monochrome: c.default.bool,
              resolution: h,
              type: Object.keys(f)
            };
            p.type;
            var y = m(
              p,
              ["type"]
            ), M = d({ minAspectRatio: c.default.string, maxAspectRatio: c.default.string, minDeviceAspectRatio: c.default.string, maxDeviceAspectRatio: c.default.string, minHeight: h, maxHeight: h, minDeviceHeight: h, maxDeviceHeight: h, minWidth: h, maxWidth: h, minDeviceWidth: h, maxDeviceWidth: h, minColor: c.default.number, maxColor: c.default.number, minColorIndex: c.default.number, maxColorIndex: c.default.number, minMonochrome: c.default.number, maxMonochrome: c.default.number, minResolution: h, maxResolution: h }, y), b = d(d({}, f), M);
            s.default = {
              all: b,
              types: f,
              matchers: p,
              features: M
            };
          }
        ),
        /***/
        "./src/toQuery.ts": (
          /*!************************!*\
            !*** ./src/toQuery.ts ***!
            \************************/
          /***/
          function(i, s, l) {
            var d = this && this.__importDefault || function(y) {
              return y && y.__esModule ? y : { default: y };
            };
            Object.defineProperty(s, "__esModule", { value: !0 });
            var m = d(l(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), v = d(l(
              /*! ./mediaQuery */
              "./src/mediaQuery.ts"
            )), c = function(y) {
              return "not ".concat(y);
            }, h = function(y, M) {
              var b = (0, m.default)(y);
              return typeof M == "number" && (M = "".concat(M, "px")), M === !0 ? b : M === !1 ? c(b) : "(".concat(b, ": ").concat(M, ")");
            }, f = function(y) {
              return y.join(" and ");
            }, p = function(y) {
              var M = [];
              return Object.keys(v.default.all).forEach(function(b) {
                var g = y[b];
                g != null && M.push(h(b, g));
              }), f(M);
            };
            s.default = p;
          }
        ),
        /***/
        "./src/useMediaQuery.ts": (
          /*!******************************!*\
            !*** ./src/useMediaQuery.ts ***!
            \******************************/
          /***/
          function(i, s, l) {
            var d = this && this.__importDefault || function(O) {
              return O && O.__esModule ? O : { default: O };
            };
            Object.defineProperty(s, "__esModule", { value: !0 });
            var m = l(
              /*! react */
              "react"
            ), v = d(l(
              /*! matchmediaquery */
              "./node_modules/matchmediaquery/index.js"
            )), c = d(l(
              /*! hyphenate-style-name */
              "./node_modules/hyphenate-style-name/index.js"
            )), h = l(
              /*! shallow-equal */
              "./node_modules/shallow-equal/dist/index.esm.js"
            ), f = d(l(
              /*! ./toQuery */
              "./src/toQuery.ts"
            )), p = d(l(
              /*! ./Context */
              "./src/Context.ts"
            )), y = function(O) {
              return O.query || (0, f.default)(O);
            }, M = function(O) {
              if (O) {
                var S = Object.keys(O);
                return S.reduce(function(x, C) {
                  return x[(0, c.default)(C)] = O[C], x;
                }, {});
              }
            }, b = function() {
              var O = (0, m.useRef)(!1);
              return (0, m.useEffect)(function() {
                O.current = !0;
              }, []), O.current;
            }, g = function(O) {
              var S = (0, m.useContext)(p.default), x = function() {
                return M(O) || M(S);
              }, C = (0, m.useState)(x), T = C[0], j = C[1];
              return (0, m.useEffect)(function() {
                var A = x();
                (0, h.shallowEqualObjects)(T, A) || j(A);
              }, [O, S]), T;
            }, E = function(O) {
              var S = function() {
                return y(O);
              }, x = (0, m.useState)(S), C = x[0], T = x[1];
              return (0, m.useEffect)(function() {
                var j = S();
                C !== j && T(j);
              }, [O]), C;
            }, P = function(O, S) {
              var x = function() {
                return (0, v.default)(O, S || {}, !!S);
              }, C = (0, m.useState)(x), T = C[0], j = C[1], A = b();
              return (0, m.useEffect)(function() {
                if (A) {
                  var $ = x();
                  return j($), function() {
                    $ && $.dispose();
                  };
                }
              }, [O, S]), T;
            }, _ = function(O) {
              var S = (0, m.useState)(O.matches), x = S[0], C = S[1];
              return (0, m.useEffect)(function() {
                var T = function(j) {
                  C(j.matches);
                };
                return O.addListener(T), C(O.matches), function() {
                  O.removeListener(T);
                };
              }, [O]), x;
            }, D = function(O, S, x) {
              var C = g(S), T = E(O);
              if (!T)
                throw new Error("Invalid or missing MediaQuery!");
              var j = P(T, C), A = _(j), $ = b();
              return (0, m.useEffect)(function() {
                $ && x && x(A);
              }, [A]), (0, m.useEffect)(function() {
                return function() {
                  j && j.dispose();
                };
              }, []), A;
            };
            s.default = D;
          }
        ),
        /***/
        react: (
          /*!**************************************************************************************!*\
            !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
            \**************************************************************************************/
          /***/
          (i) => {
            i.exports = r;
          }
        )
        /******/
      }, a = {};
      function o(i) {
        var s = a[i];
        if (s !== void 0)
          return s.exports;
        var l = a[i] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return n[i].call(l.exports, l, l.exports, o), l.exports;
      }
      o.d = (i, s) => {
        for (var l in s)
          o.o(s, l) && !o.o(i, l) && Object.defineProperty(i, l, { enumerable: !0, get: s[l] });
      }, o.o = (i, s) => Object.prototype.hasOwnProperty.call(i, s), o.r = (i) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
      };
      var u = o("./src/index.ts");
      return u;
    })()
  ));
})(uo);
var Al = uo.exports;
const kl = {
  query: "(min-width: 768px)"
}, xl = (e) => /* @__PURE__ */ je(
  "svg",
  {
    "data-testid": "oc-logo",
    fill: "none",
    height: "50",
    viewBox: "0 0 400 400",
    width: "50",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ W("path", { d: "M0 0h400v400H0z", fill: "#022e4a" }),
      /* @__PURE__ */ W(
        "path",
        {
          d: "M146.408 142.92C115.256 142.92 90 168.472 90 200.001c0 31.528 25.256 57.087 56.408 57.087s56.409-25.559 56.409-57.087-25.256-57.081-56.409-57.081m0 85.564c-15.542 0-28.141-12.75-28.141-28.483s12.599-28.477 28.141-28.477c15.543 0 28.142 12.75 28.142 28.477s-12.599 28.483-28.142 28.483M310 154.565l-11.157 23.554c-5.703-4.959-13.388-8.43-25.29-8.43-20.082 0-31.24 13.884-31.24 30.248s11.158 30.25 31.24 30.25c11.902 0 19.091-3.72 25.29-8.679L310 245.311c-9.173 5.951-22.067 11.654-37.935 11.654-36.447 0-59.753-24.299-59.753-57.028s23.307-57.025 59.753-57.025c15.868 0 29.01 5.455 37.935 11.653",
          fill: "#fff"
        }
      )
    ]
  }
);
const Rl = "button_bvtzfi5", Il = "buttonWithBadge_b1eprg2a", $l = "drifter_d12jom77", jl = "drifterFlash_drixa55", Ll = "steamer_s1d9ittc", Wl = "steamerFlash_shk7cc5", Fl = "noAnimation_nttqpkc", Nl = "selectedBet_s1xs3ppz", Hl = "bookieLogo_bd76kis", Bl = "buttonUnsupported_b86phbh", zl = "textWrapper_t1h9f86g", Vl = "ocLogoWrapper_o10rai6", Kl = "logoWrapper_lif7al8", Ul = "buttonWithVerticalBadge_b16ssfx3", ql = ({ classNamesFactory: e }) => {
  const [t, r] = ue([]);
  return J(() => {
    r(e(!0));
  }, [e]), [t, () => {
    r(e(!1));
  }];
}, Yl = ({
  bookieCode: e,
  bookmakerConfig: t,
  children: r,
  className: n,
  disableAnimation: a,
  disabled: o,
  isSelected: u,
  isUnsupported: i,
  isVerticalBadgeLogo: s = !1,
  renderBadge: l = !1,
  steamOrDrift: d,
  tooltip: m,
  ...v
}) => {
  const c = Ne(
    () => Xl(d, a),
    [d, a]
  ), [h, f] = ql({
    classNamesFactory: c
  }), p = Al.useMediaQuery(kl), y = e === "OC_NON_CLICKABLE", M = e === "OC", b = t == null ? void 0 : t.logoLarge, g = t == null ? void 0 : t.logoSmall, E = !p && l && s, P = !p && s ? b : g, _ = () => y ? /* @__PURE__ */ W("div", { className: Vl, children: /* @__PURE__ */ W(xl, {}) }) : l && P ? /* @__PURE__ */ W(
    "div",
    {
      className: Kl,
      style: !M && (t != null && t.brandColour) ? { backgroundColor: t.brandColour } : void 0,
      children: /* @__PURE__ */ W(
        "img",
        {
          alt: "bookie logo",
          className: Hl,
          src: P,
          style: !M && (t != null && t.brandColour) ? { backgroundColor: t.brandColour } : void 0
        }
      )
    }
  ) : null;
  return /* @__PURE__ */ je(
    pi,
    {
      className: or(
        Rl,
        ...u && !o && !i ? [Nl] : h,
        i ? Bl : "",
        l || y ? Il : "",
        E ? Ul : "",
        n || ""
      ),
      "data-testid": "odds-button",
      onTransitionEnd: f,
      ...v,
      children: [
        _(),
        /* @__PURE__ */ W("div", { className: zl, children: r }),
        m
      ]
    }
  );
};
function Xl(e, t) {
  return (r) => {
    const n = [];
    switch (e) {
      case "drifting":
        n.push($l), r && !t && n.push(jl);
        break;
      case "shortening":
        n.push(Ll), r && !t && n.push(Wl);
        break;
    }
    return t && n.push(Fl), n;
  };
}
class Gl extends xo {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError(t) {
    return { error: t, hasError: !0 };
  }
  componentDidCatch(t, r) {
    console.error("MostPopularBets Error:", t, r);
  }
  render() {
    return this.state.hasError ? this.props.fallback ? this.props.fallback : /* @__PURE__ */ W(Dl, { children: "Unable to load popular bets at this time. Please try again later." }) : this.props.children;
  }
}
const Xn = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), n = (d, m) => {
    const v = typeof d == "function" ? d(t) : d;
    if (!Object.is(v, t)) {
      const c = t;
      t = m ?? (typeof v != "object" || v === null) ? v : Object.assign({}, t, v), r.forEach((h) => h(t, c));
    }
  }, a = () => t, s = { setState: n, getState: a, getInitialState: () => l, subscribe: (d) => (r.add(d), () => r.delete(d)), destroy: () => {
    r.clear();
  } }, l = t = e(n, a, s);
  return s;
}, Jl = (e) => e ? Xn(e) : Xn;
var Wr = { exports: {} }, gr = {}, Yt = { exports: {} }, br = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gn;
function Ql() {
  if (Gn)
    return br;
  Gn = 1;
  var e = it;
  function t(m, v) {
    return m === v && (m !== 0 || 1 / m === 1 / v) || m !== m && v !== v;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, a = e.useEffect, o = e.useLayoutEffect, u = e.useDebugValue;
  function i(m, v) {
    var c = v(), h = n({ inst: { value: c, getSnapshot: v } }), f = h[0].inst, p = h[1];
    return o(
      function() {
        f.value = c, f.getSnapshot = v, s(f) && p({ inst: f });
      },
      [m, c, v]
    ), a(
      function() {
        return s(f) && p({ inst: f }), m(function() {
          s(f) && p({ inst: f });
        });
      },
      [m]
    ), u(c), c;
  }
  function s(m) {
    var v = m.getSnapshot;
    m = m.value;
    try {
      var c = v();
      return !r(m, c);
    } catch {
      return !0;
    }
  }
  function l(m, v) {
    return v();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : i;
  return br.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, br;
}
var Mr = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jn;
function Zl() {
  return Jn || (Jn = 1, process.env.NODE_ENV !== "production" && function() {
    function e(c, h) {
      return c === h && (c !== 0 || 1 / c === 1 / h) || c !== c && h !== h;
    }
    function t(c, h) {
      d || a.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var f = h();
      if (!m) {
        var p = h();
        o(f, p) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), m = !0);
      }
      p = u({
        inst: { value: f, getSnapshot: h }
      });
      var y = p[0].inst, M = p[1];
      return s(
        function() {
          y.value = f, y.getSnapshot = h, r(y) && M({ inst: y });
        },
        [c, f, h]
      ), i(
        function() {
          return r(y) && M({ inst: y }), c(function() {
            r(y) && M({ inst: y });
          });
        },
        [c]
      ), l(f), f;
    }
    function r(c) {
      var h = c.getSnapshot;
      c = c.value;
      try {
        var f = h();
        return !o(c, f);
      } catch {
        return !0;
      }
    }
    function n(c, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var a = it, o = typeof Object.is == "function" ? Object.is : e, u = a.useState, i = a.useEffect, s = a.useLayoutEffect, l = a.useDebugValue, d = !1, m = !1, v = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : t;
    Mr.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : v, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Mr;
}
var Qn;
function lo() {
  return Qn || (Qn = 1, process.env.NODE_ENV === "production" ? Yt.exports = Ql() : Yt.exports = Zl()), Yt.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zn;
function ed() {
  if (Zn)
    return gr;
  Zn = 1;
  var e = it, t = lo();
  function r(l, d) {
    return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : r, a = t.useSyncExternalStore, o = e.useRef, u = e.useEffect, i = e.useMemo, s = e.useDebugValue;
  return gr.useSyncExternalStoreWithSelector = function(l, d, m, v, c) {
    var h = o(null);
    if (h.current === null) {
      var f = { hasValue: !1, value: null };
      h.current = f;
    } else
      f = h.current;
    h = i(
      function() {
        function y(P) {
          if (!M) {
            if (M = !0, b = P, P = v(P), c !== void 0 && f.hasValue) {
              var _ = f.value;
              if (c(_, P))
                return g = _;
            }
            return g = P;
          }
          if (_ = g, n(b, P))
            return _;
          var D = v(P);
          return c !== void 0 && c(_, D) ? (b = P, _) : (b = P, g = D);
        }
        var M = !1, b, g, E = m === void 0 ? null : m;
        return [
          function() {
            return y(d());
          },
          E === null ? void 0 : function() {
            return y(E());
          }
        ];
      },
      [d, m, v, c]
    );
    var p = a(l, h[0], h[1]);
    return u(
      function() {
        f.hasValue = !0, f.value = p;
      },
      [p]
    ), s(p), p;
  }, gr;
}
var wr = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ea;
function td() {
  return ea || (ea = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l, d) {
      return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = it, r = lo(), n = typeof Object.is == "function" ? Object.is : e, a = r.useSyncExternalStore, o = t.useRef, u = t.useEffect, i = t.useMemo, s = t.useDebugValue;
    wr.useSyncExternalStoreWithSelector = function(l, d, m, v, c) {
      var h = o(null);
      if (h.current === null) {
        var f = { hasValue: !1, value: null };
        h.current = f;
      } else
        f = h.current;
      h = i(
        function() {
          function y(P) {
            if (!M) {
              if (M = !0, b = P, P = v(P), c !== void 0 && f.hasValue) {
                var _ = f.value;
                if (c(_, P))
                  return g = _;
              }
              return g = P;
            }
            if (_ = g, n(b, P))
              return _;
            var D = v(P);
            return c !== void 0 && c(_, D) ? (b = P, _) : (b = P, g = D);
          }
          var M = !1, b, g, E = m === void 0 ? null : m;
          return [
            function() {
              return y(d());
            },
            E === null ? void 0 : function() {
              return y(E());
            }
          ];
        },
        [d, m, v, c]
      );
      var p = a(l, h[0], h[1]);
      return u(
        function() {
          f.hasValue = !0, f.value = p;
        },
        [p]
      ), s(p), p;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), wr;
}
process.env.NODE_ENV === "production" ? Wr.exports = ed() : Wr.exports = td();
var rd = Wr.exports;
const nd = /* @__PURE__ */ Tl(rd), { useDebugValue: ad } = it, { useSyncExternalStoreWithSelector: od } = nd;
const id = (e) => e;
function sd(e, t = id, r) {
  const n = od(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    r
  );
  return ad(n), n;
}
const Fr = /* @__PURE__ */ new Map(), Xt = (e) => {
  const t = Fr.get(e);
  return t ? Object.fromEntries(
    Object.entries(t.stores).map(([r, n]) => [r, n.getState()])
  ) : {};
}, ud = (e, t, r) => {
  if (e === void 0)
    return {
      type: "untracked",
      connection: t.connect(r)
    };
  const n = Fr.get(r.name);
  if (n)
    return { type: "tracked", store: e, ...n };
  const a = {
    connection: t.connect(r),
    stores: {}
  };
  return Fr.set(r.name, a), { type: "tracked", store: e, ...a };
}, ld = (e, t = {}) => (r, n, a) => {
  const { enabled: o, anonymousActionType: u, store: i, ...s } = t;
  let l;
  try {
    l = (o ?? !1) && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!l)
    return e(r, n, a);
  const { connection: d, ...m } = ud(i, l, s);
  let v = !0;
  a.setState = (f, p, y) => {
    const M = r(f, p);
    if (!v)
      return M;
    const b = y === void 0 ? { type: u || "anonymous" } : typeof y == "string" ? { type: y } : y;
    return i === void 0 ? (d == null || d.send(b, n()), M) : (d == null || d.send(
      {
        ...b,
        type: `${i}/${b.type}`
      },
      {
        ...Xt(s.name),
        [i]: a.getState()
      }
    ), M);
  };
  const c = (...f) => {
    const p = v;
    v = !1, r(...f), v = p;
  }, h = e(a.setState, n, a);
  if (m.type === "untracked" ? d == null || d.init(h) : (m.stores[m.store] = a, d == null || d.init(
    Object.fromEntries(
      Object.entries(m.stores).map(([f, p]) => [
        f,
        f === m.store ? h : p.getState()
      ])
    )
  )), a.dispatchFromDevtools && typeof a.dispatch == "function") {
    let f = !1;
    const p = a.dispatch;
    a.dispatch = (...y) => {
      p(...y);
    };
  }
  return d.subscribe((f) => {
    var p;
    switch (f.type) {
      case "ACTION":
        if (typeof f.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return Er(
          f.payload,
          (y) => {
            if (y.type === "__setState") {
              if (i === void 0) {
                c(y.state);
                return;
              }
              Object.keys(y.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const M = y.state[i];
              if (M == null)
                return;
              JSON.stringify(a.getState()) !== JSON.stringify(M) && c(M);
              return;
            }
            a.dispatchFromDevtools && typeof a.dispatch == "function" && a.dispatch(y);
          }
        );
      case "DISPATCH":
        switch (f.payload.type) {
          case "RESET":
            return c(h), i === void 0 ? d == null ? void 0 : d.init(a.getState()) : d == null ? void 0 : d.init(Xt(s.name));
          case "COMMIT":
            if (i === void 0) {
              d == null || d.init(a.getState());
              return;
            }
            return d == null ? void 0 : d.init(Xt(s.name));
          case "ROLLBACK":
            return Er(f.state, (y) => {
              if (i === void 0) {
                c(y), d == null || d.init(a.getState());
                return;
              }
              c(y[i]), d == null || d.init(Xt(s.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return Er(f.state, (y) => {
              if (i === void 0) {
                c(y);
                return;
              }
              JSON.stringify(a.getState()) !== JSON.stringify(y[i]) && c(y[i]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: y } = f.payload, M = (p = y.computedStates.slice(-1)[0]) == null ? void 0 : p.state;
            if (!M)
              return;
            c(i === void 0 ? M : M[i]), d == null || d.send(
              null,
              // FIXME no-any
              y
            );
            return;
          }
          case "PAUSE_RECORDING":
            return v = !v;
        }
        return;
    }
  }), h;
}, dd = ld, Er = (e, t) => {
  let r;
  try {
    r = JSON.parse(e);
  } catch (n) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      n
    );
  }
  r !== void 0 && t(r);
}, cd = () => Jl()(
  dd(
    (e) => ({
      addSelectedBet: (t) => {
        e((r) => ({
          selectedBets: [...(r.selectedBets || []).filter((n) => n.betId !== t.betId), t]
        }));
      },
      removeAllSelectedBets: () => {
        e({ selectedBets: [] });
      },
      removeSelectedBet: (t) => {
        e((r) => ({
          selectedBets: (r.selectedBets || []).filter((n) => n.betId !== t)
        }));
      },
      selectedBets: [],
      syncBetslip: (t, r) => {
        e((n) => {
          if (r)
            return {
              selectedBets: t.map((o) => ({
                betId: o.betId,
                bookieCode: o.bestOddsBookmakers.split(",")[0]
              }))
            };
          const a = n.selectedBets || [];
          return {
            selectedBets: [
              ...a,
              ...t.reduce((o, u) => (a.find(({ betId: i }) => u.betId === i) || o.push({
                betId: u.betId,
                bookieCode: u.bestOddsBookmakers.split(",")[0]
              }), o), [])
            ]
          };
        });
      }
    }),
    { enabled: !1, name: "MostPopularBetsStore" }
  )
), sn = Ge(null), fd = ({ children: e, ...t }) => {
  const r = Ne(() => cd(), []), n = L(() => {
    r.getState().removeAllSelectedBets();
  }, [r]), a = L(
    (u) => {
      r.getState().removeSelectedBet(u);
    },
    [r]
  ), o = L(
    (u, i) => {
      var s, l;
      (l = (s = r.getState()).syncBetslip) == null || l.call(s, u, i);
    },
    [r]
  );
  return J(() => {
    var u, i;
    (i = (u = window.ocBetslip) == null ? void 0 : u.setCallbacks) == null || i.call(u, {
      clearBetslip: n,
      removeBet: a,
      syncBetslip: o
    });
  }, [n, a, o]), /* @__PURE__ */ W(sn.Provider, { value: { props: t, store: r }, children: e });
}, lr = () => {
  const e = Se(sn);
  if (!e)
    throw new Error("useMostPopularBetsProps must be used within MostPopularBetsPropsProvider");
  return e.props;
}, Sr = (e) => {
  const t = Se(sn);
  if (!t)
    throw new Error("useMostPopularBetsStore must be used within MostPopularBetsPropsProvider");
  return sd(t.store, e);
};
function co(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++)
        e[t] && (r = co(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}
function Lt() {
  for (var e, t, r = 0, n = "", a = arguments.length; r < a; r++)
    (e = arguments[r]) && (t = co(e)) && (n && (n += " "), n += t);
  return n;
}
function H(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
function F(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const u = e.defaultFormattingWidth || e.defaultWidth, i = r != null && r.width ? String(r.width) : u;
      a = e.formattingValues[i] || e.formattingValues[u];
    } else {
      const u = e.defaultWidth, i = r != null && r.width ? String(r.width) : e.defaultWidth;
      a = e.values[i] || e.values[u];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[o];
  };
}
function N(e) {
  return (t, r = {}) => {
    const n = r.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = t.match(a);
    if (!o)
      return null;
    const u = o[0], i = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(i) ? vd(i, (m) => m.test(u)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      md(i, (m) => m.test(u))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(s) : s, l = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(l)
    ) : l;
    const d = t.slice(u.length);
    return { value: l, rest: d };
  };
}
function md(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function vd(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function Be(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n)
      return null;
    const a = n[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    let u = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    u = r.valueCallback ? r.valueCallback(u) : u;
    const i = t.slice(a.length);
    return { value: u, rest: i };
  };
}
function hd(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
let pd = {};
function yd() {
  return pd;
}
function ta(e, t) {
  var i, s, l, d;
  const r = yd(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((s = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : s.weekStartsOn) ?? r.weekStartsOn ?? ((d = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) ?? 0, a = hd(e), o = a.getDay(), u = (o < n ? 7 : 0) + o - n;
  return a.setDate(a.getDate() - u), a.setHours(0, 0, 0, 0), a;
}
function ra(e, t, r) {
  const n = ta(e, r), a = ta(t, r);
  return +n == +a;
}
const gd = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, bd = (e, t, r) => {
  let n;
  const a = gd[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + n : n + " siden" : n;
}, Md = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, wd = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ed = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Sd = {
  date: H({
    formats: Md,
    defaultWidth: "full"
  }),
  time: H({
    formats: wd,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Ed,
    defaultWidth: "full"
  })
}, Pd = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, _d = (e, t, r, n) => Pd[e], Od = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, Cd = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Dd = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Td = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, Ad = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, kd = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, xd = (e, t) => Number(e) + ".", Rd = {
  ordinalNumber: xd,
  era: F({
    values: Od,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Cd,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Dd,
    defaultWidth: "wide"
  }),
  day: F({
    values: Td,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Ad,
    defaultWidth: "wide",
    formattingValues: kd,
    defaultFormattingWidth: "wide"
  })
}, Id = /^(\d+)(\.)?/i, $d = /\d+/i, jd = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, Ld = {
  any: [/^f/i, /^(v|e)/i]
}, Wd = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, Fd = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nd = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, Hd = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Bd = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, zd = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Vd = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, Kd = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, Ud = {
  ordinalNumber: Be({
    matchPattern: Id,
    parsePattern: $d,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: N({
    matchPatterns: jd,
    defaultMatchWidth: "wide",
    parsePatterns: Ld,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: Wd,
    defaultMatchWidth: "wide",
    parsePatterns: Fd,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: Nd,
    defaultMatchWidth: "wide",
    parsePatterns: Hd,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: Bd,
    defaultMatchWidth: "wide",
    parsePatterns: zd,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: Vd,
    defaultMatchWidth: "any",
    parsePatterns: Kd,
    defaultParseWidth: "any"
  })
}, qd = {
  code: "da",
  formatDistance: bd,
  formatLong: Sd,
  formatRelative: _d,
  localize: Rd,
  match: Ud,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, na = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, Yd = (e, t, r) => {
  let n;
  const a = r != null && r.addSuffix ? na[e].withPreposition : na[e].standalone;
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : "vor " + n : n;
}, Xd = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, Gd = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Jd = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Qd = {
  date: H({
    formats: Xd,
    defaultWidth: "full"
  }),
  time: H({
    formats: Gd,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Jd,
    defaultWidth: "full"
  })
}, Zd = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, ec = (e, t, r, n) => Zd[e], tc = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, rc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, Nr = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, nc = {
  narrow: Nr.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: Nr.wide
}, ac = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, oc = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, ic = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, sc = (e) => Number(e) + ".", uc = {
  ordinalNumber: sc,
  era: F({
    values: tc,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: rc,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Nr,
    formattingValues: nc,
    defaultWidth: "wide"
  }),
  day: F({
    values: ac,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: oc,
    defaultWidth: "wide",
    formattingValues: ic,
    defaultFormattingWidth: "wide"
  })
}, lc = /^(\d+)(\.)?/i, dc = /\d+/i, cc = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, fc = {
  any: [/^v/i, /^n/i]
}, mc = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, vc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, pc = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, yc = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, gc = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, bc = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, Mc = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, wc = {
  ordinalNumber: Be({
    matchPattern: lc,
    parsePattern: dc,
    valueCallback: (e) => parseInt(e)
  }),
  era: N({
    matchPatterns: cc,
    defaultMatchWidth: "wide",
    parsePatterns: fc,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: mc,
    defaultMatchWidth: "wide",
    parsePatterns: vc,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: hc,
    defaultMatchWidth: "wide",
    parsePatterns: pc,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: yc,
    defaultMatchWidth: "wide",
    parsePatterns: gc,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: bc,
    defaultMatchWidth: "wide",
    parsePatterns: Mc,
    defaultParseWidth: "any"
  })
}, Ec = {
  code: "de",
  formatDistance: Yd,
  formatLong: Qd,
  formatRelative: ec,
  localize: uc,
  match: wc,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Sc = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Pt = (e, t, r) => {
  let n;
  const a = Sc[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
}, Pc = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, _c = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Oc = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Cc = {
  date: H({
    formats: Pc,
    defaultWidth: "full"
  }),
  time: H({
    formats: _c,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Oc,
    defaultWidth: "full"
  })
}, Dc = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, lt = (e, t, r, n) => Dc[e], Tc = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ac = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, kc = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, xc = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Rc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ic = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, $c = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, dt = {
  ordinalNumber: $c,
  era: F({
    values: Tc,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Ac,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: kc,
    defaultWidth: "wide"
  }),
  day: F({
    values: xc,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Rc,
    defaultWidth: "wide",
    formattingValues: Ic,
    defaultFormattingWidth: "wide"
  })
}, jc = /^(\d+)(th|st|nd|rd)?/i, Lc = /\d+/i, Wc = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Fc = {
  any: [/^b/i, /^(a|c)/i]
}, Nc = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Hc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, zc = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Vc = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Kc = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Uc = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, qc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ct = {
  ordinalNumber: Be({
    matchPattern: jc,
    parsePattern: Lc,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: N({
    matchPatterns: Wc,
    defaultMatchWidth: "wide",
    parsePatterns: Fc,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: Nc,
    defaultMatchWidth: "wide",
    parsePatterns: Hc,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: Bc,
    defaultMatchWidth: "wide",
    parsePatterns: zc,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: Vc,
    defaultMatchWidth: "wide",
    parsePatterns: Kc,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: Uc,
    defaultMatchWidth: "any",
    parsePatterns: qc,
    defaultParseWidth: "any"
  })
}, Yc = {
  code: "en-AU",
  formatDistance: Pt,
  formatLong: Cc,
  formatRelative: lt,
  localize: dt,
  match: ct,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Xc = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "a second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "an hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "a day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "a week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "a month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "a year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over a year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years"
  }
}, Gc = (e, t, r) => {
  let n;
  const a = Xc[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
}, Jc = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd"
}, Qc = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Zc = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ef = {
  date: H({
    formats: Jc,
    defaultWidth: "full"
  }),
  time: H({
    formats: Qc,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Zc,
    defaultWidth: "full"
  })
}, tf = {
  code: "en-CA",
  formatDistance: Gc,
  formatLong: ef,
  formatRelative: lt,
  localize: dt,
  match: ct,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, rf = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, nf = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, af = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, of = {
  date: H({
    formats: rf,
    defaultWidth: "full"
  }),
  time: H({
    formats: nf,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: af,
    defaultWidth: "full"
  })
}, sf = {
  code: "en-GB",
  formatDistance: Pt,
  formatLong: of,
  formatRelative: lt,
  localize: dt,
  match: ct,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, uf = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM, yyyy",
  medium: "d MMM, yyyy",
  short: "dd/MM/yyyy"
}, lf = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, df = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, cf = {
  date: H({
    formats: uf,
    defaultWidth: "full"
  }),
  time: H({
    formats: lf,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: df,
    defaultWidth: "full"
  })
}, ff = {
  code: "en-IN",
  formatDistance: Pt,
  formatLong: cf,
  formatRelative: lt,
  localize: dt,
  match: ct,
  options: {
    weekStartsOn: 1,
    // Monday is the first day of the week.
    firstWeekContainsDate: 4
    // The week that contains Jan 4th is the first week of the year.
  }
}, mf = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, vf = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, hf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, pf = {
  date: H({
    formats: mf,
    defaultWidth: "full"
  }),
  time: H({
    formats: vf,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: hf,
    defaultWidth: "full"
  })
}, yf = {
  code: "en-NZ",
  formatDistance: Pt,
  formatLong: pf,
  formatRelative: lt,
  localize: dt,
  match: ct,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, gf = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, bf = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Mf = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wf = {
  date: H({
    formats: gf,
    defaultWidth: "full"
  }),
  time: H({
    formats: bf,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Mf,
    defaultWidth: "full"
  })
}, Ef = {
  code: "en-US",
  formatDistance: Pt,
  formatLong: wf,
  formatRelative: lt,
  localize: dt,
  match: ct,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Sf = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "yyyy/MM/dd"
}, Pf = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, _f = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Of = {
  date: H({
    formats: Sf,
    defaultWidth: "full"
  }),
  time: H({
    formats: Pf,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: _f,
    defaultWidth: "full"
  })
}, Cf = {
  code: "en-ZA",
  formatDistance: Pt,
  formatLong: Of,
  formatRelative: lt,
  localize: dt,
  match: ct,
  options: {
    weekStartsOn: 0,
    // Sunday is the first day of the week.
    firstWeekContainsDate: 1
    // The week that contains Jan 1st is the first week of the year.
  }
}, Df = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, Tf = (e, t, r) => {
  let n;
  const a = Df[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + n : "hace " + n : n;
}, Af = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, kf = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, xf = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rf = {
  date: H({
    formats: Af,
    defaultWidth: "full"
  }),
  time: H({
    formats: kf,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: xf,
    defaultWidth: "full"
  })
}, If = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, $f = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, jf = (e, t, r, n) => t.getHours() !== 1 ? $f[e] : If[e], Lf = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, Wf = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Ff = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, Nf = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, Hf = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, Bf = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, zf = (e, t) => Number(e) + "º", Vf = {
  ordinalNumber: zf,
  era: F({
    values: Lf,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Wf,
    defaultWidth: "wide",
    argumentCallback: (e) => Number(e) - 1
  }),
  month: F({
    values: Ff,
    defaultWidth: "wide"
  }),
  day: F({
    values: Nf,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Hf,
    defaultWidth: "wide",
    formattingValues: Bf,
    defaultFormattingWidth: "wide"
  })
}, Kf = /^(\d+)(º)?/i, Uf = /\d+/i, qf = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, Yf = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, Xf = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Gf = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Jf = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, Qf = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, Zf = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, em = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, tm = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, rm = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, nm = {
  ordinalNumber: Be({
    matchPattern: Kf,
    parsePattern: Uf,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: N({
    matchPatterns: qf,
    defaultMatchWidth: "wide",
    parsePatterns: Yf,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: Xf,
    defaultMatchWidth: "wide",
    parsePatterns: Gf,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: Jf,
    defaultMatchWidth: "wide",
    parsePatterns: Qf,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: Zf,
    defaultMatchWidth: "wide",
    parsePatterns: em,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: tm,
    defaultMatchWidth: "any",
    parsePatterns: rm,
    defaultParseWidth: "any"
  })
}, am = {
  code: "es",
  formatDistance: Tf,
  formatLong: Rf,
  formatRelative: jf,
  localize: Vf,
  match: nm,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, om = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, im = (e, t, r) => {
  let n;
  const a = om[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + n : "il y a " + n : n;
}, sm = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, um = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, lm = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dm = {
  date: H({
    formats: sm,
    defaultWidth: "full"
  }),
  time: H({
    formats: um,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: lm,
    defaultWidth: "full"
  })
}, cm = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, fm = (e, t, r, n) => cm[e], mm = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, vm = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, hm = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc."
  ],
  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre"
  ]
}, pm = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi"
  ]
}, ym = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, gm = (e, t) => {
  const r = Number(e), n = t == null ? void 0 : t.unit;
  if (r === 0)
    return "0";
  const a = ["year", "week", "hour", "minute", "second"];
  let o;
  return r === 1 ? o = n && a.includes(n) ? "ère" : "er" : o = "ème", r + o;
}, bm = ["MMM", "MMMM"], Mm = {
  preprocessor: (e, t) => e.getDate() === 1 || !t.some(
    (n) => n.isToken && bm.includes(n.value)
  ) ? t : t.map(
    (n) => n.isToken && n.value === "do" ? { isToken: !0, value: "d" } : n
  ),
  ordinalNumber: gm,
  era: F({
    values: mm,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: vm,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: hm,
    defaultWidth: "wide"
  }),
  day: F({
    values: pm,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: ym,
    defaultWidth: "wide"
  })
}, wm = /^(\d+)(ième|ère|ème|er|e)?/i, Em = /\d+/i, Sm = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, Pm = {
  any: [/^av/i, /^ap/i]
}, _m = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, Om = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Cm = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, Dm = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Tm = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, Am = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, km = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, xm = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, Rm = {
  ordinalNumber: Be({
    matchPattern: wm,
    parsePattern: Em,
    valueCallback: (e) => parseInt(e)
  }),
  era: N({
    matchPatterns: Sm,
    defaultMatchWidth: "wide",
    parsePatterns: Pm,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: _m,
    defaultMatchWidth: "wide",
    parsePatterns: Om,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: Cm,
    defaultMatchWidth: "wide",
    parsePatterns: Dm,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: Tm,
    defaultMatchWidth: "wide",
    parsePatterns: Am,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: km,
    defaultMatchWidth: "any",
    parsePatterns: xm,
    defaultParseWidth: "any"
  })
}, Im = {
  code: "fr",
  formatDistance: im,
  formatLong: dm,
  formatRelative: fm,
  localize: Mm,
  match: Rm,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, $m = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, jm = (e, t, r) => {
  let n;
  const a = $m[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "tra " + n : n + " fa" : n;
}, Lm = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Wm = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Fm = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Nm = {
  date: H({
    formats: Lm,
    defaultWidth: "full"
  }),
  time: H({
    formats: Wm,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Fm,
    defaultWidth: "full"
  })
}, un = [
  "domenica",
  "lunedì",
  "martedì",
  "mercoledì",
  "giovedì",
  "venerdì",
  "sabato"
];
function Hm(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + un[e] + " scorso alle' p";
  }
}
function aa(e) {
  return "'" + un[e] + " alle' p";
}
function Bm(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + un[e] + " prossimo alle' p";
  }
}
const zm = {
  lastWeek: (e, t, r) => {
    const n = e.getDay();
    return ra(e, t, r) ? aa(n) : Hm(n);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: (e, t, r) => {
    const n = e.getDay();
    return ra(e, t, r) ? aa(n) : Bm(n);
  },
  other: "P"
}, Vm = (e, t, r, n) => {
  const a = zm[e];
  return typeof a == "function" ? a(t, r, n) : a;
}, Km = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, Um = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, qm = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "gen",
    "feb",
    "mar",
    "apr",
    "mag",
    "giu",
    "lug",
    "ago",
    "set",
    "ott",
    "nov",
    "dic"
  ],
  wide: [
    "gennaio",
    "febbraio",
    "marzo",
    "aprile",
    "maggio",
    "giugno",
    "luglio",
    "agosto",
    "settembre",
    "ottobre",
    "novembre",
    "dicembre"
  ]
}, Ym = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: [
    "domenica",
    "lunedì",
    "martedì",
    "mercoledì",
    "giovedì",
    "venerdì",
    "sabato"
  ]
}, Xm = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, Gm = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, Jm = (e, t) => {
  const r = Number(e);
  return String(r);
}, Qm = {
  ordinalNumber: Jm,
  era: F({
    values: Km,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Um,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: qm,
    defaultWidth: "wide"
  }),
  day: F({
    values: Ym,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Xm,
    defaultWidth: "wide",
    formattingValues: Gm,
    defaultFormattingWidth: "wide"
  })
}, Zm = /^(\d+)(º)?/i, ev = /\d+/i, tv = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, rv = {
  any: [/^a/i, /^(d|e)/i]
}, nv = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, av = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ov = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, iv = {
  narrow: [
    /^g/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^g/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ge/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mag/i,
    /^gi/i,
    /^l/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, sv = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, uv = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, lv = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, dv = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, cv = {
  ordinalNumber: Be({
    matchPattern: Zm,
    parsePattern: ev,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: N({
    matchPatterns: tv,
    defaultMatchWidth: "wide",
    parsePatterns: rv,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: nv,
    defaultMatchWidth: "wide",
    parsePatterns: av,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: ov,
    defaultMatchWidth: "wide",
    parsePatterns: iv,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: sv,
    defaultMatchWidth: "wide",
    parsePatterns: uv,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: lv,
    defaultMatchWidth: "any",
    parsePatterns: dv,
    defaultParseWidth: "any"
  })
}, fv = {
  code: "it",
  formatDistance: jm,
  formatLong: Nm,
  formatRelative: Vm,
  localize: Qm,
  match: cv,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, mv = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, vv = (e, t, r) => {
  let n;
  const a = mv[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "over " + n : n + " geleden" : n;
}, hv = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, pv = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, yv = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gv = {
  date: H({
    formats: hv,
    defaultWidth: "full"
  }),
  time: H({
    formats: pv,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: yv,
    defaultWidth: "full"
  })
}, bv = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, Mv = (e, t, r, n) => bv[e], wv = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, Ev = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, Sv = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Pv = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, _v = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, Ov = (e, t) => Number(e) + "e", Cv = {
  ordinalNumber: Ov,
  era: F({
    values: wv,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Ev,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Sv,
    defaultWidth: "wide"
  }),
  day: F({
    values: Pv,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: _v,
    defaultWidth: "wide"
  })
}, Dv = /^(\d+)e?/i, Tv = /\d+/i, Av = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, kv = {
  any: [/^v/, /^n/]
}, xv = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, Rv = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Iv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, $v = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, jv = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, Lv = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, Wv = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, Fv = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, Nv = {
  ordinalNumber: Be({
    matchPattern: Dv,
    parsePattern: Tv,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: N({
    matchPatterns: Av,
    defaultMatchWidth: "wide",
    parsePatterns: kv,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: xv,
    defaultMatchWidth: "wide",
    parsePatterns: Rv,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: Iv,
    defaultMatchWidth: "wide",
    parsePatterns: $v,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: jv,
    defaultMatchWidth: "wide",
    parsePatterns: Lv,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: Wv,
    defaultMatchWidth: "any",
    parsePatterns: Fv,
    defaultParseWidth: "any"
  })
}, Hv = {
  code: "nl",
  formatDistance: vv,
  formatLong: gv,
  formatRelative: Mv,
  localize: Cv,
  match: Nv,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Bv = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, zv = (e, t, r) => {
  let n;
  const a = Bv[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "daqui a " + n : "há " + n : n;
}, Vv = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, Kv = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Uv = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, qv = {
  date: H({
    formats: Vv,
    defaultWidth: "full"
  }),
  time: H({
    formats: Kv,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Uv,
    defaultWidth: "full"
  })
}, Yv = {
  lastWeek: (e) => {
    const t = e.getDay();
    return "'" + (t === 0 || t === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, Xv = (e, t, r, n) => {
  const a = Yv[e];
  return typeof a == "function" ? a(t) : a;
}, Gv = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, Jv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Qv = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, Zv = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, eh = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, th = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, rh = (e, t) => Number(e) + "º", nh = {
  ordinalNumber: rh,
  era: F({
    values: Gv,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Jv,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Qv,
    defaultWidth: "wide"
  }),
  day: F({
    values: Zv,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: eh,
    defaultWidth: "wide",
    formattingValues: th,
    defaultFormattingWidth: "wide"
  })
}, ah = /^(\d+)(º|ª)?/i, oh = /\d+/i, ih = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, sh = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes da era comum)/i,
    /^(depois de cristo|era comum)/i
  ]
}, uh = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, lh = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, dh = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, ch = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ab/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, fh = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, mh = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, vh = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, hh = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, ph = {
  ordinalNumber: Be({
    matchPattern: ah,
    parsePattern: oh,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: N({
    matchPatterns: ih,
    defaultMatchWidth: "wide",
    parsePatterns: sh,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: uh,
    defaultMatchWidth: "wide",
    parsePatterns: lh,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: dh,
    defaultMatchWidth: "wide",
    parsePatterns: ch,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: fh,
    defaultMatchWidth: "wide",
    parsePatterns: mh,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: vh,
    defaultMatchWidth: "any",
    parsePatterns: hh,
    defaultParseWidth: "any"
  })
}, yh = {
  code: "pt",
  formatDistance: zv,
  formatLong: qv,
  formatRelative: Xv,
  localize: nh,
  match: ph,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, gh = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, bh = (e, t, r) => {
  let n;
  const a = gh[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", String(t)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "em " + n : "há " + n : n;
}, Mh = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, wh = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Eh = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Sh = {
  date: H({
    formats: Mh,
    defaultWidth: "full"
  }),
  time: H({
    formats: wh,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Eh,
    defaultWidth: "full"
  })
}, Ph = {
  lastWeek: (e) => {
    const t = e.getDay();
    return "'" + (t === 0 || t === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, _h = (e, t, r, n) => {
  const a = Ph[e];
  return typeof a == "function" ? a(t) : a;
}, Oh = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, Ch = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Dh = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, Th = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado"
  ],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, Ah = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, kh = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, xh = (e, t) => {
  const r = Number(e);
  return (t == null ? void 0 : t.unit) === "week" ? r + "ª" : r + "º";
}, Rh = {
  ordinalNumber: xh,
  era: F({
    values: Oh,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: Ch,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: Dh,
    defaultWidth: "wide"
  }),
  day: F({
    values: Th,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: Ah,
    defaultWidth: "wide",
    formattingValues: kh,
    defaultFormattingWidth: "wide"
  })
}, Ih = /^(\d+)[ºªo]?/i, $h = /\d+/i, jh = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, Lh = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, Wh = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Fh = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nh = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, Hh = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i
  ]
}, Bh = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, zh = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, Vh = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, Kh = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, Uh = {
  ordinalNumber: Be({
    matchPattern: Ih,
    parsePattern: $h,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: N({
    matchPatterns: jh,
    defaultMatchWidth: "wide",
    parsePatterns: Lh,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: Wh,
    defaultMatchWidth: "wide",
    parsePatterns: Fh,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: Nh,
    defaultMatchWidth: "wide",
    parsePatterns: Hh,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: Bh,
    defaultMatchWidth: "wide",
    parsePatterns: zh,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: Vh,
    defaultMatchWidth: "any",
    parsePatterns: Kh,
    defaultParseWidth: "any"
  })
}, qh = {
  code: "pt-BR",
  formatDistance: bh,
  formatLong: Sh,
  formatRelative: _h,
  localize: Rh,
  match: Uh,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Yh = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} veckor"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} veckor"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, Xh = [
  "noll",
  "en",
  "två",
  "tre",
  "fyra",
  "fem",
  "sex",
  "sju",
  "åtta",
  "nio",
  "tio",
  "elva",
  "tolv"
], Gh = (e, t, r) => {
  let n;
  const a = Yh[e];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace(
    "{{count}}",
    t < 13 ? Xh[t] : String(t)
  ), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + n : n + " sedan" : n;
}, Jh = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, Qh = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Zh = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ep = {
  date: H({
    formats: Jh,
    defaultWidth: "full"
  }),
  time: H({
    formats: Qh,
    defaultWidth: "full"
  }),
  dateTime: H({
    formats: Zh,
    defaultWidth: "full"
  })
}, tp = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, rp = (e, t, r, n) => tp[e], np = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, ap = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, op = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "maj",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, ip = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, sp = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, up = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, lp = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
      case 2:
        return r + ":a";
    }
  return r + ":e";
}, dp = {
  ordinalNumber: lp,
  era: F({
    values: np,
    defaultWidth: "wide"
  }),
  quarter: F({
    values: ap,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: F({
    values: op,
    defaultWidth: "wide"
  }),
  day: F({
    values: ip,
    defaultWidth: "wide"
  }),
  dayPeriod: F({
    values: sp,
    defaultWidth: "wide",
    formattingValues: up,
    defaultFormattingWidth: "wide"
  })
}, cp = /^(\d+)(:a|:e)?/i, fp = /\d+/i, mp = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, vp = {
  any: [/^f/i, /^[ev]/i]
}, hp = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, pp = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yp = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, gp = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, bp = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, Mp = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, wp = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, Ep = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, Sp = {
  ordinalNumber: Be({
    matchPattern: cp,
    parsePattern: fp,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: N({
    matchPatterns: mp,
    defaultMatchWidth: "wide",
    parsePatterns: vp,
    defaultParseWidth: "any"
  }),
  quarter: N({
    matchPatterns: hp,
    defaultMatchWidth: "wide",
    parsePatterns: pp,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: N({
    matchPatterns: yp,
    defaultMatchWidth: "wide",
    parsePatterns: gp,
    defaultParseWidth: "any"
  }),
  day: N({
    matchPatterns: bp,
    defaultMatchWidth: "wide",
    parsePatterns: Mp,
    defaultParseWidth: "any"
  }),
  dayPeriod: N({
    matchPatterns: wp,
    defaultMatchWidth: "any",
    parsePatterns: Ep,
    defaultParseWidth: "any"
  })
}, Pp = {
  code: "sv",
  formatDistance: Gh,
  formatLong: ep,
  formatRelative: rp,
  localize: dp,
  match: Sp,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, de = {
  da: qd,
  de: Ec,
  enAU: Yc,
  enCA: tf,
  enGB: sf,
  enIN: ff,
  enNZ: yf,
  enUS: Ef,
  enZA: Cf,
  es: am,
  fr: Im,
  it: fv,
  nl: Hv,
  pt: yh,
  ptBR: qh,
  sv: Pp
}, Pr = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: de.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: de.ptBR,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: de.enCA,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: de.es,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: de.enAU,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: de.de,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: de.da,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: de.es,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: de.fr,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: de.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: de.enIN,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: de.it,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: de.enGB,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: de.enGB,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: de.nl,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: de.enNZ,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: de.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: de.pt,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: de.sv,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: de.it,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: de.enUS,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: de.enGB,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: de.enUS,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: de.enZA,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, _p = [Pr.IT.name, Pr.ES.name, Pr.BR.name], Op = [
  { id: 18, name: "AMERICAN FOOTBALL", translationFile: "american_football" },
  { id: 11, name: "ATHLETICS", translationFile: "athletics" },
  { id: 23, name: "AUSSIE RULES", translationFile: "aussie_rules" },
  { id: 32, name: "BADMINTON", translationFile: "badminton" },
  { id: 48, name: "BANDY", translationFile: "bandy" },
  { id: 46, name: "BASEBALL", translationFile: "baseball" },
  { id: 47, name: "BASKETBALL", translationFile: "basketball" },
  { id: 28, name: "BETTYPE", translationFile: "bettype" },
  { id: 31, name: "BOWLS", translationFile: "bowls" },
  { id: 10, name: "BOXING", translationFile: "boxing" },
  { id: 76, name: "CASINO", translationFile: "casino" },
  { id: 19, name: "CRICKET", translationFile: "cricket" },
  { id: 14, name: "CYCLING", translationFile: "cycling" },
  { id: 21, name: "DARTS", translationFile: "darts" },
  { id: 49, name: "DUMMY", translationFile: "dummy" },
  { id: 33, name: "EQUESTRIAN", translationFile: "equestrian" },
  { id: 34, name: "FINANCIAL", translationFile: "financial" },
  { id: 29, name: "FLOORBALL", translationFile: "floorball" },
  { id: 2, name: "FOOTBALL", translationFile: "football" },
  { id: 24, name: "GAELIC SPORTS", translationFile: "gaelic_sports" },
  { id: 6, name: "GOLF", translationFile: "golf" },
  { id: 5, name: "GREYHOUNDS", translationFile: "greyhounds" },
  { id: 35, name: "HANDBALL", translationFile: "handball" },
  { id: 74, name: "HARNESS RACING", translationFile: "harness_racing" },
  { id: 36, name: "HOCKEY", translationFile: "hockey" },
  { id: 3, name: "HORSE RACING", translationFile: "horse_racing" },
  { id: 45, name: "ICE HOCKEY", translationFile: "ice_hockey" },
  { id: 0, name: "LABEL", translationFile: "label" },
  { id: 27, name: "MENU", translationFile: "menu" },
  { id: 17, name: "MOTOR SPORT", translationFile: "motor_sport" },
  { id: 37, name: "NETBALL", translationFile: "netball" },
  { id: 62, name: "OLYMPICS", translationFile: "olympics" },
  { id: 26, name: "OTHER SPORTS", translationFile: "other_sports" },
  { id: 25, name: "POKER", translationFile: "poker" },
  { id: 68, name: "POLITICS", translationFile: "politics" },
  { id: 20, name: "POOL", translationFile: "pool" },
  { id: 22, name: "ROWING", translationFile: "rowing" },
  { id: 30, name: "RUGBY LEAGUE", translationFile: "rugby_league" },
  { id: 9, name: "RUGBY UNION", translationFile: "rugby_union" },
  { id: 8, name: "SNOOKER", translationFile: "snooker" },
  { id: 15, name: "SPECIALS", translationFile: "specials" },
  { id: 38, name: "SWIMMING", translationFile: "swimming" },
  { id: 39, name: "TABLE TENNIS", translationFile: "table_tennis" },
  { id: 7, name: "TENNIS", translationFile: "tennis" },
  { id: 40, name: "TROTTING", translationFile: "trotting" },
  { id: 71, name: "TV", translationFile: "tv" },
  { id: 61, name: "VIRTUAL FOOTBALL", translationFile: "virtual_football" },
  { id: 58, name: "VIRTUAL MOTORSPORT", translationFile: "virtual_motorsport" },
  { id: 41, name: "VOLLEYBALL", translationFile: "volleyball" },
  { id: 42, name: "WATER POLO", translationFile: "water_polo" },
  { id: 43, name: "WINTER SPORTS", translationFile: "winter_sports" },
  { id: 44, name: "YACHTING", translationFile: "yachting" }
];
/*! js-cookie v3.0.8 | MIT */
function Gt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      n !== "__proto__" && (e[n] = r[n]);
  }
  return e;
}
var Cp = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Hr(e, t) {
  function r(a, o, u) {
    if (!(typeof document > "u")) {
      u = Gt({}, t, u), typeof u.expires == "number" && (u.expires = new Date(Date.now() + u.expires * 864e5)), u.expires && (u.expires = u.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var s in u)
        u[s] && (i += "; " + s, u[s] !== !0 && (i += "=" + u[s].split(";")[0]));
      return document.cookie = a + "=" + e.write(o, a) + i;
    }
  }
  function n(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], u = {}, i = 0; i < o.length; i++) {
        var s = o[i].split("="), l = s.slice(1).join("=");
        try {
          var d = decodeURIComponent(s[0]);
          if (d in u || (u[d] = e.read(l, d)), a === d)
            break;
        } catch {
        }
      }
      return a ? u[a] : u;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(a, o) {
        r(
          a,
          "",
          Gt({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return Hr(this.converter, Gt({}, this.attributes, a));
      },
      withConverter: function(a) {
        return Hr(Gt({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
Hr(Cp, { path: "/" });
Ge(void 0);
function _r(e, t) {
  return +(Math.round(+(e + "e+" + t)) + "e-" + t);
}
function Dp(e) {
  switch (!0) {
    case e < 1.01:
      return _r(e, 3);
    case e < 10:
      return _r(e, 2);
    case e < 20:
      return _r(e, 1);
    default:
      return Math.ceil(e);
  }
}
function Tp(e) {
  const t = [" v ", " at "];
  for (const r of t) {
    const n = e.split(r);
    if (n.length === 2) {
      const [a, o] = n.map((u) => u.trim());
      return r === " v " ? { away: o, first: a, home: a, second: o, separator: r, success: !0 } : { away: a, first: a, home: o, second: o, separator: r, success: !0 };
    }
  }
  return {
    away: "",
    first: "",
    home: "",
    second: "",
    separator: "",
    success: !1
  };
}
function fo(e, t = {}, r) {
  const a = r || (() => {
    if (typeof window < "u")
      return window.dataLayer = window.dataLayer || [], window.dataLayer;
  })();
  a && a.push({
    event: e,
    ...t
  });
}
const ln = () => {
  const { analyticsDataLayer: e, analyticsImpressionEventData: t, analyticsImpressionEventName: r, disableAnalytics: n } = lr(), a = L(
    (o, u = {}) => {
      n || fo(o, { ...t, ...u }, e);
    },
    [e, t, n]
  );
  return {
    analyticsDataLayer: e,
    analyticsImpressionEventData: t,
    // Suppress impressions entirely when analytics is disabled.
    impressionEventName: n ? void 0 : r,
    track: a
  };
}, Ap = ({
  betId: e,
  betName: t,
  betOdds: r,
  bookieCode: n,
  marketName: a,
  subeventName: o
}) => {
  const u = Sr((m) => m.selectedBets), i = Sr((m) => m.addSelectedBet), s = Sr((m) => m.removeSelectedBet), l = Ne(() => u.some((m) => m.betId === e), [e, u]), d = L(() => {
    try {
      window.bettingActions.addOrRemoveFromBetslip(
        [{ betId: e, selectedBookie: n }],
        [e],
        n,
        r == null ? void 0 : r.toString(),
        t,
        "most-popular-bets",
        o,
        a,
        "n/a"
      );
    } catch (m) {
      console.error("useBetslip.toggleBetslipBet", m);
    }
    l ? s(e) : i({ betId: e, bookieCode: n });
  }, [
    l,
    s,
    e,
    i,
    n,
    r,
    t,
    o,
    a
  ]);
  return { isBookieBetSelected: l, toggleBetslipBet: d };
}, kp = "application/json", mo = "Content-Type", ft = Symbol(), vo = Symbol();
function oa(e = {}) {
  var t;
  const r = e instanceof Array ? Object.fromEntries(e) : e;
  return (t = Object.entries(r).find(([n]) => n.toLowerCase() === mo.toLowerCase())) === null || t === void 0 ? void 0 : t[1];
}
function ia(e) {
  return /^application\/.*json.*/.test(e);
}
const rt = function(e, t, r = !1) {
  return Object.entries(t).reduce((n, [a, o]) => {
    const u = e[a];
    return Array.isArray(u) && Array.isArray(o) ? n[a] = r ? [...u, ...o] : o : typeof u == "object" && typeof o == "object" ? n[a] = rt(u, o, r) : n[a] = o, n;
  }, { ...e });
}, Mt = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(e, t = !0, r = !1, ...n) {
    const a = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);
    if (t && !a)
      throw new Error(e + " is not defined");
    return r && a ? new a(...n) : a;
  }
};
function xp(e, t = !1) {
  Mt.options = t ? e : rt(Mt.options, e);
}
function Rp(e, t = !1) {
  Mt.polyfills = t ? e : rt(Mt.polyfills, e);
}
function Ip(e) {
  Mt.errorType = e;
}
const $p = (e) => (t) => e.reduceRight((r, n) => n(r), t) || t;
class ho extends Error {
}
const jp = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  e = e._addons.reduce((b, g) => g.beforeRequest && g.beforeRequest(b, e._options, t) || b, e);
  const { _url: r, _options: n, _config: a, _catchers: o, _resolvers: u, _middlewares: i, _addons: s } = e, l = new Map(o), d = rt(a.options, n);
  let m = r;
  const v = $p(i)((b, g) => (m = b, a.polyfill("fetch")(b, g)))(r, d), c = new Error(), h = v.catch((b) => {
    throw { [ft]: b };
  }).then((b) => {
    var g;
    if (!b.ok) {
      const E = new ho();
      if (E.cause = c, E.stack = E.stack + `
CAUSE: ` + c.stack, E.response = b, E.status = b.status, E.url = m, b.type === "opaque")
        throw E;
      const P = a.errorType === "json" || ((g = b.headers.get("Content-Type")) === null || g === void 0 ? void 0 : g.split(";")[0]) === "application/json";
      return (a.errorType ? P ? b.text() : b[a.errorType]() : Promise.resolve(b.body)).then((D) => {
        if (E.message = typeof D == "string" ? D : b.statusText, D)
          if (P && typeof D == "string") {
            E.text = D;
            try {
              E.json = JSON.parse(D);
            } catch {
            }
          } else
            E[a.errorType] = D;
        throw E;
      });
    }
    return b;
  }), f = (b) => b.catch((g) => {
    const E = Object.prototype.hasOwnProperty.call(g, ft), P = E ? g[ft] : g, _ = (P == null ? void 0 : P.status) && l.get(P.status) || l.get(P == null ? void 0 : P.name) || E && l.has(ft) && l.get(ft);
    if (_)
      return _(P, e);
    const D = l.get(vo);
    if (D)
      return D(P, e);
    throw P;
  }), p = (b) => (g) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ f(b ? h.then((E) => E && E[b]()).then((E) => g ? g(E) : E) : h.then((E) => g ? g(E) : E)), y = {
    _wretchReq: e,
    _fetchReq: v,
    _sharedState: t,
    res: p(null),
    json: p("json"),
    blob: p("blob"),
    formData: p("formData"),
    arrayBuffer: p("arrayBuffer"),
    text: p("text"),
    error(b, g) {
      return l.set(b, g), this;
    },
    badRequest(b) {
      return this.error(400, b);
    },
    unauthorized(b) {
      return this.error(401, b);
    },
    forbidden(b) {
      return this.error(403, b);
    },
    notFound(b) {
      return this.error(404, b);
    },
    timeout(b) {
      return this.error(408, b);
    },
    internalError(b) {
      return this.error(500, b);
    },
    fetchError(b) {
      return this.error(ft, b);
    }
  }, M = s.reduce((b, g) => ({
    ...b,
    ...typeof g.resolver == "function" ? g.resolver(b) : g.resolver
  }), y);
  return u.reduce((b, g) => g(b, e), M);
}, Lp = {
  _url: "",
  _options: {},
  _config: Mt,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(e) {
    return { ...this, _addons: [...this._addons, e], ...e.wretch };
  },
  errorType(e) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: e
      }
    };
  },
  polyfills(e, t = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: t ? e : rt(this._config.polyfills, e)
      }
    };
  },
  url(e, t = !1) {
    if (t)
      return { ...this, _url: e };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + e + "?" + r[1] : this._url + e
    };
  },
  options(e, t = !1) {
    return { ...this, _options: t ? e : rt(this._options, e) };
  },
  headers(e) {
    const t = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
    return { ...this, _options: rt(this._options, { headers: t }) };
  },
  accept(e) {
    return this.headers({ Accept: e });
  },
  content(e) {
    return this.headers({ [mo]: e });
  },
  auth(e) {
    return this.headers({ Authorization: e });
  },
  catcher(e, t) {
    const r = new Map(this._catchers);
    return r.set(e, t), { ...this, _catchers: r };
  },
  catcherFallback(e) {
    return this.catcher(vo, e);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(e, t = !1) {
    return { ...this, _resolvers: t ? [e] : [...this._resolvers, e] };
  },
  defer(e, t = !1) {
    return {
      ...this,
      _deferred: t ? [e] : [...this._deferred, e]
    };
  },
  middlewares(e, t = !1) {
    return {
      ...this,
      _middlewares: t ? e : [...this._middlewares, ...e]
    };
  },
  fetch(e = this._options.method, t = "", r = null) {
    let n = this.url(t).options({ method: e });
    const a = oa(n._options.headers), o = this._config.polyfill("FormData", !1), u = typeof r == "object" && !(o && r instanceof o) && (!n._options.headers || !a || ia(a));
    return n = r ? u ? n.json(r, a) : n.body(r) : n, jp(n._deferred.reduce((i, s) => s(i, i._url, i._options), n));
  },
  get(e = "") {
    return this.fetch("GET", e);
  },
  delete(e = "") {
    return this.fetch("DELETE", e);
  },
  put(e, t = "") {
    return this.fetch("PUT", t, e);
  },
  post(e, t = "") {
    return this.fetch("POST", t, e);
  },
  patch(e, t = "") {
    return this.fetch("PATCH", t, e);
  },
  head(e = "") {
    return this.fetch("HEAD", e);
  },
  opts(e = "") {
    return this.fetch("OPTIONS", e);
  },
  body(e) {
    return { ...this, _options: { ...this._options, body: e } };
  },
  json(e, t) {
    const r = oa(this._options.headers);
    return this.content(t || ia(r) && r || kp).body(JSON.stringify(e));
  }
};
function ot(e = "", t = {}) {
  return { ...Lp, _url: e, _options: t };
}
ot.default = ot;
ot.options = xp;
ot.errorType = Ip;
ot.polyfills = Rp;
ot.WretchError = ho;
class Wp extends Error {
  constructor(r, n, a, o, u) {
    super(r);
    ze(this, "statusCode");
    ze(this, "endpoint");
    ze(this, "args");
    ze(this, "response");
    this.name = "ApiError", this.statusCode = n, this.endpoint = a, this.args = o, this.response = u;
  }
}
class dn extends Wp {
  constructor(t, r, n, a) {
    super(`Client error ${t} occurred while fetching ${r}`, t, r, n, a), this.name = "Api4xxError";
  }
}
class Fp extends dn {
  constructor(t, r, n) {
    super(404, t, r, n), this.name = "Api404Error";
  }
}
class Np extends dn {
  constructor(t, r, n) {
    super(400, t, r, n), this.name = "Api400Error";
  }
}
class Hp {
  constructor(t = {}) {
    ze(this, "logger");
    ze(this, "notFoundLogLevel");
    ze(this, "badRequestLogLevel");
    ze(this, "other4xxLogLevel");
    this.logger = t.logger, this.notFoundLogLevel = t.notFoundLogLevel || "info", this.badRequestLogLevel = t.badRequestLogLevel || "warn", this.other4xxLogLevel = t.other4xxLogLevel || "warn";
  }
  log(t, r, n) {
    this.logger && this.logger[t](r, n);
  }
  async handleApiError(t, r, n) {
    if (!(t instanceof Response))
      throw t;
    const { status: a } = t;
    if (a === 404) {
      const o = new Fp(r, n, t);
      return this.log(this.notFoundLogLevel, o.message, {
        args: n,
        endpoint: r,
        statusCode: a
      }), null;
    }
    if (a === 400) {
      const o = new Np(r, n, t);
      return this.log(this.badRequestLogLevel, o.message, {
        args: n,
        endpoint: r,
        statusCode: a
      }), null;
    }
    if (a >= 400 && a < 500) {
      const o = new dn(a, r, n, t);
      return this.log(this.other4xxLogLevel, o.message, {
        args: n,
        endpoint: r,
        statusCode: a
      }), null;
    }
    throw t;
  }
}
const Bp = (e, t) => {
  const r = new Hp(t);
  return e.catcher(404, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(400, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(401, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(403, async (n) => (await r.handleApiError(n.response, n.url), null)).catcherFallback(async (n) => {
    if (n.status >= 400 && n.status < 500)
      return await r.handleApiError(n.response, n.url), null;
    throw n;
  });
}, zp = (e, t) => {
  var n, a;
  const r = new URLSearchParams();
  return (n = t.categoryGroupIds) != null && n.length ? r.set("categoryGroupIds", t.categoryGroupIds.join(",")) : t.categoryGroupId != null && r.set("categoryGroupIds", String(t.categoryGroupId)), (a = t.eventIds) != null && a.length && r.set("eventIds", t.eventIds.join(",")), t.subeventId != null && r.set("subeventId", String(t.subeventId)), t.limit != null && r.set("limit", String(t.limit)), t.includeAll && r.set("includeAll", "true"), `${e}/v1/popular-bets?${r.toString()}`;
}, Qt = async (e, t, { apiKey: r, countryCode: n, repub: a, subdivisionCode: o }, u) => {
  if (!e)
    throw new Error("No API endpoint");
  const i = zp(e, t), s = {
    accept: "application/json",
    "content-type": "application/json"
  };
  r && (s["api-key"] = r), a && (s.repub = a.toUpperCase()), n && (s["country-code"] = n.toUpperCase()), o && (s["subdivision-code"] = o.toUpperCase());
  const l = Bp(ot(i, { headers: s }), u);
  try {
    return await l.get().json();
  } catch (d) {
    return u != null && u.logger && u.logger.error("Error fetching most-popular-bets data", d), null;
  }
}, Ct = (e) => ["most-popular-bets", e], Vp = (e, t) => {
  if (!e)
    return null;
  const r = e.startTime != null && t >= Date.parse(e.startTime), n = r ? e.inPlaySubeventId : e.preMatchSubeventId, a = r ? e.preMatchSubeventId : e.inPlaySubeventId;
  return n ?? a ?? null;
}, po = (e, t = Date.now()) => {
  var o, u;
  const r = e.subeventId ?? Vp(e.subeventMeta, t);
  if (r != null)
    return { kind: "subevent", subeventId: r };
  const a = ((o = e.eventIds) != null && o.length ? e.eventIds : ((u = e.eventMetas) == null ? void 0 : u.map((i) => i.eventId)) ?? []).filter((i) => i != null);
  return a.length > 0 ? { eventIds: a, kind: "events" } : { kind: "sports" };
}, nt = -1, Kp = () => {
  var E;
  const e = lr(), { apiKey: t, countryCode: r, dataApiEndpoint: n, includeAll: a, limit: o, repub: u, sports: i, subdivisionCode: s } = e, l = po(e), d = l.kind !== "sports", m = a ? nt : ((E = i[0]) == null ? void 0 : E.categoryGroupId) ?? nt, [v, c] = ue(m), h = { apiKey: t, countryCode: r, repub: u, subdivisionCode: s }, f = v === nt, p = (() => {
    switch (l.kind) {
      case "subevent":
        return { limit: o, subeventId: l.subeventId };
      case "events":
        return { eventIds: l.eventIds, limit: o };
      default:
        return f && a ? { categoryGroupIds: i.map((_) => _.categoryGroupId), includeAll: !0, limit: o } : { categoryGroupId: f ? void 0 : v, limit: o };
    }
  })(), { data: y, error: M } = $o({
    queryFn: () => Qt(n, p, h, { logger: console }),
    queryKey: Ct(p)
  }), b = (y == null ? void 0 : y.bets) ?? [];
  return {
    allSportsBets: (y == null ? void 0 : y.allSportsBets) ?? [],
    bets: b,
    error: M,
    includeAll: a,
    isSingleTarget: d,
    selectedCategoryGroupId: v,
    setSelectedCategoryGroupId: c,
    sports: i
  };
};
var Up = typeof Ot == "object" && Ot && Ot.Object === Object && Ot, qp = typeof self == "object" && self && self.Object === Object && self;
Up || qp || Function("return this")();
function Yp({
  threshold: e = 0,
  root: t = null,
  rootMargin: r = "0%",
  freezeOnceVisible: n = !1,
  initialIsIntersecting: a = !1,
  onChange: o
} = {}) {
  var u;
  const [i, s] = ue(null), [l, d] = ue(() => ({
    isIntersecting: a,
    entry: void 0
  })), m = X();
  m.current = o;
  const v = ((u = l.entry) == null ? void 0 : u.isIntersecting) && n;
  J(() => {
    if (!i || !("IntersectionObserver" in window) || v)
      return;
    let f;
    const p = new IntersectionObserver(
      (y) => {
        const M = Array.isArray(p.thresholds) ? p.thresholds : [p.thresholds];
        y.forEach((b) => {
          const g = b.isIntersecting && M.some((E) => b.intersectionRatio >= E);
          d({ isIntersecting: g, entry: b }), m.current && m.current(g, b), g && n && f && (f(), f = void 0);
        });
      },
      { threshold: e, root: t, rootMargin: r }
    );
    return p.observe(i), () => {
      p.disconnect();
    };
  }, [
    i,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(e),
    t,
    r,
    v,
    n
  ]);
  const c = X(null);
  J(() => {
    var f;
    !i && ((f = l.entry) != null && f.target) && !n && !v && c.current !== l.entry.target && (c.current = l.entry.target, d({ isIntersecting: a, entry: void 0 }));
  }, [i, l.entry, n, v, a]);
  const h = [
    s,
    !!l.isIntersecting,
    l.entry
  ];
  return h.ref = h[0], h.isIntersecting = h[1], h.entry = h[2], h;
}
function Xp(e, t, r) {
  const { isIntersecting: n, ref: a } = Yp({ threshold: 0.5 }), o = X(!1);
  return J(() => {
    e && n && !o.current && (fo(e, t, r), o.current = !0);
  }, [r, t, e, n]), a;
}
const Br = (e, t) => {
  var r;
  return t === nt ? "All Sports" : ((r = e.find((n) => n.categoryGroupId === t)) == null ? void 0 : r.label) ?? "";
}, Gp = (e, t, r) => {
  const n = r(e);
  return t ? `${n} ${t}`.trim() : n;
}, Jp = (e, t) => {
  const r = Tp(e);
  return r.success ? `${t(r.first)}${r.separator}${t(r.second)}`.trim() : t(e);
}, Qp = "_container_dvhg8_1", Zp = "_header_dvhg8_9", ey = "_title_dvhg8_16", ty = "_sportButton_dvhg8_26", ry = "_sportButtonLabel_dvhg8_42", ny = "_sportButtonChevron_dvhg8_49", ay = "_sportButtonChevronOpen_dvhg8_56", oy = "_sportMenu_dvhg8_60", iy = "_sportMenuItem_dvhg8_87", sy = "_sportMenuItemSelected_dvhg8_110", uy = "_list_dvhg8_114", ly = "_row_dvhg8_121", dy = "_link_dvhg8_128", cy = "_linkNoIcon_dvhg8_136", fy = "_sportIcon_dvhg8_140", my = "_betInfo_dvhg8_148", vy = "_betName_dvhg8_156", hy = "_subeventName_dvhg8_162", py = "_oddsButton_dvhg8_167", yy = "_selected_dvhg8_180", gy = "_odds_dvhg8_167", ve = {
  container: Qp,
  header: Zp,
  title: ey,
  sportButton: ty,
  sportButtonLabel: ry,
  sportButtonChevron: ny,
  sportButtonChevronOpen: ay,
  sportMenu: oy,
  sportMenuItem: iy,
  sportMenuItemSelected: sy,
  list: uy,
  row: ly,
  link: dy,
  linkNoIcon: cy,
  sportIcon: fy,
  betInfo: my,
  betName: vy,
  subeventName: hy,
  oddsButton: py,
  selected: yy,
  odds: gy
}, by = ({ includeAll: e, onSelect: t, selectedCategoryGroupId: r, sports: n }) => {
  const a = cl({ animated: !1, gutter: 4, placement: "bottom-end" }), { track: o } = ln(), { t: u } = on("label"), i = ({ categoryGroupId: v, label: c }) => v === nt ? u("CX_MOST_POPULAR_BETS_ALL_SPORTS", { defaultValue: "All Sports" }) : u(c, { defaultValue: c }), s = e ? [{ categoryGroupId: nt, label: "All Sports" }, ...n] : n, l = s.find((v) => v.categoryGroupId === r) ?? s[0], d = l ? i(l) : "", m = (v) => {
    v !== r && o("most_popular_bets_filter_change", {
      fromSport: Br(n, r),
      toSport: Br(n, v)
    }), t(v), a.hide();
  };
  return /* @__PURE__ */ je(ua, { children: [
    /* @__PURE__ */ je(
      rl,
      {
        ...a,
        "aria-label": "Select sport",
        className: ve.sportButton,
        "data-testid": "most-popular-bets-sport-select",
        children: [
          /* @__PURE__ */ W("span", { className: ve.sportButtonLabel, children: d }),
          /* @__PURE__ */ W(
            "svg",
            {
              "aria-hidden": "true",
              className: Lt(ve.sportButtonChevron, a.visible && ve.sportButtonChevronOpen),
              fill: "none",
              height: "16",
              viewBox: "0 0 16 16",
              width: "16",
              children: /* @__PURE__ */ W("path", { d: "M4 6l4 4 4-4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ W(Qu, { ...a, "aria-label": "Sports", className: ve.sportMenu, "data-testid": "most-popular-bets-sport-menu", children: s.map((v) => /* @__PURE__ */ De(
      dl,
      {
        ...a,
        className: Lt(
          ve.sportMenuItem,
          v.categoryGroupId === r && ve.sportMenuItemSelected
        ),
        "data-testid": "most-popular-bets-sport-option",
        key: v.categoryGroupId,
        onClick: () => m(v.categoryGroupId)
      },
      i(v)
    )) })
  ] });
}, My = (e) => /* @__PURE__ */ W("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...e, children: /* @__PURE__ */ W(
  "path",
  {
    d: "M18.574 4.241a1.5 1.5 0 011.128 1.03l.03.113a12.046 12.046 0 01-3.277 11.07A12.025 12.025 0 017.925 20c-.842 0-1.693-.089-2.54-.269a1.503 1.503 0 01-1.144-1.157A12.14 12.14 0 017.567 7.567 12.145 12.145 0 0118.574 4.24zM5.085 14.789a11.173 11.173 0 00.137 3.587c.037.183.19.338.373.376 1.211.26 2.434.313 3.624.172L5.085 14.79zm8.505-9.488a11.14 11.14 0 00-5.315 2.974A11.152 11.152 0 005.3 13.59l5.122 5.125a11.069 11.069 0 005.325-2.967 11.057 11.057 0 002.965-5.325L13.59 5.301zm-.737 3.847l.645.645.647-.646a.5.5 0 01.707.707l-.647.646.646.646a.499.499 0 11-.706.707l-.647-.646-.793.793.647.647a.5.5 0 01-.257.844L13 13.5a.5.5 0 01-.353-.147L12 12.706l-.793.793.646.647a.499.499 0 11-.705.707l-.648-.647-.645.647a.5.5 0 01-.258.136l-.095.01a.5.5 0 01-.354-.853l.645-.647-.645-.646a.5.5 0 01.707-.707l.645.646.791-.792-.645-.645a.5.5 0 01.707-.707l.645.645.793-.792-.645-.645a.5.5 0 01.707-.707zM16.16 5c-.46 0-.918.028-1.371.085l4.134 4.135c.14-1.191.088-2.415-.17-3.628a.496.496 0 00-.377-.371A11.245 11.245 0 0016.16 5z",
    fill: "currentColor"
  }
) }), wy = (e) => /* @__PURE__ */ W("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...e, children: /* @__PURE__ */ W(
  "path",
  {
    d: "M17.5 4a2.503 2.503 0 011.538 4.472L7.58 17.892c.084.189.128.395.128.609 0 .401-.157.777-.44 1.061-.283.282-.66.438-1.06.438-.35 0-.682-.12-.95-.339l-.111-.1-.707-.707c-.284-.284-.44-.661-.44-1.062s.157-.777.44-1.061c.432-.43 1.111-.533 1.66-.305L15.528 4.96a.268.268 0 01.035-.048A2.502 2.502 0 0117.5 4zM5.147 17.44a.494.494 0 000 .706l.707.708a.51.51 0 00.707 0 .496.496 0 000-.707l-.707-.707a.512.512 0 00-.707 0zm3.296-2.289L6.88 17.052l.067.067 1.901-1.563-.405-.405zM17.5 5c-.436 0-.844.184-1.129.507l-.031.042-7.259 8.826.543.543 8.827-7.258.042-.031A1.502 1.502 0 0017.5 5zM6 4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z",
    fill: "currentColor"
  }
) }), Ey = (e) => /* @__PURE__ */ W("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...e, children: /* @__PURE__ */ W(
  "path",
  {
    d: "M17.656 6.34A7.956 7.956 0 0120 12a7.95 7.95 0 01-2.344 5.66A7.974 7.974 0 0112 20a7.97 7.97 0 01-5.657-2.34A7.953 7.953 0 014 12c0-2.059.771-3.999 2.178-5.489l.165-.17c3.118-3.12 8.194-3.122 11.313 0zm-8.142 8.853l-2.099 2.101a6.975 6.975 0 004.089 1.69 8.707 8.707 0 00-1.99-3.79zm2.485-2.486l-1.776 1.777a9.738 9.738 0 012.308 4.496 6.975 6.975 0 004.052-1.685l-4.584-4.588zm2.484-2.484L12.707 12l4.584 4.587a6.944 6.944 0 001.69-4.055 9.734 9.734 0 01-4.497-2.309zm-9.465 2.272l.013.173a6.942 6.942 0 001.678 3.918l2.099-2.1a8.72 8.72 0 00-3.79-1.991zm.013-1.163l-.01.136a9.709 9.709 0 014.496 2.31L11.292 12 6.709 7.414a6.957 6.957 0 00-1.678 3.918zM17.29 7.414l-2.098 2.1a8.752 8.752 0 003.791 1.992 6.941 6.941 0 00-1.693-4.092zM11.47 5.02l-.14.011a6.976 6.976 0 00-3.913 1.676L12 11.293l1.777-1.778a9.714 9.714 0 01-2.306-4.494h-.002zm1.027-.003l.042.17a8.734 8.734 0 001.947 3.618l2.098-2.099a6.968 6.968 0 00-4.086-1.689h-.001z",
    fill: "currentColor"
  }
) }), Sy = (e) => /* @__PURE__ */ W("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...e, children: /* @__PURE__ */ W(
  "path",
  {
    d: "M15.92 4a4.13 4.13 0 013.015 1.303 3.96 3.96 0 011.048 3.063l-.665 7.179a.505.505 0 01-.508.455v3.5c0 .276-.229.5-.51.5H9.106a.505.505 0 01-.51-.5V16l-.071-.006-.034-.004-.044-.012-.039-.012-.025-.012a.518.518 0 01-.137-.088l-4.071-3.49A.494.494 0 014 12v-1.5C4 9.122 5.146 8 6.553 8h.854c0-.992.378-1.958 1.065-2.697A4.125 4.125 0 0111.486 4h4.433zm-4.25 12H9.618v3h8.17v-3h-6.116zm2.543 1c.282 0 .51.224.51.5s-.228.5-.51.5h-1.021c-.281 0-.51-.224-.51-.5s.229-.5.51-.5h1.022zM15.92 5h-4.433a3.05 3.05 0 00-2.26.977 2.972 2.972 0 00-.786 2.297l.015.141a.538.538 0 01.007.069L9.107 15h9.236l.622-6.725a2.962 2.962 0 00-.787-2.299A3.05 3.05 0 0015.92 5zM7.483 9h-.93c-.844 0-1.532.673-1.532 1.5v1.273l2.95 2.528L7.484 9z",
    fill: "currentColor"
  }
) }), Py = (e) => /* @__PURE__ */ W("svg", { fill: "none", height: "1em", viewBox: "0.48 0.48 17.04 17.04", width: "1em", ...e, children: /* @__PURE__ */ W(
  "path",
  {
    d: "M1.05194 2.68363L1.81307 2.98149C1.12782 4.74838 0.843008 7.04121 0.733028 8.27806C0.666142 9.03006 0.684423 9.70762 0.789032 10.3496C1.44787 14.3885 4.90112 17.3202 9.0002 17.3202C13.0993 17.3202 16.5525 14.3885 17.2114 10.3493C17.316 9.7074 17.3344 9.02983 17.2674 8.2778C17.1574 7.04091 16.8726 4.74823 16.1873 2.98123L16.9486 2.68337C17.1744 2.59501 17.3202 2.38129 17.3202 2.13885V1.26484C17.3202 0.94231 17.0579 0.679993 16.7353 0.679993H13.8105C13.4663 0.679993 13.1862 0.960161 13.1862 1.30433V2.78599C13.1862 2.80834 13.1896 2.83053 13.1968 2.85186C13.2171 2.91265 15.1994 8.96966 13.0029 12.0176C12.1708 13.1721 10.8241 13.7575 9.00002 13.7575C7.17958 13.7575 5.8349 13.173 5.00308 12.0202C2.80616 8.97527 4.78312 2.91244 4.80329 2.8519C4.8104 2.83072 4.81403 2.80852 4.81403 2.78617V1.30451C4.81403 0.960358 4.53386 0.680175 4.1897 0.680175H1.26484C0.942311 0.680175 0.679993 0.942496 0.679993 1.26503V2.13903C0.679993 2.38148 0.825808 2.59519 1.05172 2.68355L1.05194 2.68363ZM1.09619 1.2651C1.09619 1.17196 1.17193 1.09622 1.26507 1.09622H4.18992C4.30484 1.09622 4.39827 1.18966 4.39827 1.30457V2.75299C4.22185 3.29606 2.40575 9.13042 4.66567 12.2634C5.58002 13.5311 7.03832 14.1738 9.00024 14.1738C10.9655 14.1738 12.4258 13.5304 13.3404 12.2611C15.5989 9.12748 13.7791 3.29632 13.6021 2.75329V1.30487C13.6021 1.18995 13.6956 1.09652 13.8105 1.09652H16.7353C16.8285 1.09652 16.9042 1.17225 16.9042 1.2654V2.13941C16.9042 2.20934 16.8621 2.27115 16.797 2.29669L15.8404 2.67086C15.7883 2.69118 15.7467 2.73166 15.7248 2.78316C15.7029 2.83467 15.7026 2.8927 15.7241 2.94435C16.4454 4.68297 16.741 7.0557 16.853 8.31521C16.9169 9.03225 16.8997 9.67601 16.8008 10.2829C16.175 14.1198 12.8941 16.9048 9.00004 16.9048C5.10598 16.9048 1.82515 14.1199 1.1993 10.2833C1.10034 9.67609 1.08337 9.03248 1.14707 8.31547C1.25907 7.05596 1.55463 4.68331 2.27602 2.94461C2.2975 2.89296 2.29721 2.83493 2.2753 2.78342C2.25339 2.73206 2.21175 2.69158 2.15966 2.67112L1.20323 2.29695C1.13809 2.27141 1.09587 2.2096 1.09587 2.13967L1.09619 1.2651Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "0.2"
  }
) }), _y = (e) => /* @__PURE__ */ W("svg", { height: "1em", viewBox: "4 4 16 16", width: "1em", ...e, children: /* @__PURE__ */ W(
  "path",
  {
    d: "M18.5 4a1.502 1.502 0 011.267 2.303l-8.1 12.768c-.37.582-1 .929-1.688.929H6c-1.103 0-2-.897-2-2s.897-2 2-2h2.944L17.29 4.614A1.502 1.502 0 0118.5 4zM7 17H6c-.55 0-1 .448-1 1s.45 1 1 1h1v-2zm4.142-2.309L9.75 16.592c-.188.256-.49.408-.806.408H8v2h1.978c.344 0 .66-.174.845-.465l1.785-2.815-1.466-1.029zm1.452-1.981l-.861 1.174 1.412.991.739-1.165-1.29-1zM8.5 11a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5h4zM8 12H5v1h3v-1zm10.5-7a.496.496 0 00-.403.205l-4.911 6.697 1.237.959 4.5-7.094A.5.5 0 0018.5 5z",
    fill: "currentColor"
  }
) }), Oy = (e) => /* @__PURE__ */ W("svg", { height: "1em", viewBox: "0 0 16 16", width: "1em", ...e, children: /* @__PURE__ */ W(
  "path",
  {
    d: "M8 0c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm1.768 11.5H6.235l-1.002 1.203.63 1.964a6.99 6.99 0 003.916.104l.974-2.105-.985-1.167zm3.374 1.245l-1.456.287-.572 1.237a7.036 7.036 0 002.028-1.524zm-8.5 1.396l-.343-1.07-1.19-.067c.456.445.971.828 1.533 1.137zm-1.914-7.3L1.033 8.683a6.962 6.962 0 001.193 3.27l2.228.121.98-1.177L4.27 7.594 2.728 6.84zm10.556 0l-1.54.754-1.177 3.301.967 1.146 2.498-.493a6.944 6.944 0 00.935-2.866L13.284 6.84zM8.008 5.424L5.268 7.42l1.086 3.08h3.293l1.1-3.08-2.74-1.996zM1.046 7.191l1.021-1.11-.282-1.3a6.937 6.937 0 00-.739 2.41zM14.224 4.8l-.278 1.284 1.007 1.098a6.944 6.944 0 00-.729-2.382zM10.57 1.49L8.508 2.6v1.95l2.885 2.104 1.572-.77.492-2.264a7.036 7.036 0 00-2.887-2.131zM2.555 3.606l.492 2.277 1.576.77L7.508 4.55V2.596L5.445 1.483a7.027 7.027 0 00-2.89 2.123zM8 1a6.99 6.99 0 00-1.165.097l1.175.635L9.184 1.1C8.799 1.034 8.404 1 8 1z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
) }), Cy = (e) => /* @__PURE__ */ W("svg", { height: "1em", viewBox: "0 0 20 20", width: "1em", ...e, children: /* @__PURE__ */ W(
  "path",
  {
    d: "M16.256 19.805a.556.556 0 00.115-.406l-.716-6.476 4.207-4.79a.563.563 0 00.113-.535.525.525 0 00-.39-.363L13.49 5.953 10.447.273C10.355.103 10.185 0 10 0s-.355.104-.447.272L6.51 5.953.415 7.235a.525.525 0 00-.39.363.558.558 0 00.113.534l4.207 4.791L3.63 19.4a.552.552 0 00.208.498c.15.114.347.135.515.054L10 17.231l5.648 2.72a.488.488 0 00.249.048c.14-.01.27-.08.36-.194z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
) }), Dy = /* @__PURE__ */ new Map([
  [2, Oy],
  // Football (soccer)
  [3, Py],
  // Horse Racing
  [10, Sy],
  // Boxing
  [18, My],
  // American Football
  [45, _y],
  // Ice Hockey
  [46, wy],
  // Baseball
  [47, Ey]
  // Basketball
]), Ty = (e) => Dy.get(e) ?? Cy, Ay = ({ categoryGroupId: e, ...t }) => {
  const r = Ty(e);
  return /* @__PURE__ */ W("span", { "aria-hidden": "true", className: ve.sportIcon, "data-testid": "most-popular-bets-sport-icon", children: /* @__PURE__ */ W(r, { ...t }) });
}, ky = (e, t) => {
  switch (e) {
    case "american":
      return t.bestOddsUs ?? "";
    case "fractional":
      return t.bestOddsFractional ?? "";
    case "decimal":
      return t.bestOddsDecimal != null ? Dp(t.bestOddsDecimal) : "";
    default:
      return "";
  }
}, xy = ({
  bet: e,
  oddsFormat: t,
  position: r,
  renderBadge: n,
  selectedSport: a,
  showSportIcon: o
}) => {
  const { bookmakersConfig: u, onOddsButtonClick: i } = lr(), { track: s } = ln(), l = e.bestOddsBookmakerCode ?? "", d = u == null ? void 0 : u[l], m = ky(t, e), v = {
    betId: e.id,
    betName: e.name,
    position: r,
    selectedSport: a,
    sport: e.categoryGroupName,
    subeventName: e.subeventName
  }, c = Op.find((P) => P.id === e.categoryGroupId), h = (c == null ? void 0 : c.translationFile) || "", { t: f } = on([h, "label", "bettype"]), p = Jp(e.subeventName, f), y = Gp(e.name, e.line, f), { isBookieBetSelected: M, toggleBetslipBet: b } = Ap({
    betId: e.id,
    betName: e.name,
    betOdds: m,
    bookieCode: l,
    marketName: e.marketName,
    subeventName: e.subeventName
  }), g = () => {
    if (s("most_popular_bets_odds_click", {
      ...v,
      bookmakerCode: l,
      marketName: e.marketName,
      oddsText: m
    }), i)
      return i("most_popular_bets_click", e.id, l, e.name, m);
    b();
  }, E = () => {
    s("most_popular_bets_selection_click", { ...v, subeventUrl: e.subeventUrl });
  };
  return /* @__PURE__ */ W("li", { className: ve.row, "data-testid": "most-popular-bets-row", children: /* @__PURE__ */ je("div", { className: Lt(ve.link, !o && ve.linkNoIcon), children: [
    o && /* @__PURE__ */ W(Ay, { categoryGroupId: e.categoryGroupId }),
    /* @__PURE__ */ je("a", { className: ve.betInfo, href: e.subeventUrl ?? "#", onClick: E, children: [
      /* @__PURE__ */ W("span", { className: ve.betName, children: y }),
      /* @__PURE__ */ W("span", { className: ve.subeventName, children: p })
    ] }),
    m && l ? /* @__PURE__ */ W(
      Yl,
      {
        bookieCode: l,
        bookmakerConfig: d,
        className: Lt(ve.oddsButton, M && ve.selected),
        isSelected: M,
        onClick: g,
        renderBadge: n,
        children: m
      }
    ) : /* @__PURE__ */ W("span", { className: ve.odds, children: m })
  ] }) }, e.id);
}, sa = () => {
  const { className: e, emptySlot: t, errorSlot: r, oddsFormat: n = "decimal", repub: a, showBookieLogos: o } = lr(), { t: u } = on("label"), i = u("CX_MOST_POPULAR_BETS", { defaultValue: "Most Popular Bets" }), s = o ?? (a != null && _p.includes(a)), {
    allSportsBets: l,
    bets: d,
    error: m,
    includeAll: v,
    isSingleTarget: c,
    selectedCategoryGroupId: h,
    setSelectedCategoryGroupId: f,
    sports: p
  } = Kp(), { analyticsDataLayer: y, analyticsImpressionEventData: M, impressionEventName: b } = ln(), g = h === nt, E = !c && g && v ? l : d, P = !c && p.length > 0, _ = Br(p, h), D = Ne(
    () => ({ ...M, betCount: E.length, selectedSport: _ }),
    [E.length, _, M]
  ), O = Xp(b, D, y);
  if (m)
    return r ?? null;
  const S = c || g && v === !0 || p.length <= 1 && !v;
  return E.length === 0 && S ? t ?? null : /* @__PURE__ */ je("div", { className: Lt(ve.container, e), "data-testid": "most-popular-bets-container", ref: O, children: [
    /* @__PURE__ */ je("div", { className: ve.header, children: [
      /* @__PURE__ */ W("h2", { className: ve.title, children: i }),
      !c && p.length > 0 && /* @__PURE__ */ W(
        by,
        {
          includeAll: v ?? !1,
          onSelect: f,
          selectedCategoryGroupId: h,
          sports: p
        }
      )
    ] }),
    E.length === 0 ? t ?? null : /* @__PURE__ */ W("ul", { className: ve.list, children: E.map((x, C) => /* @__PURE__ */ W(
      xy,
      {
        bet: x,
        oddsFormat: n,
        position: C + 1,
        renderBadge: s,
        selectedSport: _,
        showSportIcon: P
      },
      x.id
    )) })
  ] });
}, By = async (e, t) => {
  const r = oo(), { apiKey: n, countryCode: a, limit: o, repub: u, sports: i, subdivisionCode: s } = e, l = { apiKey: n, countryCode: a, repub: u, subdivisionCode: s }, d = po(e);
  if (d.kind !== "sports") {
    const f = d.kind === "subevent" ? { limit: o, subeventId: d.subeventId } : { eventIds: d.eventIds, limit: o };
    return await r.prefetchQuery({
      queryFn: () => Qt(t, f, l),
      queryKey: Ct(f)
    }), { dehydratedState: cn(r), sports: [] };
  }
  const m = i.map((f) => ({
    categoryGroupId: f.categoryGroupId,
    limit: o
  }));
  await Promise.allSettled(
    m.map(
      (f) => r.prefetchQuery({
        queryFn: () => Qt(t, f, l),
        queryKey: Ct(f)
      })
    )
  );
  const v = i.filter((f, p) => {
    const y = r.getQueryData(
      Ct(m[p])
    );
    return y != null && y.bets.length > 0;
  }), c = e.includeAll ? { categoryGroupIds: v.map((f) => f.categoryGroupId), includeAll: !0, limit: o } : null;
  return c && await r.prefetchQuery({
    queryFn: () => Qt(t, c, l),
    queryKey: Ct(c)
  }), {
    dehydratedState: cn(r),
    sports: v
  };
};
function Ry() {
  if (globalThis.window !== void 0)
    return globalThis.window.dataLayer;
}
const Iy = () => oo({
  defaultOptions: {
    queries: {
      gcTime: 1 / 0,
      refetchOnMount: !1,
      refetchOnReconnect: !1,
      refetchOnWindowFocus: !1,
      retry: 3,
      retryDelay: (e) => e * 100,
      staleTime: 1 / 0
    }
  }
});
function zy({
  dehydratedState: e,
  loadingElement: t,
  ...r
}) {
  const [n] = it.useState(Iy), { analyticsDataLayer: a = Ry() } = r;
  return /* @__PURE__ */ W(vl, { children: /* @__PURE__ */ W(jo, { client: n, children: /* @__PURE__ */ W(Lo, { state: e, children: /* @__PURE__ */ W(Ro, { fallback: t ?? null, children: /* @__PURE__ */ W(fd, { ...r, analyticsDataLayer: a, children: /* @__PURE__ */ W(Gl, { children: r.i18n ? /* @__PURE__ */ W(hl, { i18nInstance: r.i18n, children: /* @__PURE__ */ W(sa, {}) }) : /* @__PURE__ */ W(sa, {}) }) }) }) }) }) });
}
export {
  zy as default,
  By as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
